// COMMON
export const CrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g opacity="1">
        <path
          d="M19.281 18.2198C19.3507 18.2895 19.406 18.3722 19.4437 18.4632C19.4814 18.5543 19.5008 18.6519 19.5008 18.7504C19.5008 18.849 19.4814 18.9465 19.4437 19.0376C19.406 19.1286 19.3507 19.2114 19.281 19.281C19.2114 19.3507 19.1286 19.406 19.0376 19.4437C18.9465 19.4814 18.849 19.5008 18.7504 19.5008C18.6519 19.5008 18.5543 19.4814 18.4632 19.4437C18.3722 19.406 18.2895 19.3507 18.2198 19.281L12.0004 13.0607L5.78104 19.281C5.64031 19.4218 5.44944 19.5008 5.25042 19.5008C5.05139 19.5008 4.86052 19.4218 4.71979 19.281C4.57906 19.1403 4.5 18.9494 4.5 18.7504C4.5 18.5514 4.57906 18.3605 4.71979 18.2198L10.9401 12.0004L4.71979 5.78104C4.57906 5.64031 4.5 5.44944 4.5 5.25042C4.5 5.05139 4.57906 4.86052 4.71979 4.71979C4.86052 4.57906 5.05139 4.5 5.25042 4.5C5.44944 4.5 5.64031 4.57906 5.78104 4.71979L12.0004 10.9401L18.2198 4.71979C18.3605 4.57906 18.5514 4.5 18.7504 4.5C18.9494 4.5 19.1403 4.57906 19.281 4.71979C19.4218 4.86052 19.5008 5.05139 19.5008 5.25042C19.5008 5.44944 19.4218 5.64031 19.281 5.78104L13.0607 12.0004L19.281 18.2198Z"
          fill="white"
          stroke="white"
        />
      </g>
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      className=" 3xl:w-[22px]"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none">
      <path
        d="M16.5298 15.028L12.5418 11.0394C13.1845 10.1562 13.5302 9.09183 13.5292 7.99957C13.5292 5.14069 11.2032 2.8147 8.3443 2.8147C5.48542 2.8147 3.15942 5.14069 3.15942 7.99957C3.15942 10.8585 5.48542 13.1844 8.3443 13.1844C9.43656 13.1855 10.501 12.8398 11.3841 12.1971L15.3727 16.1851L16.5298 15.028ZM8.3443 11.5469C7.64261 11.547 6.95667 11.3389 6.37321 10.9491C5.78975 10.5594 5.33499 10.0053 5.06644 9.35703C4.79789 8.70876 4.7276 7.99542 4.86448 7.30722C5.00136 6.61901 5.33924 5.98685 5.83541 5.49069C6.33158 4.99452 6.96374 4.65663 7.65194 4.51975C8.34015 4.38288 9.05349 4.45316 9.70175 4.72171C10.35 4.99027 10.9041 5.44503 11.2939 6.02848C11.6837 6.61194 11.8917 7.29789 11.8916 7.99957C11.8905 8.94004 11.5164 9.84168 10.8514 10.5067C10.1864 11.1717 9.28477 11.5458 8.3443 11.5469Z"
        fill="black"
      />
    </svg>
  );
};
export const SearchGrayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M15.7372 14.4753L12.7159 11.463C13.6907 10.2211 14.2196 8.68756 14.2176 7.10882C14.2176 5.70283 13.8007 4.32841 13.0196 3.15937C12.2385 1.99033 11.1282 1.07918 9.82925 0.54113C8.53028 0.00308012 7.10094 -0.137698 5.72196 0.136597C4.34299 0.410893 3.07631 1.08794 2.08213 2.08213C1.08794 3.07631 0.410893 4.34299 0.136597 5.72196C-0.137698 7.10094 0.00308012 8.53028 0.54113 9.82925C1.07918 11.1282 1.99033 12.2385 3.15937 13.0196C4.32841 13.8007 5.70283 14.2176 7.10882 14.2176C8.68756 14.2196 10.2211 13.6907 11.463 12.7159L14.4753 15.7372C14.5579 15.8204 14.6562 15.8865 14.7645 15.9317C14.8728 15.9768 14.9889 16 15.1062 16C15.2236 16 15.3397 15.9768 15.448 15.9317C15.5563 15.8865 15.6545 15.8204 15.7372 15.7372C15.8204 15.6545 15.8865 15.5563 15.9317 15.448C15.9768 15.3397 16 15.2236 16 15.1062C16 14.9889 15.9768 14.8728 15.9317 14.7645C15.8865 14.6562 15.8204 14.5579 15.7372 14.4753ZM1.77721 7.10882C1.77721 6.05433 2.0899 5.02352 2.67575 4.14674C3.26159 3.26996 4.09428 2.58659 5.0685 2.18305C6.04273 1.77952 7.11474 1.67393 8.14897 1.87965C9.1832 2.08538 10.1332 2.59316 10.8788 3.3388C11.6245 4.08444 12.1323 5.03444 12.338 6.06868C12.5437 7.10291 12.4381 8.17492 12.0346 9.14914C11.6311 10.1234 10.9477 10.9561 10.0709 11.5419C9.19413 12.1277 8.16332 12.4404 7.10882 12.4404C5.69479 12.4404 4.33867 11.8787 3.3388 10.8788C2.33893 9.87897 1.77721 8.52285 1.77721 7.10882Z"
        fill="#929292"
      />
    </svg>
  );
};

export const WorkflowItemDeleteIcon = () => {
  return (
    <svg
      className=" w-[18px] h-[18px] delete_hover duration-200 "
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      viewBox="0 0 13 12"
      fill="none">
      <g clipPath="url(#clip0_1447_3592)">
        <path
          d="M3.15527 9.5C3.15527 10.05 3.60527 10.5 4.15527 10.5H8.15527C8.70527 10.5 9.15527 10.05 9.15527 9.5V4.5C9.15527 3.95 8.70527 3.5 8.15527 3.5H4.15527C3.60527 3.5 3.15527 3.95 3.15527 4.5V9.5ZM9.15527 2H7.90527L7.55027 1.645C7.46027 1.555 7.33027 1.5 7.20027 1.5H5.11027C4.98027 1.5 4.85027 1.555 4.76027 1.645L4.40527 2H3.15527C2.88027 2 2.65527 2.225 2.65527 2.5C2.65527 2.775 2.88027 3 3.15527 3H9.15527C9.43027 3 9.65527 2.775 9.65527 2.5C9.65527 2.225 9.43027 2 9.15527 2Z"
          fill="#929292"
        />
      </g>
      <defs>
        <clipPath id="clip0_1447_3592">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.155273)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// HEADER
export const ToggleIcon = () => {
  return (
    <svg
      width="25"
      height="15"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 11H19M1 6H19M1 1H19"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ToggleIcon2 = () => {
  return (
    <svg
      stroke="black"
      fill="black"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="1.5em"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M21 17.9995V19.9995H3V17.9995H21ZM17.4038 3.90332L22 8.49951L17.4038 13.0957L15.9896 11.6815L19.1716 8.49951L15.9896 5.31753L17.4038 3.90332ZM12 10.9995V12.9995H3V10.9995H12ZM12 3.99951V5.99951H3V3.99951H12Z"></path>
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      className=" 3xl:w-[40px] 3xl:h-[40px]"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.344727"
        y="0.5"
        width="34"
        height="34"
        rx="17"
        fill="#6F6AF8"
        fillOpacity="0.12"
      />
      <path
        d="M17.281 25.6592C16.8905 25.6592 16.5159 25.504 16.2397 25.2278C15.9635 24.9516 15.8083 24.577 15.8083 24.1864H18.7538C18.7538 24.577 18.5986 24.9516 18.3224 25.2278C18.0462 25.504 17.6716 25.6592 17.281 25.6592ZM23.172 23.4501H11.3901V21.9773L12.8629 21.241V17.191C12.8241 16.1521 13.0587 15.1211 13.5433 14.2013C13.7817 13.7796 14.1069 13.4132 14.4973 13.1264C14.8878 12.8395 15.3346 12.6387 15.8083 12.5372V10.9319H18.4931C18.0266 11.4532 17.7371 12.1089 17.666 12.8048C17.5949 13.5008 17.746 14.2014 18.0974 14.8063C18.4489 15.4112 18.9828 15.8893 19.6227 16.1722C20.2626 16.455 20.9755 16.5281 21.6595 16.381C21.6852 16.6439 21.6978 16.9163 21.6978 17.191V21.241L23.1705 21.9773V23.4501H23.172Z"
        fill="black"
      />
      <circle cx="20.9015" cy="13.0796" r="2.14773" fill="#DF0000" />
    </svg>
  );
};

// SIDEBAR-ICONS
export const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
        fill="white"
      />
    </svg>
  );
};

export const TeamsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3132)">
        <path
          d="M12 12.75C13.63 12.75 15.07 13.14 16.24 13.65C17.32 14.13 18 15.21 18 16.38V17C18 17.55 17.55 18 17 18H7C6.45 18 6 17.55 6 17V16.39C6 15.21 6.68 14.13 7.76 13.66C8.93 13.14 10.37 12.75 12 12.75ZM4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V17C0 17.55 0.45 18 1 18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H23C23.55 18 24 17.55 24 17V16.43ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3132">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ContactIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3150)">
        <path
          d="M19 3H18V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V3H8V2C8 1.45 7.55 1 7 1C6.45 1 6 1.45 6 2V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6ZM18 18H6V17C6 15 10 13.9 12 13.9C14 13.9 18 15 18 17V18Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3150">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ContactBlueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none">
      <g clipPath="url(#clip0_456_34418)">
        <path
          className="group-hover:fill-white"
          d="M7.17525 6.66659H5.75859V5.33325C5.75859 4.96659 5.43984 4.66659 5.05025 4.66659C4.66067 4.66659 4.34192 4.96659 4.34192 5.33325V6.66659H2.92525C2.53567 6.66659 2.21692 6.96659 2.21692 7.33325C2.21692 7.69992 2.53567 7.99992 2.92525 7.99992H4.34192V9.33325C4.34192 9.69992 4.66067 9.99992 5.05025 9.99992C5.43984 9.99992 5.75859 9.69992 5.75859 9.33325V7.99992H7.17525C7.56484 7.99992 7.88359 7.69992 7.88359 7.33325C7.88359 6.96659 7.56484 6.66659 7.17525 6.66659ZM11.4253 7.33325C12.6011 7.33325 13.5432 6.43992 13.5432 5.33325C13.5432 4.22659 12.6011 3.33325 11.4253 3.33325C10.2494 3.33325 9.30025 4.22659 9.30025 5.33325C9.30025 6.43992 10.2494 7.33325 11.4253 7.33325ZM11.4253 8.66659C10.0086 8.66659 7.17525 9.33325 7.17525 10.6666V11.3333C7.17525 11.6999 7.494 11.9999 7.88359 11.9999H14.9669C15.3565 11.9999 15.6753 11.6999 15.6753 11.3333V10.6666C15.6753 9.33325 12.8419 8.66659 11.4253 8.66659Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_456_34418">
          <rect
            width="17"
            height="16"
            fill="white"
            transform="translate(0.800293)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ScheduledIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3163)">
        <path
          d="M18.625 4.83341H17.75V3.87508C17.75 3.348 17.3562 2.91675 16.875 2.91675C16.3938 2.91675 16 3.348 16 3.87508V4.83341H9V3.87508C9 3.348 8.60625 2.91675 8.125 2.91675C7.64375 2.91675 7.25 3.348 7.25 3.87508V4.83341H6.375C5.40375 4.83341 4.63375 5.69591 4.63375 6.75008L4.625 20.1667C4.625 21.2209 5.40375 22.0834 6.375 22.0834H18.625C19.5875 22.0834 20.375 21.2209 20.375 20.1667V6.75008C20.375 5.69591 19.5875 4.83341 18.625 4.83341ZM18.625 19.2084C18.625 19.7355 18.2312 20.1667 17.75 20.1667H7.25C6.76875 20.1667 6.375 19.7355 6.375 19.2084V9.62508H18.625V19.2084ZM8.125 11.5417H9.875V13.4584H8.125V11.5417ZM11.625 11.5417H13.375V13.4584H11.625V11.5417ZM15.125 11.5417H16.875V13.4584H15.125V11.5417Z"
          fill="#FBFBFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3163">
          <rect
            width="21"
            height="23"
            fill="white"
            transform="translate(2 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlogIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3176)">
        <path
          d="M19 3H4.99C3.89 3 3 3.9 3 5L3.01 19C3.01 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM8 8H16C16.55 8 17 8.45 17 9C17 9.55 16.55 10 16 10H8C7.45 10 7 9.55 7 9C7 8.45 7.45 8 8 8ZM11 14H8C7.45 14 7 13.55 7 13C7 12.45 7.45 12 8 12H11C11.55 12 12 12.45 12 13C12 13.55 11.55 14 11 14ZM14 19.5V15C14 14.45 14.45 14 15 14H19.5L14 19.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3176">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChatavirsityIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.4899 10.1901L20.4899 9.64008L11.4899 4.64008H11.3799C11.3186 4.61416 11.255 4.59407 11.1899 4.58008H10.9999H10.8199C10.7516 4.59408 10.6846 4.61416 10.6199 4.64008H10.5099L1.50988 9.64008C1.35598 9.7273 1.22797 9.85378 1.13891 10.0066C1.04985 10.1595 1.00293 10.3332 1.00293 10.5101C1.00293 10.687 1.04985 10.8607 1.13891 11.0135C1.22797 11.1664 1.35598 11.2929 1.50988 11.3801L3.99988 12.7601V17.5001C3.99988 18.2957 4.31595 19.0588 4.87856 19.6214C5.44117 20.184 6.20423 20.5001 6.99988 20.5001H14.9999C15.7955 20.5001 16.5586 20.184 17.1212 19.6214C17.6838 19.0588 17.9999 18.2957 17.9999 17.5001V12.7601L19.9999 11.6401V14.5001C19.9999 14.7653 20.1052 15.0196 20.2928 15.2072C20.4803 15.3947 20.7347 15.5001 20.9999 15.5001C21.2651 15.5001 21.5194 15.3947 21.707 15.2072C21.8945 15.0196 21.9999 14.7653 21.9999 14.5001V11.0601C21.9996 10.8829 21.9522 10.7089 21.8626 10.5561C21.773 10.4032 21.6443 10.2769 21.4899 10.1901ZM15.9999 17.5001C15.9999 17.7653 15.8945 18.0196 15.707 18.2072C15.5194 18.3947 15.2651 18.5001 14.9999 18.5001H6.99988C6.73466 18.5001 6.48031 18.3947 6.29277 18.2072C6.10524 18.0196 5.99988 17.7653 5.99988 17.5001V13.8701L10.5099 16.3701L10.6599 16.4301H10.7499C10.8329 16.4405 10.9169 16.4405 10.9999 16.4301C11.0829 16.4405 11.1669 16.4405 11.2499 16.4301H11.3399C11.393 16.4189 11.4437 16.3986 11.4899 16.3701L15.9999 13.8701V17.5001Z"
        fill="white"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7947 12.0014C19.7947 12.2443 19.8831 12.4789 20.0435 12.6614L21.3935 14.1014C21.5345 14.2587 21.6221 14.4567 21.6436 14.6669C21.6652 14.877 21.6196 15.0887 21.5135 15.2714L19.5135 18.7314C19.4084 18.9138 19.2483 19.0585 19.0562 19.1447C18.8641 19.2309 18.6496 19.2542 18.4435 19.2114L16.5635 18.8314C16.3242 18.7819 16.0752 18.8218 15.8633 18.9434C15.6515 19.0649 15.4915 19.2599 15.4135 19.4914L14.8035 21.3214C14.7364 21.52 14.6086 21.6925 14.4381 21.8145C14.2676 21.9365 14.0631 22.0019 13.8535 22.0014H9.85345C9.63538 22.0127 9.41959 21.9524 9.23902 21.8296C9.05845 21.7069 8.92303 21.5283 8.85345 21.3214L8.24345 19.4914C8.16545 19.2599 8.00542 19.0649 7.79356 18.9434C7.5817 18.8218 7.33267 18.7819 7.09345 18.8314L5.21345 19.2114C5.00728 19.2542 4.79284 19.2309 4.6007 19.1447C4.40857 19.0585 4.24855 18.9138 4.14345 18.7314L2.14345 15.2714C2.03461 15.0907 1.98567 14.8803 2.00363 14.6701C2.02159 14.46 2.10553 14.2609 2.24345 14.1014L3.51345 12.6614C3.67377 12.4789 3.76219 12.2443 3.76219 12.0014C3.76219 11.7585 3.67377 11.5238 3.51345 11.3414L2.24345 9.90136C2.10553 9.7418 2.02159 9.54272 2.00363 9.33258C1.98567 9.12245 2.03461 8.91201 2.14345 8.73136L4.14345 5.27136C4.24415 5.10159 4.39285 4.96542 4.5708 4.88C4.74875 4.79458 4.948 4.76374 5.14345 4.79136L7.07345 5.17136C7.31267 5.22079 7.5617 5.18095 7.77356 5.05936C7.98542 4.93777 8.14545 4.74284 8.22345 4.51136L8.78345 2.68136C8.85303 2.47438 8.98845 2.29586 9.16902 2.17307C9.34959 2.05029 9.56538 1.98998 9.78345 2.00136H13.7835C13.9931 2.00082 14.1976 2.06618 14.3681 2.1882C14.5386 2.31022 14.6664 2.48274 14.7335 2.68136L15.3435 4.51136C15.4214 4.74284 15.5815 4.93777 15.7933 5.05936C16.0052 5.18095 16.2542 5.22079 16.4935 5.17136L18.3735 4.79136C18.5796 4.74852 18.7941 4.77186 18.9862 4.85805C19.1783 4.94424 19.3384 5.08888 19.4435 5.27136L21.4435 8.73136C21.5496 8.91405 21.5952 9.12567 21.5736 9.33587C21.5521 9.54606 21.4645 9.74403 21.3235 9.90136L20.0435 11.3414C19.8831 11.5238 19.7947 11.7585 19.7947 12.0014ZM12.1434 17.0014C14.9049 17.0014 17.1434 14.7628 17.1434 12.0014C17.1434 9.23995 14.9049 7.00137 12.1434 7.00137C9.38201 7.00137 7.14343 9.23995 7.14343 12.0014C7.14343 14.7628 9.38201 17.0014 12.1434 17.0014Z"
        fill="white"
      />
    </svg>
  );
};

export const FaqIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3215)">
        <path
          d="M11.5 3C6.81 3 3 6.81 3 11.5C3 16.19 6.81 20 11.5 20H12V23C16.86 20.66 20 16 20 11.5C20 6.81 16.19 3 11.5 3ZM12.5 17.5H10.5V15.5H12.5V17.5ZM12.9 12.72C12.89 12.73 12.88 12.75 12.87 12.77C12.82 12.85 12.77 12.93 12.73 13.01C12.71 13.04 12.7 13.08 12.69 13.12C12.66 13.19 12.63 13.26 12.61 13.33C12.54 13.54 12.51 13.76 12.51 14.01H10.5C10.5 13.5 10.58 13.07 10.7 12.71C10.7 12.7 10.7 12.69 10.71 12.68C10.72 12.64 10.75 12.62 10.76 12.58C10.82 12.42 10.89 12.28 10.98 12.14C11.01 12.09 11.05 12.04 11.08 11.99C11.11 11.95 11.13 11.9 11.16 11.87L11.17 11.88C12.01 10.78 13.38 10.44 13.49 9.2C13.58 8.22 12.88 7.27 11.92 7.07C10.88 6.85 9.94 7.46 9.62 8.35C9.48 8.71 9.15 9 8.74 9H8.54C7.94 9 7.5 8.41 7.67 7.83C8.22 6.01 10.04 4.74 12.1 5.04C13.79 5.29 15.14 6.68 15.43 8.37C15.87 10.81 13.8 11.4 12.9 12.72Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3215">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LoggedConnectionsIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1312_3228)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 10.4733V14.5267C5 16.4383 5 17.3933 5.60167 17.9875C6.1475 18.5267 6.99667 18.5758 8.59833 18.5808C8.59396 18.5517 8.5898 18.5225 8.58583 18.4933C8.49 17.79 8.49 16.8967 8.49 15.7875V15.7433C8.49 15.4075 8.76583 15.135 9.10667 15.135C9.44667 15.135 9.7225 15.4075 9.7225 15.7433C9.7225 16.9067 9.72333 17.7183 9.80667 18.3308C9.88833 18.9258 10.0358 19.2417 10.2633 19.4658C10.4908 19.6908 10.81 19.8367 11.4125 19.9158C12.0325 19.9992 12.855 20 14.0342 20H14.855C16.0342 20 16.8558 19.9983 17.4767 19.9167C18.0792 19.8367 18.3983 19.69 18.625 19.4658C18.8525 19.2408 19.0008 18.9258 19.0817 18.3308C19.165 17.7192 19.1667 16.9067 19.1667 15.7433V9.25667C19.1667 8.0925 19.165 7.28167 19.0817 6.66833C19.0008 6.07417 18.8525 5.75833 18.6258 5.535C18.3983 5.31 18.0792 5.16333 17.4758 5.08333C16.8558 5.00167 16.0342 5 14.855 5H14.0342C12.855 5 12.0325 5.00167 11.4125 5.08333C10.81 5.16333 10.4908 5.31 10.2633 5.53417C10.0358 5.75917 9.88833 6.07417 9.80667 6.66917C9.72333 7.28083 9.7225 8.0925 9.7225 9.25667C9.7225 9.5925 9.44667 9.865 9.10583 9.865C9.02544 9.86555 8.94572 9.85024 8.87125 9.81996C8.79677 9.78967 8.729 9.745 8.6718 9.6885C8.61461 9.632 8.56911 9.56478 8.53791 9.49068C8.50672 9.41658 8.49044 9.33706 8.49 9.25667V9.2125C8.49 8.10417 8.49 7.21 8.58583 6.50667L8.59833 6.41917C6.99667 6.42417 6.14833 6.47333 5.60167 7.0125C5 7.60667 5 8.5625 5 10.4733ZM13.2375 14.9567L15.2908 12.93C15.348 12.8739 15.3934 12.807 15.4244 12.7332C15.4553 12.6593 15.4713 12.5801 15.4713 12.5C15.4713 12.4199 15.4553 12.3407 15.4244 12.2668C15.3934 12.193 15.348 12.1261 15.2908 12.07L13.2375 10.0433C13.1213 9.92928 12.9649 9.86538 12.8021 9.86538C12.6392 9.86538 12.4829 9.92928 12.3667 10.0433C12.3095 10.0994 12.2641 10.1663 12.2331 10.2402C12.2022 10.314 12.1862 10.3933 12.1862 10.4733C12.1862 10.5534 12.2022 10.6327 12.2331 10.7065C12.2641 10.7803 12.3095 10.8472 12.3667 10.9033L13.3683 11.8917H7.46417C7.3837 11.891 7.3039 11.9062 7.22933 11.9365C7.15475 11.9667 7.08688 12.0114 7.0296 12.0679C6.97231 12.1244 6.92674 12.1916 6.89549 12.2658C6.86424 12.3399 6.84794 12.4195 6.8475 12.5C6.8475 12.8358 7.12333 13.1083 7.46417 13.1083H13.3683L12.3667 14.0967C12.3095 14.1528 12.2641 14.2197 12.2331 14.2935C12.2022 14.3673 12.1862 14.4466 12.1862 14.5267C12.1862 14.6067 12.2022 14.686 12.2331 14.7598C12.2641 14.8337 12.3095 14.9006 12.3667 14.9567C12.4829 15.0707 12.6392 15.1346 12.8021 15.1346C12.9649 15.1346 13.1213 15.0707 13.2375 14.9567Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3228">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SidebarImg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="125"
      height="116"
      viewBox="0 0 125 116"
      fill="none">
      <g clipPath="url(#clip0_1312_3259)">
        <path
          d="M112.277 116H2.57344C1.1566 116 0 114.874 0 113.431C0 112.017 1.1566 110.862 2.57344 110.862H112.277C113.694 110.862 114.851 112.017 114.851 113.431C114.851 114.874 113.694 116 112.277 116Z"
          fill="#E6EDFF"
        />
        <path
          d="M113.231 65.6342C113.174 65.6054 113.145 65.5765 113.087 65.5476C109.762 63.6138 105.829 62.8634 102.041 61.9398C98.5426 61.0739 94.5812 59.9194 91.8921 57.3506C88.6247 54.2334 89.0585 49.9617 90.3307 46.0652C91.6608 41.9955 92.9042 37.8681 92.3259 33.5387C91.6608 28.6031 89.4344 23.8407 85.8778 20.1174C80.3839 14.3737 71.8829 11.3142 63.7288 12.1801C52.7989 13.3346 43.8063 20.8679 36.9824 29.0072C32.5005 34.3468 29.8692 40.4369 24.7513 45.5168C19.6911 50.5389 14.0238 55.0704 9.80216 60.7564C4.1348 68.3185 1.38786 77.9875 3.23843 87.1082C5.06008 96.2 11.7684 104.513 20.9634 107.803C26.8042 109.91 33.2234 109.939 39.4691 109.968C52.4519 109.996 65.4637 110.025 78.4177 109.044C86.9477 108.409 95.5644 107.283 103.343 103.906C111.092 100.529 117.974 94.6126 120.518 86.9062C123.034 79.2575 120.402 69.9059 113.231 65.6342Z"
          fill="#BFD2FF"
        />
        <path
          d="M8.87688 47.595C8.67447 46.8734 8.29858 46.2385 7.74919 45.6901C7.46004 45.4592 7.17089 45.2283 6.88174 45.0262C6.21669 44.6221 5.4649 44.449 4.68419 44.449H4.48178C3.87457 44.4201 3.32518 44.5644 2.80471 44.8242C2.25532 44.9974 1.79268 45.286 1.41678 45.7189C0.983056 46.123 0.693905 46.5848 0.520414 47.1043C0.260178 47.6239 0.115603 48.1723 0.144518 48.7784C0.202348 49.1536 0.260178 49.5577 0.289093 49.9329C0.491499 50.6545 0.867395 51.2895 1.41678 51.8379C1.70593 52.0688 1.99508 52.2997 2.28424 52.5017C2.94928 52.9058 3.70108 53.079 4.48178 53.079H4.68419C5.29141 53.1078 5.84079 52.9635 6.36127 52.7037C6.91065 52.5306 7.37329 52.2419 7.74919 51.809C8.18292 51.4049 8.47207 50.9431 8.64556 50.4236C8.90579 49.904 9.05037 49.3556 9.02145 48.7495C8.96362 48.3454 8.9058 47.9702 8.87688 47.595Z"
          fill="#E6EDFF"
        />
        <path
          d="M115.631 52.5594C120.806 52.5594 125 48.3725 125 43.2078C125 38.043 120.806 33.8562 115.631 33.8562C110.457 33.8562 106.263 38.043 106.263 43.2078C106.263 48.3725 110.457 52.5594 115.631 52.5594Z"
          fill="#BFD2FF"
        />
        <path
          d="M80.5576 0.0577258C80.1528 0.144314 79.7769 0.259766 79.401 0.404081C79.4299 0.432943 79.4588 0.461806 79.4588 0.490669C79.7769 0.981339 79.6034 1.61632 79.1408 1.93381C78.6492 2.25131 78.0131 2.07813 77.695 1.61632C77.6661 1.58746 77.6661 1.5586 77.6372 1.50087C77.3191 1.76064 77.0589 2.07813 76.7986 2.39562C76.8275 2.39562 76.8854 2.42448 76.9143 2.45335C77.4348 2.71311 77.6083 3.3481 77.348 3.86763C77.0878 4.38716 76.4516 4.56034 75.9312 4.30057C75.9023 4.27171 75.8444 4.24285 75.8155 4.21398C75.6709 4.5892 75.5842 4.99328 75.5264 5.39736C75.5553 5.39736 75.6131 5.3685 75.642 5.3685C76.2203 5.33964 76.7119 5.80144 76.7119 6.3787C76.7408 6.95596 76.2782 7.44663 75.6999 7.44663C75.642 7.44663 75.6131 7.44663 75.5553 7.44663C75.642 7.85071 75.7577 8.25479 75.9023 8.63001C75.9312 8.60114 75.989 8.57228 76.0179 8.54342C76.5095 8.22593 77.1456 8.3991 77.4637 8.86091C77.7817 9.35158 77.6082 9.98656 77.1456 10.3041C77.0878 10.3329 77.0589 10.3618 77.001 10.3618C77.2613 10.6793 77.5793 10.9679 77.8974 11.2277C77.9263 11.1699 77.9263 11.1411 77.9552 11.0834C78.2155 10.5638 78.8516 10.3906 79.3721 10.6504C79.8925 10.9102 80.066 11.5452 79.8058 12.0647C79.7769 12.1224 79.748 12.1513 79.7191 12.209C80.1239 12.3533 80.5287 12.4399 80.9335 12.4976C80.9335 12.4399 80.9046 12.3822 80.9046 12.3245C80.8757 11.7472 81.3383 11.2565 81.9166 11.2565C82.4949 11.2277 82.9865 11.6895 82.9865 12.2667C82.9865 12.3245 82.9865 12.3822 82.9865 12.4399C83.3913 12.3533 83.7961 12.2379 84.2009 12.0647C84.172 12.0358 84.1431 11.9781 84.1141 11.9492C83.7961 11.4586 83.9696 10.8236 84.4322 10.5061C84.9238 10.1886 85.5599 10.3618 85.878 10.8236C85.9069 10.8813 85.9358 10.9102 85.9647 10.9679C86.2828 10.6793 86.5719 10.3906 86.8322 10.0443C86.7743 10.0154 86.7454 10.0154 86.6876 9.98656C86.1671 9.7268 85.9936 9.09181 86.2539 8.57228C86.5141 8.05275 87.1502 7.87957 87.6707 8.13934C87.7285 8.1682 87.7575 8.19706 87.7864 8.22593C87.9309 7.85071 88.0177 7.44663 88.0755 7.01368C88.0177 7.01368 87.9888 7.04255 87.9309 7.04255C87.3526 7.07141 86.8611 6.6096 86.8611 6.03235C86.8322 5.45509 87.2948 4.96442 87.8731 4.96442C87.9309 4.96442 87.9599 4.96442 88.0177 4.96442C87.9309 4.56034 87.8153 4.15626 87.6707 3.78104C87.6418 3.8099 87.6129 3.83877 87.584 3.86763C87.0924 4.18512 86.4563 4.01194 86.1382 3.55014C85.8201 3.05947 85.9936 2.42448 86.4563 2.10699C86.4852 2.07813 86.543 2.07813 86.5719 2.04927C86.3117 1.73177 85.9936 1.47201 85.6756 1.21224C85.6756 1.2411 85.6467 1.26997 85.6467 1.32769C85.3864 1.84723 84.7503 2.0204 84.2298 1.76064C83.7093 1.50087 83.5358 0.865887 83.7961 0.346355C83.825 0.317492 83.825 0.288629 83.8539 0.259766C83.478 0.144314 83.0732 0.0288629 82.6684 0C82.6684 0.0288629 82.6684 0.0577258 82.6684 0.115452C82.6973 0.69271 82.2347 1.18338 81.6564 1.18338C81.0781 1.21224 80.5865 0.750435 80.5865 0.173177C80.5576 0.144314 80.5576 0.115452 80.5576 0.0577258ZM81.6564 2.62652C83.6515 2.5688 85.3286 4.12739 85.3864 6.11894C85.4442 8.11047 83.8828 9.78452 81.8877 9.84225C79.8925 9.89997 78.2155 8.34138 78.1576 6.34984C78.0998 4.3583 79.6612 2.71311 81.6564 2.62652Z"
          fill="#E6EDFF"
        />
        <path
          d="M13.7636 37.2621C20.2312 37.2621 25.4742 32.455 25.4742 26.5251C25.4742 20.5952 20.2312 15.7881 13.7636 15.7881C7.296 15.7881 2.05298 20.5952 2.05298 26.5251C2.05298 32.455 7.296 37.2621 13.7636 37.2621Z"
          fill="#E6EDFF"
        />
        <path
          d="M13.5035 26.6693L4.36628 23.7542C4.0193 24.6778 3.81689 25.688 3.81689 26.6693C3.81689 31.5183 8.18308 35.5302 13.4745 35.5302C15.2384 35.5302 16.9444 35.0973 18.4479 34.2602L13.5035 26.6693Z"
          fill="#628AEC"
        />
        <path
          d="M13.9949 26.5251L19.0261 34.0872C20.4429 33.3079 21.5995 32.1823 22.4092 30.8546C23.2188 29.5269 23.6525 28.026 23.6525 26.5251H13.9949Z"
          fill="#BFD2FF"
        />
        <path
          d="M14.0527 26.0921L23.7104 25.9767C23.6815 24.7644 23.3923 23.581 22.8718 22.4842C22.3225 21.3875 21.5707 20.4061 20.5875 19.5691L14.0527 26.0921Z"
          fill="#FEFEFF"
        />
        <path
          d="M90.1861 11.8338C89.4054 11.9781 88.6247 12.209 87.9018 12.5265C87.9597 12.5842 87.9886 12.6419 88.0464 12.6997C88.6536 13.6521 88.3645 14.9221 87.4103 15.4994C86.4561 16.1055 85.1838 15.8168 84.6055 14.8644C84.5766 14.8066 84.5477 14.7201 84.4898 14.6623C83.8826 15.1819 83.3332 15.7591 82.8417 16.3941C82.8995 16.423 82.9863 16.4518 83.0441 16.4807C84.0272 17.0002 84.432 18.2413 83.8826 19.2515C83.3622 20.2329 82.1188 20.637 81.1068 20.0886C81.02 20.0597 80.9622 20.002 80.9044 19.9442C80.6441 20.6947 80.4417 21.474 80.355 22.2821C80.4417 22.2821 80.5285 22.2533 80.6152 22.2533C81.7429 22.2244 82.6971 23.0903 82.726 24.216C82.7549 25.3416 81.8875 26.2941 80.7598 26.3229C80.673 26.3229 80.5574 26.3229 80.4706 26.2941C80.6152 27.1022 80.8755 27.8815 81.1646 28.632C81.2514 28.5742 81.3092 28.5165 81.3959 28.4588C82.3501 27.8527 83.6224 28.1413 84.2007 29.0938C84.8079 30.0463 84.5188 31.3162 83.5646 31.8935C83.4778 31.9512 83.3911 31.9801 83.2754 32.0378C83.8248 32.6439 84.4031 33.2212 85.0681 33.7118C85.0971 33.6253 85.126 33.5098 85.1838 33.4232C85.7043 32.4419 86.9476 32.0378 87.9597 32.5862C88.9428 33.1057 89.3476 34.3468 88.7982 35.357C88.7404 35.4436 88.6825 35.5591 88.6247 35.6457C89.4054 35.9054 90.1861 36.1075 91.0247 36.2229C90.9957 36.1075 90.9957 36.0209 90.9668 35.9054C90.9379 34.7798 91.8054 33.8273 92.9331 33.7984C94.0607 33.7696 95.0149 34.6355 95.0439 35.7611C95.0439 35.8766 95.0439 35.992 95.0149 36.1075C95.8246 35.9343 96.6342 35.7034 97.386 35.3859C97.3281 35.2993 97.2414 35.2127 97.1836 35.1261C96.5764 34.1737 96.8655 32.9037 97.8197 32.3264C98.7739 31.7203 100.046 32.0089 100.624 32.9614C100.682 33.048 100.74 33.1635 100.769 33.25C101.376 32.7016 101.955 32.0955 102.446 31.4605C102.359 31.4317 102.244 31.4028 102.157 31.3451C101.174 30.8256 100.769 29.5845 101.318 28.5743C101.839 27.5929 103.082 27.1888 104.094 27.7372C104.181 27.795 104.268 27.8527 104.355 27.9104C104.615 27.16 104.788 26.3518 104.904 25.5436C104.817 25.5725 104.73 25.5725 104.644 25.5725C103.516 25.6014 102.562 24.7355 102.533 23.6098C102.504 22.4842 103.371 21.5317 104.499 21.5028C104.586 21.5028 104.673 21.5028 104.759 21.5317C104.586 20.7235 104.355 19.9442 104.036 19.2227C103.979 19.2804 103.921 19.3381 103.834 19.367C102.88 19.9731 101.608 19.6845 101.029 18.732C100.422 17.7795 100.711 16.5096 101.665 15.9323C101.723 15.8746 101.81 15.8457 101.897 15.8168C101.376 15.2107 100.769 14.6623 100.133 14.1717C100.104 14.2294 100.075 14.316 100.046 14.3737C99.5257 15.355 98.2823 15.7591 97.2703 15.2107C96.2872 14.6912 95.8824 13.4501 96.4318 12.4399C96.4607 12.3822 96.5185 12.3244 96.5474 12.2378C95.7956 11.9781 95.0149 11.8049 94.2053 11.6895C94.2053 11.7472 94.2342 11.8338 94.2342 11.8915C94.2631 13.0171 93.3957 13.9696 92.268 13.9985C91.1403 14.0273 90.1861 13.1615 90.1572 12.0358C90.1861 11.9781 90.1861 11.8915 90.1861 11.8338ZM92.2969 15.6437C96.8944 15.4705 100.769 19.0784 100.914 23.6676C101.087 28.2568 97.4727 32.1244 92.8752 32.2687C88.2777 32.4419 84.4031 28.834 84.2585 24.2448C84.1139 19.6556 87.6994 15.8168 92.2969 15.6437Z"
          fill="#BFD2FF"
        />
        <path
          d="M78.1864 22.3399C77.9262 22.1667 77.6371 21.9935 77.5214 21.7049C77.3768 21.2431 77.8684 20.7236 77.7527 20.2618C77.637 19.8577 77.1744 19.6845 76.7407 19.6268C76.3359 19.5691 75.8443 19.5113 75.613 19.165C75.4106 18.8763 75.4684 18.5011 75.4106 18.1548C75.3238 17.4621 74.7744 16.8271 74.1094 16.6539C73.3865 16.4519 72.7504 17.1157 72.1432 17.3755C71.4781 17.6641 71.0733 18.2125 70.9287 18.9341C70.7842 19.6268 70.8998 20.3195 71.0444 20.9833C71.189 21.6472 71.3914 22.3399 71.4492 23.0326C71.507 23.8119 71.3336 24.4757 71.1311 25.1973C70.9866 25.688 70.9577 26.3807 71.2179 26.8425C71.4781 27.3043 71.9986 27.5064 72.5191 27.6507C73.5022 27.9393 74.5142 28.0836 75.4973 27.9393C76.4515 27.795 77.3479 27.362 77.984 26.6405C78.4178 26.2652 78.7647 25.8323 78.9671 25.2839C79.3141 24.216 79.0539 22.946 78.1864 22.3399Z"
          fill="#485070"
        />
        <path
          d="M73.1552 18.8186C73.2708 19.2516 73.213 19.7134 73.0106 20.0886C72.9528 20.204 72.8371 20.3483 72.6925 20.3195C72.5191 20.3195 72.4323 20.1174 72.3745 19.9731C72.2299 19.5402 72.1432 19.1072 72.1142 18.6454C72.0853 18.3568 72.1432 17.8661 72.548 17.9527C72.8371 18.0393 73.0974 18.5588 73.1552 18.8186Z"
          fill="#FF6EA1"
        />
        <path
          d="M73.1553 25.6302C72.8661 26.6404 71.218 27.1311 70.2638 25.9765C70.1481 25.8322 70.0325 25.6879 69.9457 25.5436C68.9337 25.7456 67.4012 26.1786 66.7072 27.0156C66.4759 27.2754 66.3892 27.6217 66.2735 27.9681C65.9265 29.1803 65.6085 30.4214 65.3771 31.6625C65.3482 31.8068 65.3193 31.9512 65.3771 32.0955C65.435 32.2687 65.5795 32.3841 65.7241 32.4707C67.141 33.5963 67.5169 35.3858 67.9795 37.0022C68.6735 39.4844 69.0204 42.8902 69.7144 45.3435C72.0276 45.5167 81.6853 43.3231 82.8419 42.3129C81.1648 39.3112 79.8347 33.9138 79.3142 30.1617C79.0829 28.5742 78.4757 27.0445 77.8685 25.5725C77.7239 25.2261 77.6082 24.4179 77.3191 24.187C76.9721 23.8984 73.589 24.3891 73.242 24.4179C73.242 24.62 73.271 24.822 73.271 25.0241C73.2999 25.2261 73.2131 25.4281 73.1553 25.6302Z"
          fill="#FF6EA1"
        />
        <path
          d="M69.7144 23.9851C69.5987 23.6388 69.4541 23.2924 69.2517 22.9749C69.83 22.9461 70.3794 22.7729 70.842 22.4265C71.0734 22.2534 71.2758 22.0802 71.4782 21.8781C71.536 21.8204 71.6517 21.6184 71.7673 21.5029C71.6227 21.6761 71.9986 22.6863 72.0565 22.8883C72.201 23.3213 72.4324 23.7254 72.7504 24.0717C73.0685 24.4181 73.242 24.4758 73.2998 24.9376C73.3577 25.4283 73.242 26.0055 73.0685 26.4673C72.9528 26.756 72.8083 27.0446 72.548 27.2178C72.23 27.4198 71.8252 27.391 71.4782 27.3044C70.871 27.1601 70.0613 26.6405 69.83 26.0344C69.7144 25.7169 69.83 25.5437 69.8878 25.1974C69.9457 24.8222 69.8589 24.3892 69.7144 23.9851Z"
          fill="#FFC1A6"
        />
        <path
          d="M69.9168 25.0531C69.9168 25.0242 69.9168 24.9953 69.9168 24.9376C69.8878 24.6201 69.83 24.2738 69.7144 23.9851C69.5987 23.6388 69.4541 23.2924 69.2517 22.9749C69.83 22.9461 70.3794 22.7729 70.842 22.4265C71.0734 22.2534 71.2758 22.0802 71.4782 21.8781C71.536 21.8204 71.6517 21.6184 71.7673 21.5029C71.7962 21.6761 71.7962 21.8781 71.8541 22.0513C71.7673 23.2347 70.9577 24.5335 69.9168 25.0531Z"
          fill="#E3856D"
        />
        <path
          d="M66.1 20.7814C66.3313 21.705 66.8807 22.5709 67.6325 23.1481C67.8349 23.3213 68.0662 23.4656 68.3265 23.5233C68.5867 23.5811 68.8759 23.5522 69.0783 23.4079C69.3674 23.177 69.4253 22.7729 69.4542 22.3977C69.4831 21.705 69.512 21.0123 69.3963 20.3196C69.2807 19.6269 68.9626 18.963 68.4711 18.5012C68.0662 18.126 66.9096 17.5487 66.3892 18.0971C65.8109 18.6455 65.9554 20.0887 66.1 20.7814Z"
          fill="#485070"
        />
        <path
          d="M66.7073 19.1651C66.7941 18.5012 67.5459 18.9919 68.1531 18.7321C68.6736 18.5012 69.0784 18.2703 69.6567 18.3281C70.1771 18.3569 70.6976 18.559 71.0735 18.963C71.1603 19.0785 71.2759 19.1651 71.3338 19.2805C71.5651 19.6558 71.7964 20.0598 71.941 20.4928V20.5216C71.9988 21.3587 71.7964 22.1668 71.3916 22.8307C71.0157 23.4945 70.3217 23.9563 69.541 23.9563C69.1362 23.9563 68.7314 23.812 68.3555 23.4945C67.9796 23.177 67.7194 22.7729 67.488 22.3689C67.1989 21.6762 66.5917 19.8578 66.7073 19.1651Z"
          fill="#FFC1A6"
        />
        <path
          d="M69.5698 20.3772C68.8469 20.2041 68.1241 20.1175 67.459 19.7711C66.9674 19.5402 66.5337 19.1361 66.3313 18.6455C66.1 18.1259 66.2735 17.7796 66.5626 17.3466C66.9674 16.7117 67.6325 16.2499 68.3554 16.0767C69.0782 15.8746 70.0035 16.1633 70.6975 16.423C71.1891 16.5962 71.6517 16.856 71.9698 17.2601C72.5481 17.9528 72.7216 19.1361 72.6926 19.9732C72.6637 20.3484 72.577 20.6659 72.4613 21.0122C72.3746 21.3009 72.23 21.6184 71.883 21.6761C71.6517 21.7049 71.1891 21.0411 70.9577 20.8968C70.5818 20.6659 70.177 20.5216 69.7433 20.4061C69.6855 20.4061 69.6276 20.4061 69.5698 20.3772Z"
          fill="#485070"
        />
        <path
          d="M68.4712 21.1564C68.4712 21.2719 68.5869 21.3585 68.7025 21.3296C68.8182 21.3296 68.9049 21.2141 68.876 21.0987C68.876 20.9832 68.7603 20.8967 68.6447 20.9255C68.5579 20.9544 68.4712 21.041 68.4712 21.1564Z"
          fill="#485070"
        />
        <path
          d="M68.7893 20.5505C68.6448 20.5214 68.5002 20.5505 68.3845 20.6087"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M67.1699 21.5029C67.1699 21.6183 67.2856 21.7049 67.4012 21.676C67.5169 21.676 67.6036 21.5606 67.5747 21.4451C67.5747 21.3297 67.4591 21.2431 67.3434 21.272C67.2567 21.3008 67.1699 21.3874 67.1699 21.5029Z"
          fill="#485070"
        />
        <path
          d="M67.4881 20.9257C67.3435 20.8966 67.1989 20.9257 67.0833 20.984"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M67.9507 21.5317C67.9796 21.7049 67.9507 21.907 67.864 22.0801C67.8351 22.109 67.8062 22.1667 67.8062 22.2244C67.8062 22.2822 67.864 22.311 67.9218 22.311C67.9796 22.311 68.0375 22.311 68.0664 22.2822"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M68.9916 22.5708C68.8181 22.7728 68.5578 22.8594 68.2976 22.8306"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M72.0277 20.4351C72.0566 20.868 71.7674 21.2432 71.3337 21.2721C70.9 21.301 70.5241 21.0123 70.4952 20.5794C70.4662 20.1465 70.7554 19.7712 71.1891 19.7424C71.5939 19.6847 71.9698 20.0021 72.0277 20.4351Z"
          fill="#FFC1A6"
        />
        <path
          d="M71.3627 20.1465C71.247 20.1465 71.1314 20.2042 71.0735 20.2908C71.0157 20.3774 71.0157 20.5217 71.0446 20.6083C71.1025 20.5506 71.2181 20.5217 71.3049 20.5506C71.3916 20.5794 71.4494 20.666 71.4494 20.7526"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.868 109.563H28.8572C27.4692 109.563 26.3416 108.438 26.3416 107.052V72.8787C26.3416 71.4933 27.4692 70.3677 28.8572 70.3677H89.868C91.256 70.3677 92.3837 71.4933 92.3837 72.8787V107.052C92.3837 108.438 91.256 109.563 89.868 109.563Z"
          fill="#DCE4FF"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M97.2705 109.621H21.4551C21.4551 111.353 22.8719 112.767 24.6068 112.767H94.1187C95.8537 112.767 97.2705 111.353 97.2705 109.621Z"
          fill="#BAC5EF"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M88.8271 108.351H29.8981C28.7993 108.351 27.9319 107.457 27.9319 106.389V73.8601C27.9319 72.7633 28.8283 71.8975 29.8981 71.8975H88.8271C89.9259 71.8975 90.7933 72.7922 90.7933 73.8601V106.36C90.7933 107.457 89.9259 108.351 88.8271 108.351Z"
          fill="#545D78"
        />
        <path
          d="M60.2302 71.0893C60.2302 71.3491 59.9989 71.58 59.7386 71.58C59.4784 71.58 59.2471 71.3491 59.2471 71.0893C59.2471 70.8295 59.4784 70.5986 59.7386 70.5986C60.0278 70.5986 60.2302 70.8295 60.2302 71.0893Z"
          fill="#333333"
        />
        <path
          d="M34.408 34.9272L34.408 108.124H84.3154V34.9272H34.408Z"
          fill="#FEFEFF"
        />
        <path
          d="M63.9602 102.319L57.3097 94.0642L51.5267 101.453L46.5244 96.0557L47.1895 95.4496L51.4689 100.068L57.3097 92.621L63.7578 100.674L67.5168 93.0251L75.4395 91.6108L75.613 92.5056L68.124 93.8044L63.9602 102.319Z"
          fill="#E6EDFF"
        />
        <path
          d="M76.654 92.0437C76.654 91.4087 76.1336 90.8892 75.4974 90.8892C74.8613 90.8892 74.3408 91.4087 74.3408 92.0437C74.3408 92.6787 74.8613 93.1982 75.4974 93.1982C76.1625 93.1982 76.654 92.6787 76.654 92.0437Z"
          fill="#FF6EA1"
        />
        <path
          d="M65.0591 101.482C65.0591 100.847 64.5386 100.327 63.9025 100.327C63.2663 100.327 62.7458 100.847 62.7458 101.482C62.7458 102.117 63.2663 102.636 63.9025 102.636C64.5386 102.636 65.0591 102.117 65.0591 101.482Z"
          fill="#628AEC"
        />
        <path
          d="M68.8181 93.4292C68.8181 92.7942 68.2976 92.2747 67.6615 92.2747C67.0254 92.2747 66.5049 92.7942 66.5049 93.4292C66.5049 94.0642 67.0254 94.5837 67.6615 94.5837C68.3265 94.5548 68.8181 94.0353 68.8181 93.4292Z"
          fill="#FFB861"
        />
        <path
          d="M57.2518 94.5837C57.8906 94.5837 58.4084 94.0668 58.4084 93.4292C58.4084 92.7916 57.8906 92.2747 57.2518 92.2747C56.613 92.2747 56.0952 92.7916 56.0952 93.4292C56.0952 94.0668 56.613 94.5837 57.2518 94.5837Z"
          fill="#FFB861"
        />
        <path
          d="M51.6424 101.77C52.2812 101.77 52.799 101.254 52.799 100.616C52.799 99.9783 52.2812 99.4614 51.6424 99.4614C51.0037 99.4614 50.4858 99.9783 50.4858 100.616C50.4858 101.254 51.0037 101.77 51.6424 101.77Z"
          fill="#FF6EA1"
        />
        <path
          d="M48.2304 95.969C48.2304 95.334 47.71 94.8145 47.0738 94.8145C46.4377 94.8145 45.9172 95.334 45.9172 95.969C45.9172 96.604 46.4377 97.1235 47.0738 97.1235C47.71 97.1235 48.2304 96.604 48.2304 95.969Z"
          fill="#3FD4C7"
        />
        <path
          d="M42.0715 88.7534V104.311H76.8853"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M50.1387 63.8735H44.8184V76.198H50.1387V63.8735Z"
          fill="#FFB861"
        />
        <path
          d="M58.3795 57.8411H53.0591V76.1979H58.3795V57.8411Z"
          fill="#FF6EA1"
        />
        <path
          d="M43.8352 60.3233C50.2254 57.437 55.9506 53.1365 60.5481 47.8257"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M61.0396 47.2773L60.6637 48.3453L60.4902 47.8835L60.0276 47.768L61.0396 47.2773Z"
          fill="#485070"
        />
        <path
          d="M66.5914 49.4998H61.271V76.1979H66.5914V49.4998Z"
          fill="#3FD4C7"
        />
        <path
          d="M74.8033 61.1892H69.4829V76.1979H74.8033V61.1892Z"
          fill="#628AEC"
        />
        <path
          d="M41.6956 49.9905V76.2269H77.2322"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M77.1744 78.7668H41.4932V80.5563H77.1744V78.7668Z"
          fill="#E6EDFF"
        />
        <path
          d="M70.0035 43.2654H48.5774V45.0549H70.0035V43.2654Z"
          fill="#E6EDFF"
        />
        <path
          d="M77.1456 40.1482H41.4644V41.9377H77.1456V40.1482Z"
          fill="#E6EDFF"
        />
        <path
          d="M77.1744 82.0571H41.4932V83.8466H77.1744V82.0571Z"
          fill="#E6EDFF"
        />
        <path
          d="M77.1744 85.3474H41.4932V87.1369H77.1744V85.3474Z"
          fill="#E6EDFF"
        />
        <path
          d="M75.8157 24.2449C75.4109 24.3315 74.9771 24.4469 74.5723 24.5624C74.5145 24.5912 74.4278 24.5912 74.3699 24.649C74.2832 24.7067 74.2543 24.8221 74.2543 24.9087C73.994 26.2076 74.341 27.9393 75.1795 28.9784C75.4398 29.2959 75.7289 29.5845 76.0181 29.8731C76.2783 30.1618 76.6542 30.4215 76.8855 30.739C77.1747 31.0854 77.2903 31.6915 77.406 32.1245C77.6952 33.1058 77.8976 34.1449 77.9554 35.1839C78.0132 35.8766 78.0421 36.6559 78.5626 37.0889C79.0831 37.5218 79.9216 37.4064 80.4421 37.0023C80.9915 36.5982 81.2806 35.9344 81.5119 35.2994C82.1192 33.6253 82.4372 31.8358 82.3505 30.0752C82.2637 28.4589 81.7722 26.525 80.7312 25.2551C80.0373 24.3892 78.8807 24.014 77.7819 24.014C77.1458 23.9851 76.4807 24.1006 75.8157 24.2449Z"
          fill="#FF6EA1"
        />
        <path
          d="M76.7986 33.914C77.1745 31.8359 77.5793 29.7578 77.9552 27.7085"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M77.2036 28.0837C77.3482 28.4301 77.4638 28.7476 77.6084 29.0939"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M69.3963 38.3877C69.5409 38.33 69.6855 38.3011 69.859 38.3011C71.2758 38.2723 72.6348 38.128 74.0517 37.9836C75.0059 37.897 75.9601 37.8393 76.8853 37.8105C77.6371 37.8105 78.5335 37.9548 79.2564 37.7527C80.0371 37.5218 80.5865 37.3198 80.9624 36.6559C81.1648 36.3385 81.3383 36.021 81.4828 35.7035C81.5696 35.5014 81.6563 35.2994 81.6274 35.1262C81.5696 34.8376 81.2515 34.6644 80.9335 34.549C80.2684 34.318 79.8636 33.9428 79.1118 33.8562C78.3311 33.7697 77.5504 33.8851 76.7697 34.0294C75.2661 34.3469 73.7625 34.4624 72.2878 34.9242C70.6108 35.4148 69.0204 36.1075 67.459 36.8291C66.8807 37.0889 66.2735 37.3487 65.8687 37.7816C65.2326 38.4454 65.1458 39.4268 65.6952 40.0329C65.8398 40.2061 66.1 40.3793 66.3602 40.3215C66.6494 40.2638 66.8229 39.9174 66.5916 39.802C68.1241 40.3793 68.153 38.8207 69.3963 38.3877Z"
          fill="#FFC1A6"
        />
        <path
          d="M64.6543 38.6186V38.532C64.6254 38.5897 64.5964 38.6474 64.5964 38.7052C64.5964 38.6763 64.6254 38.6474 64.6543 38.6186Z"
          fill="#FF6EA1"
        />
        <path
          d="M68.5868 26.9003C68.5 26.7271 68.3844 26.6116 68.2109 26.4962C67.7193 26.2076 66.6784 26.6405 66.2447 26.9003C66.1579 26.958 66.0712 27.0157 65.9555 27.0734C65.435 27.4198 64.9724 27.8816 64.5387 28.3145C64.3941 28.4589 64.2495 28.632 64.1338 28.7764C62.0809 31.1142 60.7797 33.7119 61.0978 36.858C61.1556 37.5218 61.3002 38.2723 61.7917 38.7052C62.1965 39.0804 62.7748 39.1959 63.2953 39.0804C63.7869 38.9938 64.2495 38.7052 64.6254 38.3588L64.5965 38.4743C64.6254 38.4166 64.6543 38.3588 64.6832 38.3011C65.4929 37.5218 65.6663 36.4539 65.8688 35.386C66.5049 33.8274 67.141 32.2399 67.7771 30.6813C68.153 29.9886 69.1362 27.9393 68.5868 26.9003Z"
          fill="#FF6EA1"
        />
        <path
          d="M65.3194 50.135C66.1869 48.6919 64.5966 48.461 64.3652 47.191C64.3363 47.0467 64.3363 46.8735 64.3652 46.7292C64.5966 45.3438 64.6833 43.9583 64.799 42.5152C64.8857 41.5627 65.0014 40.6102 65.1459 39.6866C65.2616 39.0517 65.4929 38.3589 65.5218 37.6951C65.4929 37.4931 65.4929 37.2621 65.4351 37.0601C65.1749 36.5694 64.77 36.1942 64.105 35.9922C63.3243 35.7324 62.4279 35.9345 61.7918 36.454C61.6183 36.6849 61.4737 36.9735 61.3581 37.2333C61.1846 37.926 61.1557 38.6476 61.1846 39.3403C61.2424 40.87 61.0978 42.3997 61.2713 43.9006C61.4737 45.6324 61.9075 47.3064 62.3412 48.9516C62.5147 49.5577 62.6882 50.1927 63.0351 50.6545C63.6134 51.3761 64.5966 51.5782 65.3483 51.1163C65.5508 50.972 65.7821 50.77 65.7532 50.4814C65.811 50.1639 65.464 49.933 65.3194 50.135Z"
          fill="#FFC1A6"
        />
        <path
          d="M65.4351 37.0889C65.8399 35.2128 66.5917 33.3944 67.6326 31.7781"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M66.9097 32.9326C67.1699 32.7594 67.4012 32.6151 67.6615 32.4419"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M22.2935 69.1555C23.3634 70.3966 23.7971 72.0418 24.173 73.6004C24.6357 75.5919 25.1272 77.6123 25.5899 79.6039C25.7055 80.0657 25.8212 80.5563 25.8212 81.0181C25.8501 81.7974 25.6188 82.7788 25.4453 83.5292C25.214 84.4817 24.6357 84.424 23.7682 84.3374C22.4092 84.1931 20.5876 83.789 19.6623 82.6922C19.2285 82.1727 19.084 81.48 18.9683 80.7872C18.7948 79.8636 18.6213 78.94 18.4478 78.0453C17.7539 74.2931 17.031 70.4255 17.8406 66.7021C19.749 66.9908 21.1659 67.8855 22.2935 69.1555Z"
          fill="white"
        />
        <path
          d="M24.2599 81.0181C24.8671 81.3068 25.4165 81.6531 25.9948 81.9995C26.9201 82.5479 27.8743 82.9231 28.7996 83.4426C29.0598 83.5869 29.349 83.7312 29.6381 83.789C30.1297 83.8755 30.679 83.7024 31.1706 83.7601C31.8357 83.8467 32.414 84.4528 32.6742 85.2321C33.079 86.5598 32.1248 86.0691 31.4887 85.9537C30.9971 85.8671 30.5056 85.7805 29.9851 85.6939C28.0189 85.3476 26.1394 85.1744 24.1442 85.0589C23.0455 85.0012 21.1371 85.0301 20.3274 84.0487C19.9226 83.5581 19.4889 81.4511 20.0094 80.9315C20.0961 80.8449 20.2407 80.7872 20.3564 80.7584C21.3973 80.412 22.4672 80.3831 23.4792 80.7006C23.7394 80.7872 23.9997 80.9027 24.2599 81.0181Z"
          fill="#9C5240"
        />
        <path
          d="M23.5659 96.4886H4.42408C3.78794 96.4886 3.29639 95.9691 3.29639 95.363C3.29639 94.728 3.81686 94.2373 4.42408 94.2373H23.537C24.1731 94.2373 24.6647 94.7568 24.6647 95.363C24.6936 95.9691 24.202 96.4886 23.5659 96.4886Z"
          fill="#485070"
        />
        <path
          d="M2.42896 81.5087V74.8125C2.42896 73.8023 3.23858 72.9941 4.25061 72.9941H19.1997C20.2117 72.9941 21.0214 73.8023 21.0214 74.8125V81.5087C21.0214 82.5189 20.2117 83.3271 19.1997 83.3271H4.25061C3.23858 83.3271 2.42896 82.5189 2.42896 81.5087Z"
          fill="#485070"
        />
        <path
          d="M5.95665 81.6531H4.80005V95.4207H5.95665V81.6531Z"
          fill="#485070"
        />
        <path
          d="M18.4191 81.6531H17.2625V95.4207H18.4191V81.6531Z"
          fill="#485070"
        />
        <path
          d="M13.9662 95.9114H12.8096V112.652H13.9662V95.9114Z"
          fill="#485070"
        />
        <path
          d="M5.29161 95.9114H4.13501V112.652H5.29161V95.9114Z"
          fill="#485070"
        />
        <path
          d="M23.826 95.9114H22.6694V112.652H23.826V95.9114Z"
          fill="#485070"
        />
        <path
          d="M17.8985 95.9114H16.7419V112.652H17.8985V95.9114Z"
          fill="#485070"
        />
        <path
          d="M35.3922 101.799C34.7271 101.944 34.2934 101.972 33.5127 102.088C32.385 102.232 31.2573 102.377 30.1296 102.463C30.4188 104.484 30.7079 106.273 30.7658 106.648C31.0549 108.207 30.9103 112.103 31.6043 113.604C32.4428 113.72 33.1946 113.575 33.9753 113.518C34.3802 109.563 34.7271 105.667 35.3922 101.799Z"
          fill="#CF9378"
        />
        <path
          d="M29.4935 105.205C29.4935 105.523 29.4935 105.84 29.5803 106.158C30.4766 107.11 31.8067 107.601 33.1079 107.659C33.8597 107.687 34.5826 107.572 35.2765 107.37C35.3633 105.84 35.45 104.31 35.5368 102.81C35.6524 100.818 35.7681 98.8554 35.9994 96.8638C36.1151 95.9979 36.2307 93.4003 36.0283 91.5242C35.5079 89.5904 34.2356 89.0708 34.2356 89.0708C34.2356 89.0708 30.6212 87.6566 27.8743 87.0504C24.4912 86.3 21.0503 85.7516 17.6383 85.03C15.9902 84.6837 13.2721 84.7414 12.4047 86.5309C11.4216 88.609 13.3878 91.351 14.9492 92.5344C16.5685 93.7755 18.5925 94.3816 20.5877 94.8146C23.4213 95.4207 26.3128 95.7093 29.2044 95.6516C29.1176 95.6227 29.4935 104.512 29.4935 105.205Z"
          fill="#66A3F2"
        />
        <path
          d="M29.2045 95.6516C28.5973 95.0167 27.9901 94.3528 27.3828 93.7178C26.4576 92.7942 25.5323 91.8417 24.607 90.8893C22.7564 89.042 20.9059 87.1948 19.0842 85.2899C18.6216 85.2033 18.13 85.0878 17.6674 85.0012C16.0192 84.6549 13.3012 84.7126 12.4337 86.5021C11.4506 88.5802 13.4168 91.3222 14.9783 92.5056C16.5975 93.7467 18.6216 94.3528 20.6167 94.7857C23.4215 95.4207 26.313 95.6805 29.2045 95.6516Z"
          fill="#485070"
        />
        <path
          d="M29.2334 96.2001C29.2334 95.3053 29.3491 94.1797 29.3491 93.2849"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
        />
        <path
          d="M31.5465 88.1761C29.1176 87.3968 26.9201 86.6752 23.3635 86.1846"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M38.9198 115.538H31.4308C31.2862 115.538 31.1416 115.423 31.1416 115.25V114.701H38.8909V115.538H38.9198Z"
          fill="#B3B3B3"
        />
        <path
          d="M38.8042 114.903C38.8331 114.874 38.8621 114.817 38.891 114.788C39.0645 114.384 38.8621 113.864 38.4862 113.576C38.1392 113.287 37.6476 113.143 37.2139 113.027C36.2308 112.767 35.3055 112.508 34.2935 112.363C34.0332 112.335 31.1996 112.075 31.2285 111.93C31.1706 112.652 31.1417 113.345 31.0839 114.066C31.055 114.355 30.9972 114.644 31.0839 114.903H38.8042Z"
          fill="#485070"
        />
        <path
          d="M32.5007 111.353C32.9344 111.007 33.5995 111.007 34.0621 111.324C34.5248 111.642 34.785 112.219 34.7561 112.767C34.7561 112.883 34.7272 112.969 34.6694 113.056C34.5826 113.114 34.4669 113.143 34.3802 113.143C33.9465 113.143 33.4838 113.143 33.0501 113.171C32.761 113.171 32.414 113.229 32.2116 112.998C31.8646 112.508 32.1827 111.699 32.5007 111.353Z"
          fill="#485070"
        />
        <path
          d="M35.45 112.565C35.1898 112.537 34.9295 112.71 34.8428 112.941"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M35.5947 113.258C35.7393 113.027 35.9995 112.883 36.2598 112.883"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M36.5776 113.345C36.6355 113.171 36.809 113.056 36.9824 113.056"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M22.5539 100.731C21.5708 100.876 20.5588 100.991 19.5757 101.078C20.3275 104.772 20.6745 108.553 21.2817 112.277C22.1202 112.277 22.9009 112.103 23.7973 112.103C23.9708 110.978 24.3178 104.282 24.8382 100.327C23.9419 100.587 23.4792 100.616 22.5539 100.731Z"
          fill="#CF9378"
        />
        <path
          d="M19.6914 106.013C19.8938 106.85 20.1252 107.37 20.9637 107.687C21.6866 107.976 22.4673 108.091 23.2191 108.005C24.26 107.889 25.0696 107.139 25.0696 107.139C25.0696 107.139 26.1395 91.3221 24.8094 89.3017C23.1902 86.8195 19.6625 86.2999 16.8867 85.7227C14.4578 85.2032 12.0289 84.7702 9.57114 84.2795C8.96393 86.5308 9.39765 89.1862 10.2651 91.2644V91.2932C10.9591 92.9384 12.5205 94.0352 14.2843 94.1795C15.5855 94.295 16.8867 94.3238 18.1589 94.295C18.2168 94.295 18.9686 103.012 19.6914 106.013Z"
          fill="#66A3F2"
        />
        <path
          d="M18.2456 94.8722C18.2456 93.9774 18.3613 92.8518 18.3613 91.957"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
        />
        <path
          d="M28.8285 115.394H21.3394C21.1949 115.394 21.0503 115.278 21.0503 115.105V114.557H28.7995V115.394H28.8285Z"
          fill="#B3B3B3"
        />
        <path
          d="M28.7129 114.788C28.7418 114.759 28.7708 114.701 28.7997 114.672C28.9732 114.268 28.7708 113.749 28.3949 113.46C28.0479 113.171 27.5563 113.027 27.1226 112.911C26.1395 112.652 25.2142 112.392 24.2022 112.248C23.9419 112.219 21.1083 111.959 21.1372 111.815C21.0793 112.536 21.0504 113.229 20.9926 113.951C20.9637 114.239 20.9058 114.528 20.9926 114.788H28.7129Z"
          fill="#485070"
        />
        <path
          d="M22.4093 111.237C22.843 110.891 23.5081 110.891 23.9707 111.209C24.4334 111.526 24.6936 112.103 24.6647 112.652C24.6647 112.767 24.6358 112.854 24.5779 112.94C24.4912 112.998 24.3755 113.027 24.2888 113.027C23.8551 113.027 23.3924 113.027 22.9587 113.056C22.6695 113.056 22.3226 113.113 22.1202 112.883C21.7443 112.392 22.0623 111.555 22.4093 111.237Z"
          fill="#485070"
        />
        <path
          d="M25.3299 112.45C25.0696 112.421 24.8094 112.594 24.7227 112.825"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M25.5034 113.113C25.648 112.883 25.9082 112.738 26.1685 112.738"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M26.4863 113.229C26.5442 113.056 26.7176 112.94 26.8911 112.94"
          stroke="#B3B3B3"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M9.28189 87.3103C9.33972 87.6855 9.42647 88.0319 9.4843 88.4071C10.7566 87.7432 12.2601 87.8875 13.677 87.8875C16.7998 87.8875 19.8937 87.1082 22.6407 85.6651C22.4961 84.8858 22.3226 84.1354 22.2937 83.3849C22.2937 82.6056 21.9756 81.8263 21.9756 81.047C21.9178 79.9791 21.9756 78.9112 22.0045 77.8433C22.0913 75.8229 22.2359 73.7736 21.86 71.782C21.5997 70.4832 21.1371 69.2132 20.3275 68.1453C19.9516 67.6546 19.46 67.0197 18.9106 66.731C18.3323 66.4424 17.436 66.529 16.7709 66.4713C16.2793 66.4424 15.7878 66.3847 15.3251 66.4713C14.7468 66.5579 14.1975 66.8465 13.677 67.164C10.9301 68.8092 10.612 71.4357 9.77345 74.2931C9.36864 75.7074 8.70359 77.064 8.29878 78.4782C8.06746 79.2864 7.98071 80.0946 7.98071 80.9316C8.00963 81.682 8.29878 82.3459 8.41444 83.0674C8.76142 84.4529 9.02166 85.896 9.28189 87.3103Z"
          fill="white"
        />
        <path
          d="M17.0312 69.0402C17.5228 69.4731 18.2168 69.704 18.8818 69.6463C19.1131 69.6463 19.3445 69.5886 19.5179 69.4443C19.6914 69.2999 19.8071 69.0402 19.7204 68.8381"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.395 74.9858C16.9733 76.9197 18.5347 78.5648 20.4431 79.2576"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.1877 76.5156C18.6793 77.1217 19.4022 77.497 20.1829 77.5835"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M14.689 76.3713C15.3829 78.5938 16.6552 80.643 18.3323 82.2594"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.9924 68.9246C21.7731 70.2811 21.8021 71.0316 21.9755 72.2438C22.178 73.5715 22.2647 74.928 22.2358 76.2846C22.2069 78.5359 21.7153 80.614 22.2069 82.8653"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
        />
        <path
          d="M19.3444 66.0094C19.4601 65.6342 19.6335 65.259 19.836 64.9415C19.2287 64.9126 18.6504 64.7106 18.13 64.3642C17.8697 64.191 17.6673 63.989 17.436 63.7581C17.3493 63.6715 17.2336 63.4983 17.1179 63.354C17.0023 64.7106 16.4818 65.9805 15.3252 66.7598C15.73 67.4814 16.3661 68.0009 17.089 68.4339C17.6962 68.7802 19.1998 69.4729 19.2287 68.2318C19.2287 67.8278 19.0842 67.4525 19.1131 67.0485C19.142 66.7021 19.2287 66.3557 19.3444 66.0094Z"
          fill="#CF9378"
        />
        <path
          d="M19.113 67.1639C19.113 67.135 19.113 67.1062 19.113 67.0485C19.1419 66.7021 19.2287 66.3557 19.3154 66.0094C19.4311 65.6342 19.6046 65.259 19.807 64.9415C19.1997 64.9126 18.6214 64.7106 18.101 64.3642C17.8407 64.191 17.6383 63.989 17.407 63.7581C17.3203 63.6715 17.2046 63.4983 17.0889 63.354C17.06 63.556 17.0311 63.7581 17.0022 63.9313C17.1468 65.2012 18.0142 66.5866 19.113 67.1639Z"
          fill="#9C5240"
        />
        <path
          d="M10.207 69.1554C9.13717 70.3965 8.70345 72.0417 8.32755 73.6003C7.86491 75.5919 7.37335 77.6123 6.91071 79.6038C6.73722 80.2965 6.47699 81.249 6.65048 81.9706C6.82397 82.7499 7.37335 83.4426 8.0384 83.8467C8.76128 84.2796 9.83114 84.4816 10.6118 84.1064C11.3926 83.7601 12.26 83.3849 12.8094 82.721C13.2431 82.2015 13.3877 81.5088 13.5034 80.8161C13.6768 79.8924 13.8503 78.9688 14.0238 78.0741C14.7178 74.3219 15.4407 70.4543 14.631 66.731C12.7516 66.9907 11.3347 67.8855 10.207 69.1554Z"
          fill="white"
        />
        <path
          d="M14.689 72.8787C13.1276 73.2827 13.2722 75.2743 13.1276 76.5154C12.9252 78.3338 12.5782 80.1521 12.0867 81.9127"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
        />
        <path
          d="M13.5322 73.9179C13.7057 73.3695 14.0527 72.8788 14.4864 72.5325"
          stroke="#485070"
          strokeWidth="0.167187"
          strokeMiterlimit="10"
        />
        <path
          d="M12.6071 81.3932C13.4457 81.5664 14.2553 81.855 15.0938 82.0859C16.395 82.49 17.7251 82.7209 19.0552 83.0673C19.4311 83.1539 19.807 83.2693 20.2118 83.2693C20.8768 83.2693 21.5419 83.0096 22.2069 82.9807C23.1033 82.9518 23.9708 83.4714 24.4623 84.1929C25.2719 85.4341 23.9129 85.1166 23.0744 85.0877C22.4093 85.0877 21.7443 85.0588 21.0793 85.0588C18.448 85.03 15.9613 85.1454 13.33 85.3763C11.9132 85.4918 9.39755 85.8381 8.12529 84.9722C7.51807 84.5682 6.47712 82.5478 7.05543 81.9705C7.17109 81.855 7.31566 81.7973 7.46024 81.7396C8.76142 81.2201 10.1493 81.0469 11.5373 81.1912C11.8553 81.2489 12.2312 81.3067 12.6071 81.3932Z"
          fill="#CF9378"
        />
        <path
          d="M34.6116 88.7532H17.2625C17.0601 88.7532 16.9155 88.6089 16.9155 88.4069V88.2914C16.9155 88.0894 17.0601 87.9451 17.2625 87.9451H34.6116C34.814 87.9451 34.9586 88.0894 34.9586 88.2914V88.4069C34.9586 88.58 34.7851 88.7532 34.6116 88.7532Z"
          fill="#485070"
        />
        <path
          d="M36.7803 88.7533H21.3396L22.6697 79.8924C22.7275 79.5749 22.9878 79.344 23.2769 79.344H37.4742C37.8501 79.344 38.1104 79.6615 38.0525 80.0367L36.7803 88.7533Z"
          fill="#757E96"
        />
        <path
          d="M30.3321 84.8856C30.891 84.8856 31.3441 84.4334 31.3441 83.8754C31.3441 83.3175 30.891 82.8652 30.3321 82.8652C29.7732 82.8652 29.3201 83.3175 29.3201 83.8754C29.3201 84.4334 29.7732 84.8856 30.3321 84.8856Z"
          fill="white"
        />
        <path
          d="M22.3805 60.3812C22.207 59.6885 21.4552 60.2946 20.7902 60.0637C20.2118 59.8616 19.7492 59.6885 19.142 59.8039C18.5926 59.8905 18.0432 60.1791 17.6962 60.6121C17.6095 60.7275 17.5227 60.843 17.436 60.9873C17.2336 61.4202 17.0312 61.882 16.9155 62.3438V62.3727C16.9444 63.2675 17.2625 64.1045 17.7541 64.7972C18.2456 65.461 19.0263 65.894 19.836 65.7785C20.2697 65.7208 20.6745 65.5476 21.0504 65.1724C21.3974 64.7972 21.6576 64.3354 21.86 63.8736C22.1492 63.1231 22.5829 61.1316 22.3805 60.3812Z"
          fill="#CF9378"
        />
        <path
          d="M19.1419 61.045C19.1419 61.0161 19.1419 60.9872 19.1708 60.9295C19.2287 60.6409 19.2865 60.3523 19.3443 60.0636C20.0672 60.612 20.8479 61.3625 21.8021 61.68C22.525 61.9109 23.3057 61.6511 23.7683 61.0738C23.8551 60.9584 23.9129 60.8429 23.9707 60.7275C23.9996 60.6697 24.0575 60.4388 24.0864 60.4388C23.8262 60.612 23.4792 60.4966 23.2768 60.2657C23.0744 60.0348 22.9876 59.7461 22.872 59.4575C22.6117 58.7937 22.1491 58.1875 21.5708 57.7835C20.9925 57.3794 20.2407 57.1773 19.5467 57.2639C19.113 57.3217 18.6793 57.4948 18.3034 57.7546C18.1299 57.8989 17.9564 58.0432 17.8407 58.2164C17.7829 58.303 17.5227 58.7648 17.6383 58.8514C17.4937 58.7071 17.2335 58.7359 17.06 58.8225C16.8865 58.938 16.742 59.1112 16.6552 59.2843C16.2215 60.0636 16.048 60.9872 16.1926 61.8531C16.2504 62.2572 16.395 62.5747 16.5395 62.9499C16.6552 63.2386 16.8576 63.5849 17.2046 63.5849C17.6962 63.5849 17.6383 62.7479 17.7829 62.3149C17.8407 62.1418 17.8407 61.9397 18.0431 61.882C18.2455 61.8243 18.5925 62.2283 18.7371 61.9109C18.7949 61.7954 18.766 61.6511 18.7371 61.5356C18.7082 61.4202 18.6793 61.2759 18.766 61.1604C18.766 61.1604 19.0262 61.1604 19.0841 61.1604C19.113 61.1604 19.113 61.1316 19.1419 61.045Z"
          fill="#485070"
        />
        <path
          d="M17.8985 57.5813C17.4937 58.1008 17.4359 58.8513 17.6961 59.4285"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.5105 58.707C16.8286 58.505 17.2912 58.5916 17.5225 58.8802"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.5009 62.9498C20.6286 62.9498 20.7322 62.8465 20.7322 62.7189C20.7322 62.5914 20.6286 62.488 20.5009 62.488C20.3731 62.488 20.2695 62.5914 20.2695 62.7189C20.2695 62.8465 20.3731 62.9498 20.5009 62.9498Z"
          fill="#485070"
        />
        <path
          d="M20.3274 62.1132C20.472 62.055 20.6455 62.0841 20.79 62.1132"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M22.1492 62.9499C22.1492 63.0653 22.0624 63.1808 21.9178 63.1808C21.8022 63.1808 21.6865 63.0942 21.6865 62.9499C21.6865 62.8344 21.7733 62.719 21.9178 62.719C22.0624 62.719 22.1492 62.8344 22.1492 62.9499Z"
          fill="#485070"
        />
        <path
          d="M21.7441 62.3442C21.8887 62.2859 22.0622 62.3151 22.2068 62.3442"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M21.3394 63.0654C21.3105 63.2675 21.3683 63.4695 21.484 63.6427C21.5129 63.6716 21.5418 63.7293 21.5418 63.787C21.5418 63.8447 21.484 63.8736 21.4262 63.9025C21.3683 63.9025 21.3105 63.9025 21.2527 63.9025"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.3274 64.2776C20.5298 64.4508 20.8479 64.5374 21.1081 64.4796"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.8865 62.3148C16.8865 62.7766 17.2624 63.1518 17.725 63.1518C18.1877 63.1518 18.5635 62.7766 18.5635 62.3148C18.5635 61.853 18.1877 61.4778 17.725 61.4778C17.2335 61.4778 16.8865 61.853 16.8865 62.3148Z"
          fill="#CF9378"
        />
        <path
          d="M17.5516 61.9684C17.6673 61.9396 17.7829 61.9973 17.8697 62.0839C17.9564 62.1705 17.9564 62.3148 17.9275 62.4303C17.8697 62.3725 17.754 62.3437 17.6673 62.4014C17.5805 62.4303 17.5227 62.5457 17.5227 62.6323"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M109.444 109.506C109.415 109.39 106.465 109.91 106.147 109.968L106.118 109.996C105.106 110.862 103.805 111.324 102.533 111.786C102.33 111.844 102.128 111.93 102.012 112.103C101.434 112.767 102.648 113.056 103.082 113.114C103.805 113.171 104.499 113.027 105.193 112.912C106.61 112.652 108.056 112.738 109.472 112.392C109.53 112.392 109.588 112.363 109.617 112.305C109.646 112.277 109.646 112.219 109.646 112.19C109.704 111.295 109.646 110.372 109.444 109.506Z"
          fill="#485070"
        />
        <path
          d="M102.967 88.7822C103.689 95.8824 104.991 103.156 105.8 110.256C107.477 110.4 108.056 110.285 109.675 110.025C110.745 102.319 111.178 98.5956 110.224 90.7737C110.137 89.9655 110.224 83.3271 110.195 82.4612C110.022 77.3813 110.716 71.5799 107.651 67.2793C106.87 66.1825 105.627 65.3744 104.326 65.4609C103.371 65.5475 102.648 66.0382 102.128 66.7886C100.538 68.9245 101.434 74.7548 101.723 77.2947C102.07 80.6428 102.62 85.4052 102.967 88.7822Z"
          fill="#757E96"
        />
        <path
          d="M103.458 93.1982C103.747 91.9571 104.094 90.7449 104.441 89.5326C105.656 85.2898 106.147 80.9026 106.755 76.5443C106.899 75.5053 107.044 74.4662 107.015 73.4271C106.986 72.3592 106.87 71.2913 106.783 70.2522C106.668 68.8091 106.523 67.3659 106.176 65.9516C105.598 65.6053 104.933 65.4032 104.297 65.461C103.343 65.5475 102.62 66.0382 102.099 66.7886C100.509 68.9245 101.405 74.7548 101.694 77.2947C102.07 80.6717 102.62 85.4341 102.967 88.811C103.111 90.2253 103.285 91.6973 103.458 93.1982Z"
          fill="#545D78"
        />
        <path
          d="M98.051 110.487C98.0221 110.487 97.9932 110.487 97.9643 110.487C97.0101 110.603 96.0559 110.603 95.1017 110.458C94.986 110.43 94.8704 110.43 94.7258 110.458C94.6101 110.487 94.5234 110.545 94.4367 110.603C93.5403 111.151 92.5572 111.526 91.5451 111.7C90.9668 111.815 90.3307 111.873 89.8681 112.248C89.6367 112.421 89.4922 112.739 89.6367 112.969C89.6946 113.056 89.7813 113.085 89.8681 113.143C90.7644 113.547 92.0945 113.402 93.0487 113.345C94.5812 113.258 96.1137 113.345 97.6462 113.056C97.7041 113.056 97.7619 113.027 97.8197 112.998C97.8775 112.941 97.9065 112.854 97.9354 112.767C98.0221 112.335 98.1089 111.93 98.1667 111.497C98.1956 111.324 98.2824 110.718 98.1667 110.574C98.1378 110.487 98.1089 110.487 98.051 110.487Z"
          fill="#485070"
        />
        <path
          d="M101.81 66.4135C98.3112 66.3558 97.2414 70.0214 96.8076 72.8211C95.9402 78.738 95.3041 84.7126 94.9571 90.7161C94.7836 93.689 94.5523 96.2 94.4366 99.2018C94.3209 102.261 94.1764 107.572 94.292 110.603C94.292 110.66 94.292 110.718 94.3499 110.776C94.4077 110.834 94.4655 110.834 94.5523 110.834C95.8245 110.978 97.1257 110.978 98.4269 110.891C98.4847 110.891 98.5426 110.891 98.6004 110.834C98.6582 110.805 98.1667 110.603 98.1956 110.545C99.1787 107.514 99.8437 102.059 100.162 98.8843C100.798 92.2458 102.186 85.7805 104.673 79.6327C107.159 73.8601 108.547 66.529 101.81 66.4135Z"
          fill="#757E96"
        />
        <path
          d="M103.256 83.2693C104.672 79.9212 105.858 76.4866 106.87 72.9941"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M102.504 74.2931H102.533C102.851 74.3508 103.169 74.3797 103.487 74.4374C103.718 74.4662 103.95 74.4951 104.21 74.524C104.297 74.524 104.354 74.524 104.441 74.5528C104.644 74.5817 104.846 74.5817 105.048 74.5817C105.164 74.5817 105.28 74.5817 105.395 74.6106C105.482 74.6106 105.569 74.6106 105.656 74.6106C107.159 74.6683 108.692 74.5528 110.166 74.2931C109.935 71.6088 109.357 69.04 107.795 66.8464C107.015 65.7497 105.771 64.9415 104.47 65.0281C103.516 65.1147 102.793 65.6053 102.272 66.3558C102.157 66.529 102.041 66.7021 101.954 66.9042C98.9183 66.8464 97.5593 69.9059 96.8943 72.4747C97.5882 72.8788 98.34 73.1963 99.0629 73.456C100.191 73.8313 101.347 74.091 102.504 74.2931Z"
          fill="#545D78"
        />
        <path
          d="M104.036 47.3641C104.065 46.96 104.036 46.5848 103.95 46.1807C104.528 46.3828 105.135 46.3828 105.742 46.2384C106.032 46.1519 106.321 46.0364 106.581 45.921C106.668 45.8632 106.841 45.7189 107.015 45.6323C106.668 46.96 106.697 48.3166 107.506 49.4422C106.899 49.9618 106.089 50.2504 105.28 50.3947C104.586 50.5102 102.938 50.6256 103.342 49.4711C103.458 49.0959 103.747 48.8072 103.863 48.4032C103.979 48.0568 104.007 47.7105 104.036 47.3641Z"
          fill="#F7B699"
        />
        <path
          d="M105.627 46.2673C105.077 46.3827 104.499 46.3827 103.95 46.1807C104.036 46.5559 104.065 46.96 104.036 47.364C104.007 47.7104 103.979 48.0568 103.863 48.4031C103.863 48.432 103.834 48.4608 103.834 48.5186C103.892 48.5186 103.979 48.4897 104.036 48.4897C104.817 47.9413 105.366 47.1331 105.627 46.2673Z"
          fill="#C46E58"
        />
        <path
          d="M103.14 41.0142C103.545 40.437 104.036 41.2451 104.73 41.274C105.337 41.3029 105.829 41.274 106.378 41.5915C106.87 41.8801 107.275 42.3131 107.448 42.8615C107.506 43.0058 107.535 43.1501 107.564 43.2944C107.593 43.7851 107.622 44.2469 107.564 44.7376V44.7664C107.217 45.6034 106.639 46.2673 105.945 46.7291C105.251 47.1909 104.383 47.3064 103.631 46.9311C103.256 46.7291 102.909 46.4116 102.706 45.9498C102.504 45.488 102.446 44.9685 102.417 44.4489C102.388 43.6696 102.677 41.6492 103.14 41.0142Z"
          fill="#F7B699"
        />
        <path
          d="M103.95 42.3707C103.4 42.4573 102.938 42.5439 102.446 42.2553C102.07 42.0244 101.752 41.6491 101.636 41.2451C101.608 41.1296 101.579 40.9853 101.579 40.841C101.579 40.7833 101.579 40.5524 101.579 40.5235C101.752 40.7833 102.128 40.7833 102.417 40.6389C102.677 40.4946 102.88 40.2349 103.082 40.0328C103.574 39.5133 104.21 39.1092 104.904 38.936C105.598 38.7629 106.35 38.8206 106.986 39.1381C107.391 39.3401 107.738 39.6576 107.969 40.0328C108.085 40.206 108.2 40.4369 108.258 40.6389C108.287 40.7255 108.374 41.2451 108.229 41.3028C108.431 41.2162 108.663 41.3317 108.778 41.5048C108.923 41.678 108.952 41.88 109.01 42.0821C109.125 42.7171 109.039 43.5541 108.75 44.1602C108.547 44.622 108.316 45.1416 108.056 45.6034C107.824 46.0074 107.506 46.3538 107.101 46.5558C106.581 46.8156 105.974 46.7867 105.424 46.7579C104.904 46.729 104.499 46.527 104.268 46.0363C104.181 45.8054 104.123 45.5168 104.123 45.2859C104.123 45.1704 104.065 44.4488 104.152 44.3911C104.036 44.4488 103.921 44.5066 103.805 44.5066C103.689 44.5066 103.545 44.4777 103.487 44.3623C103.429 44.2468 103.458 44.1314 103.487 44.0159C103.632 43.4386 103.776 42.8902 103.95 42.3707Z"
          fill="#485070"
        />
        <path
          d="M108.316 39.9463C108.489 40.5813 108.316 41.3028 107.853 41.7647"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M109.241 41.476C109.01 41.1873 108.547 41.1007 108.229 41.2739"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M105.251 44.7374C105.077 45.1704 104.615 45.3724 104.181 45.2281C103.747 45.0549 103.545 44.5931 103.689 44.1602C103.863 43.7272 104.325 43.5252 104.759 43.6695C105.193 43.8427 105.424 44.3333 105.251 44.7374Z"
          fill="#F7B699"
        />
        <path
          d="M104.759 44.189C104.644 44.1313 104.528 44.1313 104.412 44.189C104.297 44.2468 104.239 44.3622 104.239 44.4777C104.326 44.4488 104.441 44.4777 104.499 44.5354C104.557 44.5931 104.586 44.7086 104.528 44.7952"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.7717 54.0891C93.8295 53.8294 94.003 53.5985 94.2632 53.5119C94.5235 53.4253 94.9572 53.4253 95.0439 53.1655C95.0729 53.0501 95.1307 52.9923 95.015 52.9057C94.8994 52.8192 94.7837 52.7903 94.6391 52.7614C94.2343 52.7326 93.8006 52.9635 93.5982 53.3387C93.5404 53.4541 93.4536 53.5985 93.3379 53.5696C93.2801 53.5407 93.2512 53.483 93.2223 53.4541C93.0777 53.1078 93.2801 52.7326 93.4825 52.4151C93.6271 52.1842 93.8006 51.9244 94.0608 51.7801C94.35 51.6069 94.697 51.6358 95.015 51.6646C95.6801 51.7224 96.3451 51.7512 96.8945 52.1553C97.0391 52.2708 97.1837 52.3862 97.3282 52.4728C97.7041 52.7326 98.1379 52.8769 98.5716 53.0212C98.427 53.483 98.3113 53.9448 98.1668 54.4066C98.1668 54.4355 98.1379 54.4643 98.1379 54.4643C98.1089 54.4643 98.08 54.4643 98.0511 54.4643C97.2704 54.2623 96.3451 54.118 95.5644 53.9737C94.9572 53.9448 94.35 54.0025 93.7717 54.0891Z"
          fill="#F7B699"
        />
        <path
          d="M98.1378 51.9822C97.4149 52.9058 97.0101 54.0603 97.068 55.2148C97.5884 55.4169 98.08 55.6189 98.6005 55.8209C98.7739 55.0128 98.9474 54.2046 99.1209 53.3965C99.1788 53.1656 99.3812 52.646 99.2655 52.444C99.092 52.2419 98.3691 52.0976 98.1378 51.9822Z"
          fill="white"
        />
        <path
          d="M103.371 53.8871C102.967 53.6274 102.504 53.3965 102.07 53.1944C101.29 52.8481 100.451 52.5594 99.6703 52.2708C99.3811 52.1554 99.063 52.0399 98.745 51.9822C97.8775 52.9058 97.5884 54.4355 97.6751 55.7632C98.5715 56.5425 99.9016 57.0332 100.914 57.6393C101.463 57.9857 102.012 58.3609 102.649 58.5918C103.256 58.8227 103.95 58.9381 104.586 58.765C104.904 58.6784 105.251 58.4763 105.395 58.1588C105.482 57.9568 105.511 57.7548 105.482 57.5239C105.453 56.0807 104.615 54.6664 103.371 53.8871Z"
          fill="#545D78"
        />
        <path
          d="M88.48 58.9669C88.133 58.3608 88.0752 57.6104 88.3065 56.9754C88.3933 56.7445 88.5668 56.4847 88.7981 56.427C89.0872 56.3404 89.4053 56.5136 89.6077 56.7445C89.7812 56.9754 89.8679 57.2929 90.0125 57.5815C90.1282 57.899 90.3017 58.1876 90.5041 58.4474C90.7065 58.7072 90.9667 58.9958 91.0245 59.3133C91.0824 59.573 90.9667 59.8617 90.7932 60.0637C90.0414 60.7853 88.827 59.6019 88.48 58.9669Z"
          fill="#F7B699"
        />
        <path
          d="M96.6631 58.5341L92.268 60.641L86.4561 55.388L90.8512 53.281L96.6631 58.5341Z"
          fill="#F4AE2D"
        />
        <path
          d="M95.9401 58.303L92.1811 60.1213L87.1499 55.5898L90.9089 53.7715L95.9401 58.303Z"
          fill="white"
        />
        <path
          d="M91.4873 54.7241L88.3645 56.2539L88.0464 55.9652L91.1981 54.4644L91.4873 54.7241Z"
          fill="#C8DDF7"
        />
        <path
          d="M93.1067 56.1672L89.9549 57.697L89.6658 57.4083L92.7886 55.9075L93.1067 56.1672Z"
          fill="#C8DDF7"
        />
        <path
          d="M93.6269 56.6578L90.5041 58.1875L90.186 57.8989L93.3089 56.3691L93.6269 56.6578Z"
          fill="#C8DDF7"
        />
        <path
          d="M94.1474 57.1485L91.0246 58.6494L90.7065 58.3896L93.8583 56.8599L94.1474 57.1485Z"
          fill="#C8DDF7"
        />
        <path
          d="M94.697 57.6104L91.5453 59.1401L91.2561 58.8515L94.3789 57.3506L94.697 57.6104Z"
          fill="#C8DDF7"
        />
        <path
          d="M95.2173 58.1011L92.0944 59.602L91.7764 59.3422L94.8992 57.8125L95.2173 58.1011Z"
          fill="#C8DDF7"
        />
        <path
          d="M90.7355 54.2045L88.1043 55.4745L86.9766 54.4643L89.6078 53.1943L90.7355 54.2045Z"
          fill="#485070"
        />
        <path
          d="M88.9427 58.4762C88.8849 58.5339 88.856 58.5917 88.8271 58.6494C88.509 59.1689 89.1451 59.6885 89.5499 59.9482C90.4752 60.6121 91.6029 60.9007 92.6728 61.2182C93.28 61.3914 95.0438 60.9584 94.5522 60.0059C94.2342 59.3421 93.2511 58.9669 92.586 58.7937C91.921 58.6783 91.3427 58.3896 91.0824 57.7258C90.9668 57.4371 90.9379 57.0908 90.8222 56.8022C90.7933 56.7156 90.7644 56.6579 90.7065 56.6001C90.6487 56.5424 90.562 56.5135 90.4752 56.5713C90.4463 56.6001 90.4174 56.629 90.4174 56.6867C90.2439 57.2062 90.562 57.6103 89.9258 57.899C89.7234 58.0144 89.4632 58.0433 89.2608 58.1587C89.1451 58.2742 89.0295 58.3608 88.9427 58.4762Z"
          fill="#F7B699"
        />
        <path
          d="M92.1524 57.928C91.5162 58.9093 91.256 60.1216 91.4295 61.2761C91.9499 61.4204 92.4993 61.5647 93.0198 61.709C93.1065 60.9009 93.1933 60.0638 93.28 59.2557C93.309 58.9959 93.4535 58.4764 93.309 58.3032C93.1355 58.0723 92.4126 58.0146 92.1524 57.928Z"
          fill="white"
        />
        <path
          d="M103.025 48.3743C103.343 48.0857 103.776 48.0568 104.21 47.9991C105.28 47.9125 106.35 47.797 107.42 47.7104C107.622 48.432 107.824 49.1536 108.027 49.8463C108.027 49.8174 104.557 49.9618 104.21 49.9329C103.863 49.9329 102.735 50.0483 102.591 49.702C102.417 49.3845 102.735 48.6341 103.025 48.3743Z"
          fill="white"
        />
        <path
          d="M110.051 66.2405C110.051 65.1148 110.109 63.9603 110.195 62.8346C110.282 61.3626 110.398 59.8618 110.427 58.3897C110.456 56.6002 110.369 54.6953 110.051 52.8769C109.964 52.4151 109.877 51.9822 109.762 51.5492C109.733 51.4627 109.704 51.3761 109.675 51.2606C109.328 50.4525 108.692 49.3557 107.824 48.865C107.68 48.865 107.535 48.865 107.391 48.865C106.408 48.9227 105.396 49.0382 104.412 49.1825C103.747 49.2979 103.256 49.3845 102.764 49.9041C101.492 51.2317 100.306 54.1758 99.9595 55.9941C99.6414 57.7259 99.7571 57.8413 99.5836 59.5731C99.3812 61.6513 99.0631 63.7294 98.6583 65.7786C98.3403 67.5104 97.8198 69.3865 96.374 70.4256C98.774 71.4358 101.203 72.446 103.747 72.8501C106.321 73.2541 109.068 72.9944 111.265 71.5801C110.311 69.9638 110.051 68.1165 110.051 66.2405Z"
          fill="#757E96"
        />
        <path
          d="M104.152 54.4932C104.065 54.2911 103.921 54.118 103.747 54.0025C103.545 53.887 103.314 53.8293 103.082 53.8582C102.07 53.9159 101.29 54.7241 100.74 55.5611C100.191 56.3981 99.7859 57.3795 99.0341 58.0144C97.704 59.1401 94.4945 58.2165 92.9909 57.899C91.8632 58.9958 91.7475 60.2946 92.3258 61.7955C94.321 62.6614 98.5426 64.7684 100.711 63.7293C101.463 63.3541 102.041 62.748 102.504 62.0264C102.764 61.6223 103.024 61.1605 103.227 60.7276C103.718 59.7462 104.21 58.7649 104.441 57.6969C104.673 56.6002 104.644 55.4456 104.152 54.4932Z"
          fill="#757E96"
        />
        <path
          d="M105.02 50.8853C104.354 50.1638 103.198 50.106 102.417 50.5967C101.955 50.8853 101.694 51.4914 101.463 51.9821C101.174 52.5594 100.914 53.1944 100.711 53.8005C100.509 54.4643 100.335 55.1282 100.133 55.7632C99.8148 56.8311 99.3811 57.8701 99.1208 58.9669C98.8606 60.0637 98.8317 61.2471 99.2365 62.2862C99.8148 63.787 101.781 62.9789 102.677 62.1419C103.429 61.4203 103.805 60.4101 104.123 59.4287C104.47 58.4474 104.788 57.4661 105.135 56.4847C105.424 55.6477 105.742 54.5509 105.8 53.483C105.858 52.5305 105.685 51.578 105.02 50.8853Z"
          fill="#757E96"
        />
        <path
          d="M99.6992 57.062C100.162 54.8684 101 52.7614 102.128 50.8564"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M105.714 55.2148C105.28 56.3694 104.846 57.5239 104.412 58.6784C104.094 59.5154 103.805 60.5833 103.227 61.2472C102.649 61.9399 102.099 62.6903 101.376 63.2387C100.682 63.7871 99.8148 64.1623 98.9185 64.0758"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M106.176 55.5034C105.8 55.7343 105.453 56.0518 105.251 56.4559"
          stroke="#485070"
          strokeWidth="0.315447"
          strokeMiterlimit="10"
        />
        <path
          d="M92.6728 55.0128L92.1523 55.3015L92.4126 54.7819L95.5354 51.5493C95.5932 51.4916 95.7089 51.4627 95.7956 51.5493C95.8535 51.607 95.8824 51.7225 95.7956 51.809L92.6728 55.0128Z"
          fill="#485070"
        />
      </g>
      <defs>
        <clipPath id="clip0_1312_3259">
          <rect width="125" height="116" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// TODAY PRODUCTIVITY
export const CarbonPlan = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none">
      <path
        d="M16.8872 5.1475C16.8872 4.93848 16.7827 4.78172 16.6259 4.67721L12.9681 2.58704C12.8636 2.53479 12.8113 2.53479 12.7068 2.53479C12.6023 2.53479 12.5501 2.53479 12.4456 2.58704L9.04905 4.52045L5.65254 2.58704C5.54803 2.53479 5.49577 2.53479 5.39127 2.53479C5.28676 2.53479 5.2345 2.53479 5.12999 2.58704L1.47221 4.67721C1.31545 4.78172 1.21094 4.93848 1.21094 5.1475V15.5983C1.21094 15.9118 1.41995 16.1209 1.73348 16.1209C1.83799 16.1209 1.89024 16.0686 1.99475 16.0686L5.39127 14.1352L8.78778 16.0686C8.89229 16.1209 8.94454 16.1209 9.04905 16.1209C9.15356 16.1209 9.20581 16.1209 9.31032 16.0686L12.7068 14.1352L16.1034 16.0686C16.1556 16.1209 16.2601 16.1209 16.3646 16.1209C16.6782 16.1209 16.8872 15.9118 16.8872 15.5983V5.1475ZM2.25602 5.46102L4.86872 3.94565V13.1946L2.25602 14.71V5.46102ZM8.52651 14.71L5.91381 13.1946V3.94565L8.52651 5.46102V14.71ZM12.1843 13.1946L9.57159 14.71V5.46102L12.1843 3.94565V13.1946ZM13.2294 13.1946V3.94565L15.8421 5.46102V14.71L13.2294 13.1946Z"
        fill="white"
      />
    </svg>
  );
};

export const RoundAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <path
        d="M14.9273 11.1407H10.8631V15.2049C10.8631 15.6519 10.4973 16.0177 10.0502 16.0177C9.60318 16.0177 9.2374 15.6519 9.2374 15.2049V11.1407H5.17319C4.72613 11.1407 4.36035 10.7749 4.36035 10.3278C4.36035 9.88077 4.72613 9.51499 5.17319 9.51499H9.2374V5.45078C9.2374 5.00372 9.60318 4.63794 10.0502 4.63794C10.4973 4.63794 10.8631 5.00372 10.8631 5.45078V9.51499H14.9273C15.3744 9.51499 15.7401 9.88077 15.7401 10.3278C15.7401 10.7749 15.3744 11.1407 14.9273 11.1407Z"
        fill="white"
      />
    </svg>
  );
};

export const DeviceMeetingRemoteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <path
        d="M3.8643 5.39815C3.98681 4.85904 4.28888 4.37757 4.72096 4.03268C5.15304 3.68779 5.6895 3.49997 6.24235 3.5H13.8574C14.4102 3.49997 14.9467 3.68779 15.3788 4.03268C15.8108 4.37757 16.1129 4.85904 16.2354 5.39815L17.7873 12.226C17.8684 12.5831 17.8681 12.9538 17.7864 13.3107C17.7047 13.6677 17.5436 14.0016 17.3152 14.2877C17.0867 14.5739 16.7968 14.8049 16.4668 14.9637C16.1369 15.1225 15.7754 15.2049 15.4093 15.2049H9.07494V14.2295H15.4093C15.6289 14.2295 15.8458 14.1801 16.0437 14.0849C16.2417 13.9896 16.4157 13.8511 16.5527 13.6794C16.6898 13.5078 16.7865 13.3074 16.8356 13.0933C16.8847 12.8792 16.8849 12.6568 16.8363 12.4426L15.2854 5.61469C15.2119 5.29079 15.0303 5.00155 14.7706 4.7945C14.5109 4.58745 14.1885 4.47492 13.8564 4.47541H6.24235C5.91072 4.47559 5.58899 4.58842 5.32989 4.79541C5.07079 5.00241 4.8897 5.29128 4.8163 5.61469L4.40955 7.40164H3.71019C3.60679 7.40164 3.50535 7.40847 3.40488 7.42115L3.8643 5.39815ZM9.02617 17.1557H14.4397C14.569 17.1557 14.6931 17.1044 14.7846 17.0129C14.876 16.9214 14.9274 16.7974 14.9274 16.668C14.9274 16.5387 14.876 16.4146 14.7846 16.3232C14.6931 16.2317 14.569 16.1803 14.4397 16.1803H9.07494V16.668C9.07494 16.8348 9.05836 16.9977 9.02617 17.1557ZM5.1733 12.2787C5.43199 12.2787 5.68009 12.1759 5.86302 11.993C6.04594 11.8101 6.14871 11.562 6.14871 11.3033C6.14871 11.0446 6.04594 10.7965 5.86302 10.6136C5.68009 10.4306 5.43199 10.3279 5.1733 10.3279C4.91461 10.3279 4.66651 10.4306 4.48358 10.6136C4.30066 10.7965 4.19789 11.0446 4.19789 11.3033C4.19789 11.562 4.30066 11.8101 4.48358 11.993C4.66651 12.1759 4.91461 12.2787 5.1733 12.2787ZM2.24707 9.84016C2.24707 9.45212 2.40122 9.07997 2.67561 8.80559C2.94999 8.5312 3.32214 8.37705 3.71019 8.37705H6.63641C7.02446 8.37705 7.39661 8.5312 7.67099 8.80559C7.94538 9.07997 8.09953 9.45212 8.09953 9.84016V16.668C8.09953 17.0561 7.94538 17.4282 7.67099 17.7026C7.39661 17.977 7.02446 18.1311 6.63641 18.1311H3.71019C3.32214 18.1311 2.94999 17.977 2.67561 17.7026C2.40122 17.4282 2.24707 17.0561 2.24707 16.668V9.84016ZM3.71019 9.35246C3.58084 9.35246 3.45679 9.40384 3.36533 9.4953C3.27386 9.58677 3.22248 9.71082 3.22248 9.84016V16.668C3.22248 16.7974 3.27386 16.9214 3.36533 17.0129C3.45679 17.1044 3.58084 17.1557 3.71019 17.1557H6.63641C6.76576 17.1557 6.88981 17.1044 6.98127 17.0129C7.07274 16.9214 7.12412 16.7974 7.12412 16.668V9.84016C7.12412 9.71082 7.07274 9.58677 6.98127 9.4953C6.88981 9.40384 6.76576 9.35246 6.63641 9.35246H3.71019Z"
        fill="white"
      />
    </svg>
  );
};
export const QuickActionBoxVector = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="57"
      viewBox="0 0 60 57"
      fill="none">
      <path
        d="M0.72168 1.5182C0.72168 0.748621 1.34555 0.124756 2.11512 0.124756H57.8528C58.6224 0.124756 59.2463 0.748622 59.2463 1.5182V31.4262C59.2463 32.1958 58.6224 32.8197 57.8528 32.8197H28.448C27.9992 32.8197 27.5778 33.0359 27.3161 33.4005L11.2726 55.7467C10.6178 56.6587 9.2085 56.4616 8.82917 55.4048L0.803622 33.0479C0.749402 32.8969 0.72168 32.7376 0.72168 32.5771V1.5182Z"
        fill="white"
      />
    </svg>
  );
};

export const MingcuteFollowlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g clipPath="url(#clip0_684_38092)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1617 11.3809C14.2397 11.3809 15.2735 11.8091 16.0358 12.5713C16.798 13.3336 17.2263 14.3674 17.2263 15.4454V17.0713C17.2263 17.2869 17.1406 17.4936 16.9882 17.6461C16.8357 17.7985 16.6289 17.8842 16.4133 17.8842C16.1977 17.8842 15.991 17.7985 15.8385 17.6461C15.6861 17.4936 15.6004 17.2869 15.6004 17.0713V15.4454C15.6004 14.7986 15.3435 14.1783 14.8861 13.721C14.4288 13.2636 13.8085 13.0067 13.1617 13.0067H6.65833C6.01154 13.0067 5.39123 13.2636 4.93388 13.721C4.47652 14.1783 4.21958 14.7986 4.21958 15.4454V17.0713C4.21958 17.2869 4.13394 17.4936 3.98149 17.6461C3.82903 17.7985 3.62227 17.8842 3.40667 17.8842C3.19107 17.8842 2.9843 17.7985 2.83185 17.6461C2.6794 17.4936 2.59375 17.2869 2.59375 17.0713V15.4454C2.59375 14.3674 3.02198 13.3336 3.78424 12.5713C4.5465 11.8091 5.58034 11.3809 6.65833 11.3809H13.1617ZM17.5628 7.38212C17.7087 7.23477 17.9055 7.14878 18.1128 7.14175C18.3201 7.13472 18.5222 7.20718 18.6778 7.34429C18.8334 7.4814 18.9307 7.6728 18.9498 7.87932C18.9689 8.08583 18.9084 8.29183 18.7805 8.45517L18.7123 8.53239L16.4133 10.8305C16.2734 10.9705 16.0871 11.0546 15.8896 11.067C15.692 11.0794 15.4967 11.0193 15.3403 10.898L15.2639 10.8305L14.1144 9.68105C13.9671 9.53509 13.8811 9.33834 13.874 9.13107C13.867 8.92379 13.9395 8.72167 14.0766 8.56606C14.2137 8.41046 14.4051 8.31315 14.6116 8.29404C14.8181 8.27494 15.0241 8.33549 15.1875 8.4633L15.2639 8.53077L15.8386 9.10631L17.5628 7.3813V7.38212ZM9.91 1.62585C10.988 1.62585 12.0218 2.05409 12.7841 2.81634C13.5464 3.5786 13.9746 4.61244 13.9746 5.69044C13.9746 6.76843 13.5464 7.80227 12.7841 8.56453C12.0218 9.32679 10.988 9.75502 9.91 9.75502C8.83201 9.75502 7.79816 9.32679 7.03591 8.56453C6.27365 7.80227 5.84542 6.76843 5.84542 5.69044C5.84542 4.61244 6.27365 3.5786 7.03591 2.81634C7.79816 2.05409 8.83201 1.62585 9.91 1.62585ZM9.91 3.25169C9.58974 3.25169 9.27261 3.31477 8.97673 3.43733C8.68085 3.55989 8.412 3.73952 8.18554 3.96598C7.95908 4.19244 7.77945 4.46129 7.65689 4.75717C7.53433 5.05305 7.47125 5.37018 7.47125 5.69044C7.47125 6.0107 7.53433 6.32782 7.65689 6.62371C7.77945 6.91959 7.95908 7.18844 8.18554 7.41489C8.412 7.64135 8.68085 7.82099 8.97673 7.94355C9.27261 8.06611 9.58974 8.12919 9.91 8.12919C10.5568 8.12919 11.1771 7.87225 11.6345 7.41489C12.0918 6.95754 12.3488 6.33723 12.3488 5.69044C12.3488 5.04364 12.0918 4.42334 11.6345 3.96598C11.1771 3.50863 10.5568 3.25169 9.91 3.25169Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_684_38092">
          <rect
            width="19.51"
            height="19.51"
            fill="white"
            transform="translate(0.155273)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuickActionBtnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none">
      <path
        d="M15.0001 10.1515C15.643 10.1515 16.2596 9.89605 16.7143 9.44142C17.1689 8.98679 17.4243 8.37017 17.4243 7.72722C17.4243 7.08427 17.1689 6.46766 16.7143 6.01302C16.2596 5.55839 15.643 5.30298 15.0001 5.30298C14.3571 5.30298 13.7405 5.55839 13.2859 6.01302C12.8312 6.46766 12.5758 7.08427 12.5758 7.72722C12.5758 8.37017 12.8312 8.98679 13.2859 9.44142C13.7405 9.89605 14.3571 10.1515 15.0001 10.1515ZM6.51522 12.5757C6.19375 12.5757 5.88544 12.7034 5.65812 12.9307C5.43081 13.158 5.3031 13.4664 5.3031 13.7878C5.3031 14.1093 5.43081 14.4176 5.65812 14.6449C5.88544 14.8722 6.19375 14.9999 6.51522 14.9999H23.4849C23.8064 14.9999 24.1147 14.8722 24.342 14.6449C24.5693 14.4176 24.697 14.1093 24.697 13.7878C24.697 13.4664 24.5693 13.158 24.342 12.9307C24.1147 12.7034 23.8064 12.5757 23.4849 12.5757H6.51522ZM5.3031 18.6363C5.3031 18.3148 5.43081 18.0065 5.65812 17.7792C5.88544 17.5519 6.19375 17.4242 6.51522 17.4242H23.4849C23.8064 17.4242 24.1147 17.5519 24.342 17.7792C24.5693 18.0065 24.697 18.3148 24.697 18.6363C24.697 18.9578 24.5693 19.2661 24.342 19.4934C24.1147 19.7207 23.8064 19.8484 23.4849 19.8484H6.51522C6.19375 19.8484 5.88544 19.7207 5.65812 19.4934C5.43081 19.2661 5.3031 18.9578 5.3031 18.6363ZM6.51522 22.2727C6.19375 22.2727 5.88544 22.4004 5.65812 22.6277C5.43081 22.855 5.3031 23.1633 5.3031 23.4848C5.3031 23.8063 5.43081 24.1146 5.65812 24.3419C5.88544 24.5692 6.19375 24.6969 6.51522 24.6969H23.4849C23.8064 24.6969 24.1147 24.5692 24.342 24.3419C24.5693 24.1146 24.697 23.8063 24.697 23.4848C24.697 23.1633 24.5693 22.855 24.342 22.6277C24.1147 22.4004 23.8064 22.2727 23.4849 22.2727H6.51522Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      className="productivity-card-edit-icon duration-200 3xl:w-[16px] 3xl:h-[16px]"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.36499 10.673H12.2243V11.4486H1.36499V10.673ZM10.4403 4.07982C10.7505 3.76955 10.7505 3.30415 10.4403 2.99389L9.04408 1.59769C8.73381 1.28742 8.26841 1.28742 7.95815 1.59769L2.14066 7.41518V9.89731H4.62278L10.4403 4.07982ZM8.50111 2.14066L9.89731 3.53685L8.73381 4.70035L7.33761 3.30415L8.50111 2.14066ZM2.91632 9.12164V7.72545L6.79465 3.84712L8.19085 5.24332L4.31252 9.12164H2.91632Z"
        fill="black"
      />
    </svg>
  );
};

export const ProductivityModalCrossIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="13.3145" cy="12.71" r="12.5" fill="#6F6AF8" />
      <g clipPath="url(#clip0_1130_16991)">
        <path
          d="M19.4837 16.5229L15.6708 12.7099L19.4837 8.89696C19.5568 8.823 19.5977 8.72323 19.5977 8.61927C19.5977 8.51532 19.5568 8.41555 19.4837 8.34159L17.6825 6.54037C17.6461 6.50382 17.6028 6.47482 17.5551 6.45503C17.5075 6.43524 17.4564 6.42505 17.4048 6.42505C17.3532 6.42505 17.3021 6.43524 17.2545 6.45503C17.2068 6.47482 17.1635 6.50382 17.1271 6.54037L13.3142 10.3533L9.50121 6.54037C9.42755 6.46674 9.32767 6.42538 9.22352 6.42538C9.11937 6.42538 9.01949 6.46674 8.94584 6.54037L7.14462 8.34159C7.10807 8.37801 7.07906 8.42128 7.05927 8.46893C7.03948 8.51659 7.0293 8.56768 7.0293 8.61927C7.0293 8.67087 7.03948 8.72196 7.05927 8.76961C7.07906 8.81727 7.10807 8.86054 7.14462 8.89696L10.9576 12.7099L7.14462 16.5229C7.07099 16.5965 7.02962 16.6964 7.02962 16.8006C7.02962 16.9047 7.07099 17.0046 7.14462 17.0782L8.94584 18.8795C8.98225 18.916 9.02553 18.945 9.07318 18.9648C9.12083 18.9846 9.17192 18.9948 9.22352 18.9948C9.27512 18.9948 9.32621 18.9846 9.37386 18.9648C9.42151 18.945 9.46479 18.916 9.50121 18.8795L13.3142 15.0665L17.1271 18.8795C17.2008 18.9531 17.3007 18.9945 17.4048 18.9945C17.509 18.9945 17.6088 18.9531 17.6825 18.8795L19.4837 17.0782C19.5203 17.0418 19.5493 16.9986 19.5691 16.9509C19.5888 16.9032 19.599 16.8522 19.599 16.8006C19.599 16.749 19.5888 16.6979 19.5691 16.6502C19.5493 16.6026 19.5203 16.5593 19.4837 16.5229Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1130_16991">
          <rect
            width="12.5685"
            height="12.5685"
            fill="white"
            transform="translate(7.03027 6.42578)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DecreaseValueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none">
      <path
        d="M11.7973 2.78613C6.87686 2.78613 2.87354 6.78945 2.87354 11.7099C2.87354 16.6303 6.87686 20.6336 11.7973 20.6336C16.7177 20.6336 20.721 16.6303 20.721 11.7099C20.721 6.78945 16.7177 2.78613 11.7973 2.78613ZM11.7973 4.15901C15.9756 4.15901 19.3481 7.5315 19.3481 11.7099C19.3481 15.8882 15.9756 19.2607 11.7973 19.2607C7.6189 19.2607 4.24642 15.8882 4.24642 11.7099C4.24642 7.5315 7.6189 4.15901 11.7973 4.15901Z"
        fill="#6F6AF8"
      />
      <path
        d="M11.1108 11.0234H7.67862V12.3963H11.1108H12.4837H15.9159V11.0234H12.4837H11.1108Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};

export const IncreaseValueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none">
      <path
        d="M11.7636 2.78613C6.84317 2.78613 2.83984 6.78945 2.83984 11.7099C2.83984 16.6303 6.84317 20.6336 11.7636 20.6336C16.684 20.6336 20.6873 16.6303 20.6873 11.7099C20.6873 6.78945 16.684 2.78613 11.7636 2.78613ZM11.7636 4.15901C15.9419 4.15901 19.3144 7.5315 19.3144 11.7099C19.3144 15.8882 15.9419 19.2607 11.7636 19.2607C7.58521 19.2607 4.21273 15.8882 4.21273 11.7099C4.21273 7.5315 7.58521 4.15901 11.7636 4.15901ZM11.0771 7.59122V11.0234H7.64493V12.3963H11.0771V15.8285H12.45V12.3963H15.8822V11.0234H12.45V7.59122H11.0771Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};

export const DescriptionIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#6F6AF8" />
      <g clipPath="url(#clip0_1121_16916)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9564 9.19047C16.2921 9.5905 16.0891 10.2287 16.4471 10.7914C16.7121 11.208 17.0122 11.3729 17.5683 11.4076C18.1324 11.4429 18.5338 11.2518 18.8218 10.8112C19.5068 9.76296 18.0735 8.51769 16.9564 9.19047ZM15.4842 12.8994C14.4075 12.9732 13.4567 13.0604 13.3711 13.0934C13.1441 13.1809 12.9478 13.5655 13.0125 13.7959C13.1046 14.1235 13.4442 14.3008 13.9801 14.3008C14.3873 14.3008 14.489 14.3325 14.7078 14.528C14.8671 14.6705 14.9621 14.8362 14.9621 14.9718C14.9621 15.091 14.5315 16.6274 14.0051 18.3862C13.4788 20.1449 13.0483 21.7209 13.0485 21.8882C13.0498 23.1709 15.0946 23.3901 16.914 22.3025C17.6647 21.8538 18.9642 20.7918 18.9642 20.627C18.9642 20.4212 18.6908 20.4201 18.0211 20.6233C17.0703 20.9117 16.5451 20.9247 16.2567 20.667C16.1069 20.5332 16.0818 20.4422 16.1226 20.1811C16.1502 20.0045 16.6443 18.2924 17.2205 16.3763C17.7968 14.4603 18.2682 12.8596 18.2682 12.8192C18.2682 12.7247 17.8692 12.7362 15.4842 12.8994Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1121_16916">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DateRangeIcon = () => {
  return (
    <svg
      className="3xl:w-[18px] 3xl:h-[18px]"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <g clipPath="url(#clip0_597_35468)">
        <path
          d="M9.5 2H9V1.5C9 1.225 8.775 1 8.5 1C8.225 1 8 1.225 8 1.5V2H4V1.5C4 1.225 3.775 1 3.5 1C3.225 1 3 1.225 3 1.5V2H2.5C1.945 2 1.505 2.45 1.505 3L1.5 10C1.5 10.55 1.945 11 2.5 11H9.5C10.05 11 10.5 10.55 10.5 10V3C10.5 2.45 10.05 2 9.5 2ZM9.5 9.5C9.5 9.775 9.275 10 9 10H3C2.725 10 2.5 9.775 2.5 9.5V4.5H9.5V9.5ZM3.5 5.5H4.5V6.5H3.5V5.5ZM5.5 5.5H6.5V6.5H5.5V5.5ZM7.5 5.5H8.5V6.5H7.5V5.5Z"
          fill="#929292"
        />
      </g>
      <defs>
        <clipPath id="clip0_597_35468">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.32138 13.4644H19.6785V15.5358H9.32138V13.4644ZM6.21423 9.32153H22.7857V11.393H6.21423V9.32153ZM12.4285 17.6072H16.5714V19.6787H12.4285V17.6072Z"
        fill="#6F6AF8"
      />
      <rect
        x="0.414286"
        y="0.414286"
        width="28.1714"
        height="28.1714"
        rx="14.0857"
        stroke="#6F6AF8"
        strokeWidth="0.828571"
      />
    </svg>
  );
};

export const AddContactIcon = () => {
  return (
    <svg
      className="w-[20px] h-[20px]"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none">
      <g clipPath="url(#clip0_597_35471)">
        <path
          className="group-hover:fill-white"
          d="M6.37496 6.66659H4.95829V5.33325C4.95829 4.96659 4.63954 4.66659 4.24996 4.66659C3.86038 4.66659 3.54163 4.96659 3.54163 5.33325V6.66659H2.12496C1.73538 6.66659 1.41663 6.96659 1.41663 7.33325C1.41663 7.69992 1.73538 7.99992 2.12496 7.99992H3.54163V9.33325C3.54163 9.69992 3.86038 9.99992 4.24996 9.99992C4.63954 9.99992 4.95829 9.69992 4.95829 9.33325V7.99992H6.37496C6.76454 7.99992 7.08329 7.69992 7.08329 7.33325C7.08329 6.96659 6.76454 6.66659 6.37496 6.66659ZM10.625 7.33325C11.8008 7.33325 12.7429 6.43992 12.7429 5.33325C12.7429 4.22659 11.8008 3.33325 10.625 3.33325C9.44913 3.33325 8.49996 4.22659 8.49996 5.33325C8.49996 6.43992 9.44913 7.33325 10.625 7.33325ZM10.625 8.66659C9.20829 8.66659 6.37496 9.33325 6.37496 10.6666V11.3333C6.37496 11.6999 6.69371 11.9999 7.08329 11.9999H14.1666C14.5562 11.9999 14.875 11.6999 14.875 11.3333V10.6666C14.875 9.33325 12.0416 8.66659 10.625 8.66659Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_597_35471">
          <rect width="17" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// FILTER-MODEL-ICON
export const FilterProspectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none">
      <g clipPath="url(#clip0_417_25891)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.2084 3.09469C7.11556 3.29527 6.20365 4.15018 5.89126 5.26695C5.7726 5.69124 5.77322 6.45127 5.89261 6.87847C5.99412 7.24165 6.2073 7.67257 6.42927 7.96327C6.98062 8.68535 7.93633 9.12434 8.84411 9.07255C9.29744 9.04665 9.55583 8.97677 9.97806 8.76579C10.713 8.39853 11.2468 7.75475 11.5028 6.92675C11.6069 6.58973 11.6341 5.84488 11.5563 5.45727C11.336 4.3598 10.537 3.4788 9.47799 3.16578C9.16922 3.07449 8.5172 3.038 8.2084 3.09469ZM16.1965 8.59982C15.8265 8.65474 15.3367 8.81559 14.9504 9.00903C13.7114 9.62945 12.8364 10.8316 12.59 12.2521C12.5217 12.6455 12.5297 13.4034 12.6065 13.8079C12.6874 14.2339 12.8546 14.7251 13.0355 15.068C13.1143 15.2173 13.1787 15.3538 13.1787 15.3714C13.1787 15.3889 13.0356 15.5211 12.8608 15.6653C12.3658 16.0731 12.4127 16.0505 12.3122 15.9301C12.2266 15.8276 12.2238 15.827 12.1259 15.8922C12.0321 15.9547 10.1505 17.2784 9.5574 17.6991C9.40651 17.8061 9.04438 18.0602 8.75266 18.2637C8.11662 18.7074 7.97718 18.8378 7.87352 19.0861C7.80852 19.2419 7.79714 19.329 7.80907 19.5802C7.82626 19.9425 7.90926 20.1449 8.14446 20.3978C8.38983 20.6617 8.59694 20.7501 8.97214 20.7512C9.38625 20.7525 9.43245 20.7217 10.3651 19.8208C11.0423 19.1668 12.8801 17.3859 13.1025 17.1681L13.1908 17.0816L13.0889 16.9439C13.0034 16.8284 12.995 16.7984 13.0371 16.7585C13.0874 16.7108 13.6742 16.2219 13.7489 16.1656C13.7729 16.1475 13.8823 16.2191 14.0233 16.345C14.5341 16.8013 15.1086 17.1119 15.7759 17.2925C16.2523 17.4215 17.1068 17.454 17.5865 17.3615C19.0683 17.0756 20.2647 16.0561 20.8177 14.608C21.0429 14.0183 21.0968 13.7006 21.0957 12.9683C21.0949 12.3821 21.0842 12.2662 20.9995 11.9277C20.7422 10.8992 20.133 9.97446 19.3192 9.37731C18.4357 8.72892 17.2743 8.43977 16.1965 8.59982ZM8.07854 9.71038C8.00835 9.78275 8.00839 9.77585 8.07752 10.2152C8.10946 10.4181 8.15916 10.601 8.19278 10.6393C8.24333 10.6969 8.31613 10.7066 8.69648 10.7066C8.99807 10.7066 9.16147 10.6912 9.20456 10.6587C9.29092 10.5937 9.3992 9.86892 9.34192 9.73936C9.3034 9.65225 9.29572 9.65116 8.71949 9.65116C8.23785 9.65116 8.12602 9.66149 8.07854 9.71038ZM17.8153 9.7956C18.9224 10.1792 19.7117 11.0538 19.9909 12.2065C20.0892 12.6121 20.0961 13.3027 20.0058 13.6934C19.7172 14.9428 18.8362 15.8946 17.6597 16.2281C17.3574 16.3138 16.6487 16.3448 16.3036 16.2874C15.2802 16.1172 14.3957 15.4364 13.926 14.4572C13.0192 12.5667 14.0239 10.2981 16.0142 9.74215C16.3108 9.6593 16.3981 9.65172 16.9098 9.66435C17.4275 9.67709 17.5062 9.68851 17.8153 9.7956ZM5.36909 9.98905C4.86419 10.1268 4.48896 10.3514 4.15576 10.7153C3.81148 11.0914 3.60419 11.4895 3.48315 12.0071C3.41833 12.2843 3.41258 12.4624 3.41237 14.2122L3.41211 16.1158L7.273 16.106C10.8461 16.097 11.1412 16.0914 11.2327 16.0316C11.287 15.9961 11.5412 15.8182 11.7974 15.6362C12.0536 15.4542 12.2774 15.3053 12.2947 15.3053C12.312 15.3053 12.3559 15.3393 12.3923 15.3807C12.474 15.4738 12.4781 15.4735 12.6059 15.3659L12.7097 15.2783L12.6194 15.0939C12.4978 14.8454 12.3168 14.2931 12.2439 13.9478C12.2111 13.7926 12.1754 13.4349 12.1645 13.1528C12.1315 12.2986 12.3011 11.5168 12.6848 10.7544L12.8789 10.3687L12.6905 10.2577C12.5868 10.1967 12.3703 10.0998 12.2094 10.0425C11.9473 9.9491 11.8557 9.93681 11.3315 9.92448L10.7462 9.91072L10.5879 10.205C10.5008 10.3669 10.2144 10.9022 9.95158 11.3945C9.68869 11.8869 9.46299 12.2898 9.44997 12.2898C9.43695 12.2898 9.39188 12.0606 9.34978 11.7806C9.30764 11.5005 9.25284 11.2461 9.22793 11.2151C9.19209 11.1707 9.08458 11.1589 8.71246 11.1589C8.13806 11.1589 8.16099 11.136 8.07291 11.7997C8.03849 12.0589 8.00045 12.2827 7.9883 12.2971C7.97616 12.3115 7.67815 11.7817 7.32608 11.1196L6.68594 9.91596L6.15554 9.91758C5.75954 9.91875 5.56026 9.93688 5.36909 9.98905ZM16.1416 12.7798V14.9284H16.8366H17.5317V12.7798V10.6312H16.8366H16.1416V12.7798ZM17.7847 11.4762C17.7763 11.4848 17.7738 12.2651 17.7793 13.2101L17.7892 14.9284H18.4834H19.1777V13.1944V11.4605H18.4888C18.1099 11.4605 17.793 11.4675 17.7847 11.4762ZM14.4956 13.4395V14.9284H15.1906H15.8856V13.4395V11.9505H15.1906H14.4956V13.4395Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_417_25891">
          <rect
            width="24.9333"
            height="23.4667"
            fill="white"
            transform="translate(0.520508 0.176025)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterTeamMemberIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M12.254 8.2424C13.0319 8.2424 13.778 7.93335 14.3281 7.38325C14.8783 6.83314 15.1873 6.08703 15.1873 5.30907C15.1873 4.5311 14.8783 3.78499 14.3281 3.23489C13.778 2.68478 13.0319 2.37573 12.254 2.37573C11.476 2.37573 10.7299 2.68478 10.1798 3.23489C9.62968 3.78499 9.32064 4.5311 9.32064 5.30907C9.32064 6.08703 9.62968 6.83314 10.1798 7.38325C10.7299 7.93335 11.476 8.2424 12.254 8.2424ZM7.85397 5.67573C7.85397 6.01279 7.78758 6.34655 7.6586 6.65795C7.52961 6.96936 7.34055 7.2523 7.10221 7.49064C6.86387 7.72898 6.58093 7.91804 6.26953 8.04702C5.95812 8.17601 5.62436 8.2424 5.2873 8.2424C4.95025 8.2424 4.61649 8.17601 4.30508 8.04702C3.99368 7.91804 3.71073 7.72898 3.4724 7.49064C3.23406 7.2523 3.045 6.96936 2.91601 6.65795C2.78703 6.34655 2.72064 6.01279 2.72064 5.67573C2.72064 4.99501 2.99105 4.34217 3.4724 3.86083C3.95374 3.37948 4.60658 3.10907 5.2873 3.10907C5.96803 3.10907 6.62087 3.37948 7.10221 3.86083C7.58356 4.34217 7.85397 4.99501 7.85397 5.67573ZM21.7873 5.67573C21.7873 6.01279 21.7209 6.34655 21.5919 6.65795C21.4629 6.96936 21.2739 7.2523 21.0355 7.49064C20.7972 7.72898 20.5143 7.91804 20.2029 8.04702C19.8915 8.17601 19.5577 8.2424 19.2206 8.2424C18.8836 8.2424 18.5498 8.17601 18.2384 8.04702C17.927 7.91804 17.6441 7.72898 17.4057 7.49064C17.1674 7.2523 16.9783 6.96936 16.8493 6.65795C16.7204 6.34655 16.654 6.01279 16.654 5.67573C16.654 4.99501 16.9244 4.34217 17.4057 3.86083C17.8871 3.37948 18.5399 3.10907 19.2206 3.10907C19.9014 3.10907 20.5542 3.37948 21.0355 3.86083C21.5169 4.34217 21.7873 4.99501 21.7873 5.67573ZM7.3971 9.70907C6.97981 10.2289 6.75287 10.8758 6.75397 11.5424V17.0424C6.75397 17.9481 6.9725 18.8024 7.36044 19.5555C6.80154 19.8494 6.17622 19.994 5.54505 19.9752C4.91388 19.9565 4.29825 19.775 3.7578 19.4485C3.21734 19.1219 2.77037 18.6613 2.46019 18.1113C2.15 17.5613 1.98712 16.9405 1.9873 16.3091V11.5424C1.9873 11.0562 2.18046 10.5899 2.52428 10.246C2.86809 9.90222 3.33441 9.70907 3.82064 9.70907H7.3971ZM17.1475 19.5555C17.5473 18.7782 17.7553 17.9165 17.754 17.0424V11.5424C17.754 10.8487 17.5134 10.2114 17.1108 9.70907H20.6873C21.1735 9.70907 21.6398 9.90222 21.9837 10.246C22.3275 10.5899 22.5206 11.0562 22.5206 11.5424V16.3091C22.5208 16.9405 22.3579 17.5613 22.0478 18.1113C21.7376 18.6613 21.2906 19.1219 20.7501 19.4485C20.2097 19.775 19.5941 19.9565 18.9629 19.9752C18.3317 19.994 17.7064 19.8494 17.1475 19.5555ZM9.6873 9.70907C9.20107 9.70907 8.73476 9.90222 8.39094 10.246C8.04713 10.5899 7.85397 11.0562 7.85397 11.5424V17.0424C7.85397 18.2094 8.31754 19.3285 9.1427 20.1537C9.96786 20.9788 11.087 21.4424 12.254 21.4424C13.4209 21.4424 14.5401 20.9788 15.3652 20.1537C16.1904 19.3285 16.654 18.2094 16.654 17.0424V11.5424C16.654 11.0562 16.4608 10.5899 16.117 10.246C15.7732 9.90222 15.3069 9.70907 14.8206 9.70907H9.6873Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};

export const FilterAddContactTypesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M12.2554 1.64282C9.54232 1.67556 6.94956 2.76788 5.03096 4.68648C3.11236 6.60508 2.02004 9.19784 1.9873 11.9109C2.02004 14.6241 3.11236 17.2168 5.03096 19.1354C6.94956 21.054 9.54232 22.1463 12.2554 22.1791C14.9685 22.1463 17.5613 21.054 19.4799 19.1354C21.3985 17.2168 22.4908 14.6241 22.5236 11.9109C22.4908 9.19784 21.3985 6.60508 19.4799 4.68648C17.5613 2.76788 14.9685 1.67556 12.2554 1.64282ZM18.1229 12.6444H12.9889V17.7784H11.522V12.6444H6.38793V11.1775H11.522V6.04345H12.9889V11.1775H18.1229V12.6444Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};

export const StatusLevelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="13"
      viewBox="0 0 24 13"
      fill="none">
      <g clipPath="url(#clip0_1395_3577)">
        <path
          d="M5.51798 8.75758C4.88095 9.85841 4.51641 11.1366 4.51641 12.5H0C0 10.3139 0.584633 8.26438 1.60596 6.49902L4.54019 7.32556L5.51798 8.75758Z"
          fill="#E82D48"
        />
        <path
          d="M9.43987 5.46589C7.77843 6.07068 6.39184 7.24722 5.51798 8.75764L1.60596 6.49908C3.00716 4.07725 5.23064 2.19051 7.8946 1.2207L9.21797 2.9829L9.43987 5.46581V5.46589Z"
          fill="#EDA635"
        />
        <path
          d="M16.1053 1.22072V3.58762L14.5601 5.46583C13.7615 5.17493 12.8993 5.01633 12 5.01633C11.1007 5.01633 10.2385 5.17493 9.43988 5.46583L7.89453 1.22072C9.17538 0.754384 10.5579 0.5 11.9999 0.5C13.4419 0.5 14.8245 0.754384 16.1053 1.22072Z"
          fill="#EFD933"
        />
        <path
          d="M22.3941 6.49908L20.7908 8.6244L18.4822 8.75764C17.6083 7.24722 16.2217 6.07068 14.5603 5.46589L16.1055 1.2207C18.7695 2.19051 20.9929 4.07725 22.3941 6.499V6.49908Z"
          fill="#1BA5ED"
        />
        <path
          d="M23.9999 12.5H19.4835C19.4835 11.1367 19.119 9.85849 18.4819 8.75758L22.394 6.49902C23.4154 8.26438 23.9999 10.3139 23.9999 12.5Z"
          fill="#3FD14A"
        />
        <path
          d="M6.80103 12.4526C6.80103 9.53308 9.16777 7.16626 12.0874 7.16626C15.007 7.16626 17.3737 9.53301 17.3737 12.4526"
          fill="#A6A9B2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1395_3577">
          <rect
            width="24"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WorkflowItemRightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M14.8299 11.2899L10.5899 7.04995C10.497 6.95622 10.3864 6.88183 10.2645 6.83106C10.1427 6.78029 10.012 6.75415 9.87994 6.75415C9.74793 6.75415 9.61723 6.78029 9.49537 6.83106C9.37351 6.88183 9.26291 6.95622 9.16994 7.04995C8.98369 7.23731 8.87915 7.49076 8.87915 7.75495C8.87915 8.01913 8.98369 8.27259 9.16994 8.45995L12.7099 11.9999L9.16994 15.5399C8.98369 15.7273 8.87915 15.9808 8.87915 16.2449C8.87915 16.5091 8.98369 16.7626 9.16994 16.9499C9.26338 17.0426 9.3742 17.116 9.49604 17.1657C9.61787 17.2155 9.74834 17.2407 9.87994 17.2399C10.0115 17.2407 10.142 17.2155 10.2638 17.1657C10.3857 17.116 10.4965 17.0426 10.5899 16.9499L14.8299 12.7099C14.9237 12.617 14.9981 12.5064 15.0488 12.3845C15.0996 12.2627 15.1257 12.132 15.1257 11.9999C15.1257 11.8679 15.0996 11.7372 15.0488 11.6154C14.9981 11.4935 14.9237 11.3829 14.8299 11.2899Z"
        fill="black"
      />
    </svg>
  );
};

export const MarkCompletedIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.808594"
        y="0.780029"
        width="18"
        height="18"
        rx="4"
        fill="white"
      />
      <path
        d="M12.5021 6.66592C12.3777 6.59672 12.2409 6.55272 12.0996 6.53642C11.9582 6.52012 11.815 6.53186 11.6781 6.57094C11.5413 6.61003 11.4135 6.67571 11.3021 6.76423C11.1906 6.85274 11.0978 6.96235 11.0287 7.08679L9.01751 10.7062L7.86647 9.55517C7.76653 9.4517 7.64699 9.36917 7.51482 9.31239C7.38265 9.25561 7.2405 9.22573 7.09665 9.22448C6.95281 9.22323 6.81016 9.25064 6.67702 9.30511C6.54388 9.35958 6.42292 9.44002 6.32121 9.54174C6.21949 9.64346 6.13905 9.76441 6.08458 9.89755C6.03011 10.0307 6.0027 10.1733 6.00395 10.3172C6.0052 10.461 6.03508 10.6032 6.09186 10.7354C6.14864 10.8675 6.23117 10.9871 6.33464 11.087L8.5013 13.2537C8.70605 13.459 8.9823 13.5716 9.26722 13.5716L9.41726 13.5608C9.58331 13.5376 9.7417 13.4761 9.87996 13.3813C10.0182 13.2864 10.1326 13.1608 10.2141 13.0143L12.9224 8.13925C12.9915 8.01491 13.0355 7.87817 13.0518 7.73684C13.0681 7.5955 13.0564 7.45234 13.0174 7.31553C12.9783 7.17871 12.9127 7.05093 12.8243 6.93947C12.7359 6.82801 12.6264 6.73505 12.5021 6.66592Z"
        fill="#929292"
      />
      <rect
        x="1.15235"
        y="1.12379"
        width="17.3125"
        height="17.3125"
        rx="3.65624"
        stroke="black"
        stroke-opacity="0.3"
        strokeWidth="0.687513"
      />
    </svg>
  );
};
export const LeftArrow = () => {
  return (
    <svg
      className=""
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="1">
        <path
          className=""
          d="M12.1347 5.74487L13.4255 7.03568L9.50649 10.9547L13.4255 14.8737L12.1347 16.1645L6.92487 10.9547L12.1347 5.74487Z"
          fill="#6F6AF8"
        />
      </g>
    </svg>
  );
};
export const BlogRightArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 18L15 12L9 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BlogLeftArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 18L9 12L15 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftgrayArrow = () => {
  return (
    <svg
      className=""
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.">
        <path
          className=""
          d="M12.1347 5.74487L13.4255 7.03568L9.50649 10.9547L13.4255 14.8737L12.1347 16.1645L6.92487 10.9547L12.1347 5.74487Z"
          fill="black"
          fillOpacity="0.9"
        />
      </g>
    </svg>
  );
};
export const RightgrayArrow = () => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path
          d="M10.0267 17.2277L8.71584 15.9573L12.5729 11.9773L8.59289 8.12031L9.86329 6.80941L15.1542 11.9368L10.0267 17.2277Z"
          fill="black"
          fillOpacity="0.9"
        />
      </g>
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6834 5.74463L9.39264 7.03544L13.3116 10.9544L9.39264 14.8734L10.6834 16.1642L15.8932 10.9544L10.6834 5.74463Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};
// ================================ MY TEAM ICONS =========================================
export const ClaenderIcon = () => {
  return (
    <svg
      className=" w-[15px] h-[15px] 2xl:w-[17px] 2xl:h-[17px]"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none">
      <g clipPath="url(#clip0_1608_7954)">
        <path
          className="fill-[#929292]"
          d="M5 7.91675C5.08241 7.91675 5.16297 7.89231 5.23149 7.84653C5.30001 7.80074 5.35342 7.73567 5.38495 7.65953C5.41649 7.5834 5.42474 7.49962 5.40866 7.41879C5.39259 7.33797 5.3529 7.26372 5.29463 7.20545C5.23636 7.14718 5.16212 7.1075 5.08129 7.09142C5.00046 7.07534 4.91669 7.08359 4.84055 7.11513C4.76442 7.14667 4.69934 7.20007 4.65356 7.26859C4.60777 7.33711 4.58334 7.41767 4.58334 7.50008C4.58334 7.61059 4.62723 7.71657 4.70537 7.79471C4.78352 7.87285 4.8895 7.91675 5 7.91675ZM7.08334 7.91675C7.16575 7.91675 7.2463 7.89231 7.31482 7.84653C7.38334 7.80074 7.43675 7.73567 7.46829 7.65953C7.49982 7.5834 7.50807 7.49962 7.492 7.41879C7.47592 7.33797 7.43624 7.26372 7.37796 7.20545C7.31969 7.14718 7.24545 7.1075 7.16462 7.09142C7.0838 7.07534 7.00002 7.08359 6.92388 7.11513C6.84775 7.14667 6.78267 7.20007 6.73689 7.26859C6.69111 7.33711 6.66667 7.41767 6.66667 7.50008C6.66667 7.61059 6.71057 7.71657 6.78871 7.79471C6.86685 7.87285 6.97283 7.91675 7.08334 7.91675ZM7.08334 6.25008C7.16575 6.25008 7.2463 6.22564 7.31482 6.17986C7.38334 6.13408 7.43675 6.069 7.46829 5.99287C7.49982 5.91673 7.50807 5.83295 7.492 5.75213C7.47592 5.6713 7.43624 5.59706 7.37796 5.53879C7.31969 5.48051 7.24545 5.44083 7.16462 5.42475C7.0838 5.40868 7.00002 5.41693 6.92388 5.44846C6.84775 5.48 6.78267 5.53341 6.73689 5.60193C6.69111 5.67045 6.66667 5.75101 6.66667 5.83341C6.66667 5.94392 6.71057 6.0499 6.78871 6.12804C6.86685 6.20618 6.97283 6.25008 7.08334 6.25008ZM5 6.25008C5.08241 6.25008 5.16297 6.22564 5.23149 6.17986C5.30001 6.13408 5.35342 6.069 5.38495 5.99287C5.41649 5.91673 5.42474 5.83295 5.40866 5.75213C5.39259 5.6713 5.3529 5.59706 5.29463 5.53879C5.23636 5.48051 5.16212 5.44083 5.08129 5.42475C5.00046 5.40868 4.91669 5.41693 4.84055 5.44846C4.76442 5.48 4.69934 5.53341 4.65356 5.60193C4.60777 5.67045 4.58334 5.75101 4.58334 5.83341C4.58334 5.94392 4.62723 6.0499 4.70537 6.12804C4.78352 6.20618 4.8895 6.25008 5 6.25008ZM7.91667 1.25008H7.5V0.833415C7.5 0.722908 7.4561 0.616927 7.37796 0.538787C7.29982 0.460647 7.19384 0.416748 7.08334 0.416748C6.97283 0.416748 6.86685 0.460647 6.78871 0.538787C6.71057 0.616927 6.66667 0.722908 6.66667 0.833415V1.25008H3.33334V0.833415C3.33334 0.722908 3.28944 0.616927 3.2113 0.538787C3.13316 0.460647 3.02718 0.416748 2.91667 0.416748C2.80616 0.416748 2.70018 0.460647 2.62204 0.538787C2.5439 0.616927 2.5 0.722908 2.5 0.833415V1.25008H2.08334C1.75182 1.25008 1.43387 1.38178 1.19945 1.6162C0.965032 1.85062 0.833336 2.16856 0.833336 2.50008V8.33341C0.833336 8.66493 0.965032 8.98288 1.19945 9.2173C1.43387 9.45172 1.75182 9.58341 2.08334 9.58341H7.91667C8.24819 9.58341 8.56613 9.45172 8.80055 9.2173C9.03497 8.98288 9.16667 8.66493 9.16667 8.33341V2.50008C9.16667 2.16856 9.03497 1.85062 8.80055 1.6162C8.56613 1.38178 8.24819 1.25008 7.91667 1.25008ZM8.33334 8.33341C8.33334 8.44392 8.28944 8.5499 8.2113 8.62804C8.13316 8.70618 8.02718 8.75008 7.91667 8.75008H2.08334C1.97283 8.75008 1.86685 8.70618 1.78871 8.62804C1.71057 8.5499 1.66667 8.44392 1.66667 8.33341V4.58341H8.33334V8.33341ZM8.33334 3.75008H1.66667V2.50008C1.66667 2.38957 1.71057 2.28359 1.78871 2.20545C1.86685 2.12731 1.97283 2.08341 2.08334 2.08341H2.5V2.50008C2.5 2.61059 2.5439 2.71657 2.62204 2.79471C2.70018 2.87285 2.80616 2.91675 2.91667 2.91675C3.02718 2.91675 3.13316 2.87285 3.2113 2.79471C3.28944 2.71657 3.33334 2.61059 3.33334 2.50008V2.08341H6.66667V2.50008C6.66667 2.61059 6.71057 2.71657 6.78871 2.79471C6.86685 2.87285 6.97283 2.91675 7.08334 2.91675C7.19384 2.91675 7.29982 2.87285 7.37796 2.79471C7.4561 2.71657 7.5 2.61059 7.5 2.50008V2.08341H7.91667C8.02718 2.08341 8.13316 2.12731 8.2113 2.20545C8.28944 2.28359 8.33334 2.38957 8.33334 2.50008V3.75008ZM2.91667 6.25008C2.99908 6.25008 3.07964 6.22564 3.14816 6.17986C3.21668 6.13408 3.27008 6.069 3.30162 5.99287C3.33316 5.91673 3.34141 5.83295 3.32533 5.75213C3.30925 5.6713 3.26957 5.59706 3.2113 5.53879C3.15303 5.48051 3.07878 5.44083 2.99796 5.42475C2.91713 5.40868 2.83335 5.41693 2.75722 5.44846C2.68108 5.48 2.61601 5.53341 2.57022 5.60193C2.52444 5.67045 2.5 5.75101 2.5 5.83341C2.5 5.94392 2.5439 6.0499 2.62204 6.12804C2.70018 6.20618 2.80616 6.25008 2.91667 6.25008ZM2.91667 7.91675C2.99908 7.91675 3.07964 7.89231 3.14816 7.84653C3.21668 7.80074 3.27008 7.73567 3.30162 7.65953C3.33316 7.5834 3.34141 7.49962 3.32533 7.41879C3.30925 7.33797 3.26957 7.26372 3.2113 7.20545C3.15303 7.14718 3.07878 7.1075 2.99796 7.09142C2.91713 7.07534 2.83335 7.08359 2.75722 7.11513C2.68108 7.14667 2.61601 7.20007 2.57022 7.26859C2.52444 7.33711 2.5 7.41767 2.5 7.50008C2.5 7.61059 2.5439 7.71657 2.62204 7.79471C2.70018 7.87285 2.80616 7.91675 2.91667 7.91675Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1608_7954">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MembersIcon = () => {
  return (
    <svg
      className=""
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none">
      <g clipPath="url(#clip0_1608_7946)">
        <path
          className="group-hover:fill-white"
          d="M7.5 1.16675C4.28 1.16675 1.66667 3.78008 1.66667 7.00008C1.66667 10.2201 4.28 12.8334 7.5 12.8334C10.72 12.8334 13.3333 10.2201 13.3333 7.00008C13.3333 3.78008 10.72 1.16675 7.5 1.16675ZM9.60584 4.86508C10.23 4.86508 10.7317 5.36675 10.7317 5.99091C10.7317 6.61508 10.23 7.11675 9.60584 7.11675C8.98167 7.11675 8.48001 6.61508 8.48001 5.99091C8.47417 5.36675 8.98167 4.86508 9.60584 4.86508ZM6.10584 3.94341C6.86417 3.94341 7.4825 4.56175 7.4825 5.32008C7.4825 6.07841 6.86417 6.69675 6.10584 6.69675C5.3475 6.69675 4.72917 6.07841 4.72917 5.32008C4.72917 4.55591 5.34167 3.94341 6.10584 3.94341ZM6.10584 9.26925V11.4567C4.70584 11.0192 3.5975 9.94008 3.1075 8.56341C3.72 7.91008 5.24834 7.57758 6.10584 7.57758C6.415 7.57758 6.80584 7.62425 7.21417 7.70591C6.2575 8.21341 6.10584 8.88425 6.10584 9.26925ZM7.5 11.6667C7.3425 11.6667 7.19084 11.6609 7.03917 11.6434V9.26925C7.03917 8.44091 8.75417 8.02675 9.60584 8.02675C10.23 8.02675 11.3092 8.25425 11.8458 8.69758C11.1633 10.4301 9.4775 11.6667 7.5 11.6667Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1608_7946">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DropDownIcon = () => {
  return (
    <svg
      className=" xl:w-[10px] xl:h-[10px]"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none">
      <path
        d="M4.86602 6C4.48112 6.66667 3.51887 6.66667 3.13397 6L0.968911 2.25C0.584011 1.58333 1.06514 0.749999 1.83494 0.749999L6.16507 0.75C6.93487 0.75 7.41599 1.58333 7.03109 2.25L4.86602 6Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};
export const DropDownGrayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g opacity="0.4">
        <path
          d="M14.1667 8.33333L10 12.5L5.83337 8.33333"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const DropDownwhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none">
      <g>
        <path
          d="M14.1667 8.33333L10 12.5L5.83337 8.33333"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const MediaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none">
      <path
        d="M11.0922 13.1692L7.83984 16.4216C7.64748 16.6147 7.41888 16.768 7.16714 16.8725C6.91541 16.9771 6.64552 17.0309 6.37293 17.0309C6.10035 17.0309 5.83045 16.9771 5.57872 16.8725C5.32699 16.768 5.09839 16.6147 4.90602 16.4216C4.71189 16.2298 4.55775 16.0014 4.45256 15.7496C4.34736 15.4978 4.29319 15.2276 4.29319 14.9547C4.29319 14.6818 4.34736 14.4116 4.45256 14.1598C4.55775 13.908 4.71189 13.6796 4.90602 13.4878L8.15837 10.2354C8.31622 10.0776 8.40489 9.8635 8.40489 9.64028C8.40489 9.41705 8.31622 9.20297 8.15837 9.04513C8.00053 8.88729 7.78645 8.79861 7.56323 8.79861C7.34 8.79861 7.12592 8.88729 6.96808 9.04513L3.71573 12.3059C3.06053 13.019 2.70617 13.9577 2.72667 14.926C2.74717 15.8942 3.14093 16.8171 3.82573 17.5019C4.51053 18.1867 5.43341 18.5804 6.40164 18.6009C7.36987 18.6214 8.30859 18.2671 9.02176 17.6119L12.2825 14.3595C12.4403 14.2017 12.529 13.9876 12.529 13.7644C12.529 13.5412 12.4403 13.3271 12.2825 13.1692C12.1246 13.0114 11.9106 12.9227 11.6873 12.9227C11.4641 12.9227 11.25 13.0114 11.0922 13.1692ZM8.34279 12.9848C8.42111 13.0625 8.514 13.124 8.61613 13.1657C8.71826 13.2074 8.82762 13.2286 8.93793 13.2279C9.04825 13.2286 9.15761 13.2074 9.25974 13.1657C9.36187 13.124 9.45476 13.0625 9.53308 12.9848L13.6572 8.86072C13.815 8.70287 13.9037 8.48879 13.9037 8.26557C13.9037 8.04235 13.815 7.82827 13.6572 7.67042C13.4994 7.51258 13.2853 7.4239 13.062 7.4239C12.8388 7.4239 12.6247 7.51258 12.4669 7.67042L8.34279 11.7945C8.26422 11.8725 8.20186 11.9652 8.1593 12.0673C8.11675 12.1695 8.09484 12.279 8.09484 12.3897C8.09484 12.5003 8.11675 12.6099 8.1593 12.7121C8.20186 12.8142 8.26422 12.9069 8.34279 12.9848ZM18.5441 15.357H17.7059V14.5188C17.7059 14.2965 17.6176 14.0833 17.4604 13.9261C17.3032 13.7689 17.09 13.6806 16.8676 13.6806C16.6453 13.6806 16.4321 13.7689 16.2749 13.9261C16.1177 14.0833 16.0294 14.2965 16.0294 14.5188V15.357H15.1912C14.9689 15.357 14.7556 15.4454 14.5984 15.6026C14.4412 15.7598 14.3529 15.973 14.3529 16.1953C14.3529 16.4176 14.4412 16.6308 14.5984 16.788C14.7556 16.9452 14.9689 17.0335 15.1912 17.0335H16.0294V17.8717C16.0294 18.0941 16.1177 18.3073 16.2749 18.4645C16.4321 18.6217 16.6453 18.71 16.8676 18.71C17.09 18.71 17.3032 18.6217 17.4604 18.4645C17.6176 18.3073 17.7059 18.0941 17.7059 17.8717V17.0335H18.5441C18.7664 17.0335 18.9796 16.9452 19.1368 16.788C19.294 16.6308 19.3823 16.4176 19.3823 16.1953C19.3823 15.973 19.294 15.7598 19.1368 15.6026C18.9796 15.4454 18.7664 15.357 18.5441 15.357ZM15.0319 11.6101L18.2843 8.34939C18.9395 7.63623 19.2938 6.69751 19.2733 5.72928C19.2528 4.76104 18.859 3.83816 18.1743 3.15337C17.4895 2.46857 16.5666 2.07481 15.5983 2.05431C14.6301 2.03381 13.6914 2.38816 12.9782 3.04336L9.71749 6.29572C9.63934 6.37387 9.57734 6.46666 9.53504 6.56877C9.49274 6.67089 9.47097 6.78033 9.47097 6.89086C9.47097 7.00139 9.49274 7.11084 9.53504 7.21295C9.57734 7.31507 9.63934 7.40785 9.71749 7.48601C9.79565 7.56417 9.88843 7.62616 9.99055 7.66846C10.0927 7.71076 10.2021 7.73253 10.3126 7.73253C10.4232 7.73253 10.5326 7.71076 10.6347 7.66846C10.7368 7.62616 10.8296 7.56417 10.9078 7.48601L14.1601 4.23366C14.3525 4.04053 14.5811 3.88729 14.8328 3.78273C15.0846 3.67817 15.3545 3.62435 15.6271 3.62435C15.8996 3.62435 16.1695 3.67817 16.4213 3.78273C16.673 3.88729 16.9016 4.04053 17.094 4.23366C17.2881 4.42545 17.4422 4.65387 17.5474 4.90568C17.6526 5.15749 17.7068 5.42767 17.7068 5.70057C17.7068 5.97347 17.6526 6.24365 17.5474 6.49546C17.4422 6.74727 17.2881 6.97569 17.094 7.16748L13.8416 10.4198C13.763 10.4978 13.7007 10.5905 13.6581 10.6926C13.6156 10.7948 13.5937 10.9043 13.5937 11.015C13.5937 11.1256 13.6156 11.2352 13.6581 11.3373C13.7007 11.4395 13.763 11.5322 13.8416 11.6101C13.9195 11.6887 14.0122 11.7511 14.1144 11.7936C14.2165 11.8362 14.3261 11.8581 14.4368 11.8581C14.5474 11.8581 14.657 11.8362 14.7591 11.7936C14.8613 11.7511 14.954 11.6887 15.0319 11.6101Z"
        fill="black"
      />
    </svg>
  );
};
export const TeamSettingIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="19" cy="19" r="19" fill="#F2F2FE" />
      <path
        d="M19.0027 16.4577C18.5087 16.4577 18.0462 16.6522 17.696 17.0076C17.3474 17.363 17.1541 17.8324 17.1541 18.3337C17.1541 18.835 17.3474 19.3044 17.696 19.6598C18.0462 20.0135 18.5087 20.2097 19.0027 20.2097C19.4966 20.2097 19.9592 20.0135 20.3094 19.6598C20.658 19.3044 20.8513 18.835 20.8513 18.3337C20.8513 17.8324 20.658 17.363 20.3094 17.0076C20.1384 16.8327 19.9348 16.694 19.7104 16.5996C19.4861 16.5052 19.2455 16.457 19.0027 16.4577ZM25.8139 20.4058L24.7335 19.4687C24.7847 19.1502 24.8111 18.8249 24.8111 18.5014C24.8111 18.1778 24.7847 17.8509 24.7335 17.534L25.8139 16.5969C25.8955 16.526 25.9539 16.4316 25.9814 16.3261C26.0088 16.2207 26.004 16.1093 25.9675 16.0068L25.9527 15.9632C25.6553 15.1194 25.2098 14.3373 24.6377 13.6547L24.6079 13.6195C24.5385 13.5366 24.4459 13.477 24.3423 13.4486C24.2388 13.4201 24.1293 13.4242 24.0281 13.4602L22.6867 13.9447C22.191 13.5323 21.6393 13.2071 21.0413 12.9807L20.7819 11.5574C20.7623 11.4502 20.7111 11.3516 20.6349 11.2746C20.5588 11.1976 20.4614 11.146 20.3557 11.1266L20.3111 11.1182C19.452 10.9606 18.5467 10.9606 17.6877 11.1182L17.6431 11.1266C17.5374 11.146 17.44 11.1976 17.3638 11.2746C17.2877 11.3516 17.2364 11.4502 17.2169 11.5574L16.9559 12.9875C16.3635 13.2156 15.8117 13.54 15.322 13.9481L13.9707 13.4602C13.8695 13.4239 13.7599 13.4197 13.6563 13.4481C13.5527 13.4766 13.4601 13.5364 13.3908 13.6195L13.3611 13.6547C12.79 14.338 12.3446 15.1199 12.0461 15.9632L12.0312 16.0068C11.9569 16.2163 12.018 16.451 12.1849 16.5969L13.2785 17.5441C13.2273 17.8593 13.2025 18.1812 13.2025 18.4997C13.2025 18.8216 13.2273 19.1434 13.2785 19.4553L12.1882 20.4025C12.1066 20.4734 12.0482 20.5678 12.0207 20.6732C11.9933 20.7786 11.9981 20.89 12.0345 20.9926L12.0494 21.0362C12.3484 21.8794 12.7895 22.659 13.3644 23.3447L13.3941 23.3799C13.4636 23.4628 13.5562 23.5224 13.6597 23.5508C13.7632 23.5792 13.8728 23.5752 13.974 23.5391L15.3253 23.0513C15.8176 23.462 16.3661 23.7873 16.9592 24.0119L17.2202 25.4419C17.2397 25.5492 17.291 25.6478 17.3671 25.7248C17.4433 25.8017 17.5407 25.8533 17.6464 25.8728L17.691 25.8812C18.5585 26.0396 19.4469 26.0396 20.3144 25.8812L20.359 25.8728C20.4647 25.8533 20.5621 25.8017 20.6382 25.7248C20.7144 25.6478 20.7656 25.5492 20.7852 25.4419L21.0446 24.0186C21.6426 23.7906 22.1944 23.4671 22.69 23.0546L24.0314 23.5391C24.1325 23.5755 24.2422 23.5797 24.3458 23.5512C24.4493 23.5228 24.5419 23.463 24.6112 23.3799L24.641 23.3447C25.2159 22.6556 25.6569 21.8794 25.956 21.0362L25.9708 20.9926C26.0419 20.7847 25.9807 20.5517 25.8139 20.4058ZM19.0027 21.2809C17.3986 21.2809 16.0985 19.9616 16.0985 18.3337C16.0985 16.7059 17.3986 15.3865 19.0027 15.3865C20.6068 15.3865 21.9069 16.7059 21.9069 18.3337C21.9069 19.9616 20.6068 21.2809 19.0027 21.2809Z"
        fill="black"
      />
    </svg>
  );
};

export const MarkCompleteCrossIcon = () => {
  return (
    <svg
      className=" 3xl:w-[24px] 3xl:h-[24px]"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <g opacity="0.7">
        <path
          d="M11.25 4.75L4.75 11.25M4.75 4.75L11.25 11.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const UploadFileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none">
      <g opacity="0.2" clipPath="url(#clip0_1157_17418)">
        <path
          d="M24.4391 19.926V33.028C24.4397 33.5846 24.6528 34.1199 25.0349 34.5246C25.417 34.9294 25.9391 35.1729 26.4948 35.2055C27.0504 35.2381 27.5975 35.0574 28.0243 34.7001C28.4511 34.3429 28.7254 33.8362 28.7911 33.2835L28.8064 33.028V19.926H41.9084C43.0102 19.9257 44.0715 20.3418 44.8794 21.091C45.6873 21.8402 46.1822 22.8671 46.2648 23.9658L46.2757 24.2934V43.9464C46.2761 45.0482 45.86 46.1094 45.1108 46.9174C44.3616 47.7253 43.3347 48.2201 42.236 48.3028L41.9084 48.3137H11.3371C10.2352 48.314 9.17399 47.8979 8.36608 47.1487C7.55816 46.3995 7.06328 45.3726 6.98065 44.2739L6.96973 43.9464V24.2934C6.96938 23.1915 7.38551 22.1303 8.13471 21.3224C8.8839 20.5145 9.91079 20.0196 11.0095 19.9369L11.3371 19.926H24.4391ZM28.5531 5.66448L35.888 12.9972C36.2978 13.407 36.528 13.9627 36.528 14.5422C36.528 15.1217 36.2978 15.6774 35.888 16.0871C35.4783 16.4969 34.9226 16.7271 34.3431 16.7271C33.7636 16.7271 33.2079 16.4969 32.7982 16.0871L28.8064 12.0932V19.926H24.4391V12.0932L20.4473 16.0871C20.2444 16.29 20.0036 16.451 19.7385 16.5608C19.4734 16.6706 19.1893 16.7271 18.9024 16.7271C18.6155 16.7271 18.3313 16.6706 18.0663 16.5608C17.8012 16.451 17.5603 16.29 17.3574 16.0871C17.1545 15.8842 16.9936 15.6434 16.8838 15.3783C16.774 15.1132 16.7175 14.8291 16.7175 14.5422C16.7175 14.2553 16.774 13.9712 16.8838 13.7061C16.9936 13.441 17.1545 13.2001 17.3574 12.9972L24.6946 5.66448C25.2064 5.1531 25.9003 4.86584 26.6238 4.86584C27.3473 4.86584 28.0413 5.1531 28.5531 5.66448Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1157_17418">
          <rect
            width="52.408"
            height="52.408"
            fill="white"
            transform="translate(0.419922 0.272827)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// ============= TODAY WORKFLOW ITEM PROFILE PAGE ICON
export const ProfileEditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" fill="none">
      <path
        d="M2.07227 12.0623V14.1626C2.07227 14.356 2.22426 14.508 2.4177 14.508H4.51796C4.60778 14.508 4.69759 14.4735 4.75977 14.4044L12.3041 6.86696L9.71335 4.27618L2.1759 11.8136C2.10681 11.8827 2.07227 11.9656 2.07227 12.0623ZM14.3077 4.86342C14.5771 4.59398 14.5771 4.15873 14.3077 3.88929L12.691 2.27264C12.4216 2.0032 11.9863 2.0032 11.7169 2.27264L10.4526 3.53694L13.0434 6.12772L14.3077 4.86342Z"
        fill="#8536EA"
      />
    </svg>
  );
};
export const AlertCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none">
      <g clipPath="url(#clip0_469_36511)">
        <path
          d="M8.15495 1.66089C4.47495 1.66089 1.48828 4.64756 1.48828 8.32755C1.48828 12.0076 4.47495 14.9942 8.15495 14.9942C11.8349 14.9942 14.8216 12.0076 14.8216 8.32755C14.8216 4.64756 11.8349 1.66089 8.15495 1.66089ZM8.15495 11.6609C7.78828 11.6609 7.48828 11.3609 7.48828 10.9942V8.32755C7.48828 7.96089 7.78828 7.66089 8.15495 7.66089C8.52161 7.66089 8.82161 7.96089 8.82161 8.32755V10.9942C8.82161 11.3609 8.52161 11.6609 8.15495 11.6609ZM8.82161 6.32756H7.48828V4.99422H8.82161V6.32756Z"
          fill="#929292"
        />
      </g>
      <defs>
        <clipPath id="clip0_469_36511">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.155273 0.327637)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ConnectedAddNewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none">
      <path
        d="M10.1553 1.57764C7.84329 1.60553 5.63387 2.53636 3.99893 4.17129C2.36399 5.80623 1.43317 8.01566 1.40527 10.3276C1.43317 12.6396 2.36399 14.849 3.99893 16.484C5.63387 18.1189 7.84329 19.0497 10.1553 19.0776C12.4673 19.0497 14.6767 18.1189 16.3116 16.484C17.9466 14.849 18.8774 12.6396 18.9053 10.3276C18.8774 8.01566 17.9466 5.80623 16.3116 4.17129C14.6767 2.53636 12.4673 1.60553 10.1553 1.57764ZM15.1553 10.9526H10.7803V15.3276H9.53027V10.9526H5.15527V9.70264H9.53027V5.32764H10.7803V9.70264H15.1553V10.9526Z"
        fill="url(#paint0_linear_469_36521)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_469_36521"
          x1="1.40527"
          y1="10.3276"
          x2="18.9053"
          y2="10.3276"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#16D9E3" />
          <stop offset="0.47" stop-color="#30C7EC" />
          <stop offset="1" stop-color="#46AEF7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const StoryBookIcon = () => {
  return (
    <svg
      className=" 3xl:w-[19px] 3xl:h-[19px]"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.63101 0.132567C1.32987 0.216151 1.10998 0.39943 0.981505 0.673929L0.897461 0.853465V5.60015V10.3468L0.975576 10.5115C1.07666 10.7246 1.24091 10.8896 1.44936 10.9874L1.61604 11.0656L5.03879 11.0735L8.46158 11.0813L8.63637 11.0107C8.85356 10.9229 8.96327 10.8357 9.0827 10.6558C9.248 10.4069 9.26594 10.2703 9.26594 9.26052V8.35152L9.51424 8.06142C9.7938 7.73487 10.4141 6.99981 10.8836 6.43868C11.0559 6.23279 11.2046 6.0576 11.2141 6.04936C11.3052 5.97027 11.7322 5.41382 11.7849 5.30547C11.8888 5.09182 11.8826 4.71706 11.7714 4.48727C11.6104 4.15476 11.2682 3.94103 10.8954 3.94019C10.7162 3.9398 10.6529 3.95477 10.4856 4.03716C10.2766 4.14009 10.2471 4.16989 9.58032 4.95322L9.28091 5.30496L9.26543 3.66317C9.24896 1.91633 9.25172 1.94877 9.09785 1.7026C9.02063 1.57909 7.76752 0.38763 7.58419 0.263438C7.32143 0.0854298 7.39691 0.0895627 4.45582 0.0924676C2.40388 0.094534 1.7338 0.104027 1.63101 0.132567ZM6.6612 1.60964C6.66129 2.38741 6.66512 2.44697 6.72108 2.53876C6.75396 2.5927 6.81543 2.64999 6.85767 2.66604C6.90088 2.68248 7.29996 2.69524 7.77084 2.69524H8.60724V4.39952V6.10381L8.25543 6.52038C8.06196 6.74951 7.80288 7.05734 7.67973 7.20444C7.55658 7.35151 7.39712 7.53865 7.32532 7.62026C7.25355 7.70187 7.16202 7.83337 7.12196 7.91246C7.0172 8.11922 6.70956 9.40807 6.73393 9.53804C6.75896 9.67161 6.90252 9.79281 7.03567 9.79281C7.13531 9.79281 8.23522 9.3382 8.46676 9.20134C8.52942 9.16427 8.5867 9.13396 8.59398 9.13396C8.61999 9.13396 8.60673 10.0795 8.57936 10.1749C8.54649 10.2896 8.49137 10.3504 8.38298 10.3916C8.33184 10.4111 7.16226 10.4217 5.07131 10.4217C1.48523 10.4217 1.66976 10.4319 1.58502 10.2291C1.51811 10.0689 1.519 1.08807 1.58592 0.958611C1.68476 0.767485 1.52254 0.778596 4.21261 0.778596H6.66108L6.6612 1.60964ZM7.69359 1.25776C7.82512 1.38129 8.06091 1.60703 8.21759 1.75944L8.50245 2.03651L7.9186 2.02897L7.33475 2.02142L7.32658 1.46961L7.3184 0.917792L7.38643 0.975471C7.42386 1.00719 7.56206 1.13422 7.69359 1.25776ZM2.33223 2.07068C2.24917 2.11099 2.16992 2.25016 2.17007 2.35545C2.17022 2.46955 2.27169 2.62998 2.36654 2.66604C2.41313 2.68377 3.10746 2.69524 4.13198 2.69524H5.82064L5.92648 2.60228C6.02101 2.5193 6.03232 2.49342 6.03232 2.3604C6.03232 2.23572 6.01807 2.19721 5.94481 2.12393L5.85729 2.03639L4.1259 2.03843C3.02647 2.03972 2.37178 2.05149 2.33223 2.07068ZM2.27175 4.08481C2.1883 4.16827 2.16995 4.2093 2.16995 4.31241C2.16995 4.41552 2.1883 4.45654 2.27175 4.54001L2.37355 4.64183H5.07353H7.7735L7.8595 4.55582C8.0133 4.40198 8.0133 4.22283 7.8595 4.06899L7.7735 3.98298H5.07353H2.37355L2.27175 4.08481ZM11.0878 4.68756C11.2176 4.79678 11.2343 4.91321 11.1426 5.06915C11.1016 5.13884 11.0364 5.22542 10.9977 5.26156L10.9274 5.32727L10.7104 5.14689C10.5911 5.04768 10.4935 4.95215 10.4935 4.93466C10.4935 4.91714 10.559 4.83736 10.6389 4.75734C10.8137 4.58256 10.9398 4.56298 11.0878 4.68756ZM10.279 5.66199C10.4128 5.77472 10.4864 5.85689 10.473 5.87869C10.4277 5.95191 8.77895 7.89162 8.75395 7.90099C8.73952 7.90641 8.62625 7.8269 8.50224 7.7243C8.30367 7.56001 8.28166 7.53204 8.31786 7.48984C8.34047 7.46349 8.5858 7.1724 8.86305 6.84297C9.67688 5.87603 10.0192 5.48036 10.0419 5.48036C10.0537 5.48036 10.1603 5.56209 10.279 5.66199ZM2.28723 5.98294C2.21552 6.04706 2.19034 6.09872 2.17818 6.20674C2.16351 6.33698 2.17004 6.35492 2.26795 6.45285L2.37355 6.55847H5.06454C8.02199 6.55847 7.83459 6.57024 7.93375 6.37846C7.99049 6.2687 7.99031 6.18904 7.93306 6.07832C7.83632 5.89121 7.97243 5.89963 5.04622 5.89963H2.38049L2.28723 5.98294ZM2.35903 7.86011C2.11908 7.96448 2.11261 8.33757 2.34861 8.45963C2.47945 8.52731 5.7216 8.52794 5.85235 8.46032C5.97541 8.39665 6.03232 8.30106 6.03232 8.15803C6.03232 8.00149 5.94759 7.88871 5.79893 7.84741C5.72899 7.82798 5.09068 7.81699 4.0712 7.81762C2.76104 7.81843 2.4363 7.82648 2.35903 7.86011ZM8.11321 8.27974C8.21202 8.36197 8.2996 8.43418 8.30783 8.4402C8.35304 8.47323 8.04522 8.68187 7.8253 8.76722C7.68725 8.8208 7.56625 8.86461 7.55643 8.86455C7.5388 8.86443 7.58299 8.6628 7.66539 8.36754C7.6888 8.28366 7.7365 8.17869 7.77141 8.13431C7.843 8.04327 7.8147 8.03123 8.11321 8.27974Z"
        fill="#929292"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      className="3xl:w-[19px] 3xl:h-[19px]"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.53934 1.45923H6.44881C5.50147 1.45923 4.75102 1.45923 4.16396 1.53809C3.5599 1.61952 3.07077 1.79064 2.68472 2.17617C2.29919 2.56222 2.12807 3.05135 2.04663 3.65542C1.96777 4.24299 1.96777 4.99293 1.96777 5.94026V9.06162C1.96779 9.52211 2.13216 9.96747 2.43131 10.3175C2.73046 10.6676 3.14473 10.8994 3.59958 10.9712C3.67019 11.365 3.80678 11.7011 4.07995 11.9748C4.39023 12.285 4.78092 12.418 5.24479 12.4809C5.69166 12.5407 6.26016 12.5407 6.96474 12.5407H8.56768C9.27226 12.5407 9.84076 12.5407 10.2876 12.4809C10.7515 12.418 11.1422 12.285 11.4525 11.9748C11.7628 11.6645 11.8957 11.2738 11.9586 10.8099C12.0184 10.3631 12.0184 9.79455 12.0184 9.08997V6.45619C12.0184 5.75162 12.0184 5.18311 11.9586 4.73625C11.8957 4.27237 11.7628 3.88169 11.4525 3.57141C11.1788 3.29824 10.8427 3.16165 10.449 3.09104C10.3771 2.63619 10.1453 2.22191 9.79525 1.92276C9.44518 1.62361 8.99982 1.45924 8.53934 1.45923ZM9.63717 3.0163C9.5588 2.78746 9.41083 2.58885 9.21397 2.44827C9.01712 2.3077 8.78123 2.23221 8.53934 2.23235H6.47767C5.49477 2.23235 4.7969 2.23338 4.26653 2.30451C3.74854 2.37409 3.4496 2.50501 3.23158 2.72303C3.01355 2.94105 2.88264 3.23999 2.81306 3.7585C2.74193 4.28835 2.7409 4.98622 2.7409 5.96912V9.06162C2.74075 9.30352 2.81625 9.5394 2.95682 9.73626C3.09739 9.93312 3.296 10.0811 3.52485 10.1595C3.51402 9.84506 3.51402 9.48942 3.51402 9.08997V6.45619C3.51402 5.75162 3.51402 5.18311 3.57433 4.73625C3.63618 4.27237 3.77019 3.88169 4.07995 3.57141C4.39023 3.26113 4.78092 3.12815 5.24479 3.06578C5.69166 3.00548 6.26016 3.00548 6.96474 3.00548H8.56768C8.96713 3.00548 9.32277 3.00548 9.63717 3.0163ZM4.62629 4.11878C4.76906 3.97601 4.96904 3.88323 5.34788 3.83221C5.7365 3.78015 6.25295 3.77912 6.99257 3.77912H8.53882C9.27844 3.77912 9.79438 3.78015 10.184 3.83221C10.5623 3.88323 10.7623 3.97652 10.9051 4.11878C11.0479 4.26155 11.1406 4.46153 11.1917 4.84036C11.2437 5.22899 11.2448 5.74543 11.2448 6.48506V9.06214C11.2448 9.80176 11.2437 10.3177 11.1917 10.7074C11.1406 11.0857 11.0474 11.2856 10.9051 11.4284C10.7623 11.5712 10.5623 11.664 10.1835 11.715C9.79438 11.767 9.27844 11.7681 8.53882 11.7681H6.99257C6.25295 11.7681 5.7365 11.767 5.34736 11.715C4.96904 11.664 4.76906 11.5707 4.62629 11.4284C4.48352 11.2856 4.39075 11.0857 4.33972 10.7068C4.28766 10.3177 4.28663 9.80176 4.28663 9.06214V6.48506C4.28663 5.74543 4.28766 5.22899 4.33972 4.83985C4.39075 4.46153 4.48404 4.26155 4.62629 4.11878Z"
        fill="#929292"
      />
    </svg>
  );
};

export const CodeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M9.03684 18.2047L1 14.1011V12.2269L9.03684 8.14303V10.0567L1.62073 13.7854V12.5623L9.03684 16.291V18.2047Z"
        fill="black"
      />
      <path
        d="M11.1867 20H9.50418L13.8003 4H15.4828L11.1867 20Z"
        fill="black"
      />
      <path
        d="M15.9795 18.2047V16.291L23.3793 12.5623V13.7854L15.9795 10.0567V8.14303L24 12.2269V14.1011L15.9795 18.2047Z"
        fill="black"
      />
    </svg>
  );
};
export const BoldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M11.2626 6C12.6775 6 13.7026 6.0942 14.3381 6.28261C14.9856 6.45845 15.4472 6.67198 15.723 6.92319C16.3345 7.47585 16.6403 8.32367 16.6403 9.46667C16.6403 10.3208 16.2026 11.1309 15.3273 11.8971C16.4424 12.4874 17 13.5865 17 15.1942C17 16.4502 16.6043 17.386 15.813 18.0015C15.0336 18.6043 13.8645 18.9372 12.3058 19H7.17986L7 17.4362C7.15588 17.2227 7.48561 17.0155 7.98921 16.8145V8.20435C7.4976 8.01594 7.16787 7.80242 7 7.56377L7.17986 6H11.2626ZM12.1799 13.3667H10.5791V16.9464H11.8201C12.6355 16.9464 13.253 16.8208 13.6727 16.5696C14.0923 16.3184 14.3022 15.8662 14.3022 15.213C14.3022 14.5599 14.1343 14.0889 13.7986 13.8C13.4748 13.5111 12.9353 13.3667 12.1799 13.3667ZM11.5144 8.05362H10.5791V11.313H12.054C12.6655 11.313 13.1331 11.1498 13.4568 10.8232C13.7806 10.4966 13.9424 10.101 13.9424 9.63623C13.9424 9.15894 13.8285 8.80097 13.6007 8.56232C13.3729 8.32367 13.1091 8.17923 12.8094 8.12899C12.5096 8.07874 12.0779 8.05362 11.5144 8.05362Z"
        fill="black"
      />
    </svg>
  );
};
export const ItalicIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M9 17L9.09709 16.1895L10.0485 15.9965C10.2168 15.9708 10.3333 15.9193 10.3981 15.8421C10.4757 15.7649 10.521 15.6363 10.534 15.4561L11.5437 7.46667C11.5696 7.29942 11.5502 7.18363 11.4854 7.1193C11.4207 7.05497 11.3172 7.00994 11.1748 6.98421L10.2427 6.81053L10.3398 6H15L14.9029 6.81053L13.9515 6.98421C13.7961 7.00994 13.6796 7.0614 13.6019 7.1386C13.5243 7.21579 13.4725 7.34445 13.4466 7.52456L12.4563 15.5333C12.4434 15.6877 12.4628 15.7971 12.5146 15.8614C12.5793 15.9257 12.6828 15.9708 12.8252 15.9965L13.7573 16.1895L13.6602 17H9Z"
        fill="black"
      />
    </svg>
  );
};
export const UnderlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M16.3664 5V5.96893L15.5792 6.18644C15.3616 6.23917 15.2528 6.37759 15.2528 6.6017V12.1582C15.2528 13.1996 15.08 14.0367 14.7344 14.6695C14.3888 15.3023 13.9024 15.7637 13.2752 16.0537C12.648 16.3437 11.8992 16.4887 11.0288 16.4887C9.5568 16.4887 8.4624 16.1394 7.7456 15.4407C7.0416 14.7288 6.6896 13.5951 6.6896 12.0395V6.6017C6.6896 6.39077 6.5808 6.25235 6.3632 6.18644L5.6336 5.96893V5H10.5296V5.96893L9.3776 6.20621C9.1472 6.25895 9.032 6.40396 9.032 6.64124V12.2571C9.032 12.9689 9.1152 13.5687 9.2816 14.0565C9.448 14.5443 9.704 14.9068 10.0496 15.1441C10.408 15.3814 10.856 15.5 11.3936 15.5C12.2896 15.5 12.9104 15.21 13.256 14.6299C13.6144 14.0499 13.7936 13.2655 13.7936 12.2768V6.62147C13.7936 6.38418 13.6848 6.24576 13.4672 6.20621L12.296 5.96893V5H16.3664Z"
        fill="black"
      />
      <path d="M5 18.2684H17V19H5V18.2684Z" fill="black" />
    </svg>
  );
};
export const AlignLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M5 6H19V7.52941H5V6ZM5 17.4706H15.8889V19H5V17.4706ZM5 13.6471H19V15.1765H5V13.6471ZM5 9.82353H15.8889V11.3529H5V9.82353Z"
        fill="black"
      />
    </svg>
  );
};
export const AlignRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M5 5H19V6.55556H5V5ZM5 11.2222H19V12.7778H5V11.2222ZM5 17.4444H19V19H5V17.4444ZM9.66667 8.11111H19V9.66667H9.66667V8.11111ZM9.66667 14.3333H19V15.8889H9.66667V14.3333Z"
        fill="black"
      />
    </svg>
  );
};
export const AlignJustifyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_810_20073)">
        <path
          d="M5.77778 5C5.5715 5 5.37367 5.08057 5.22781 5.22398C5.08194 5.36739 5 5.56189 5 5.76471C5 5.96752 5.08194 6.16202 5.22781 6.30543C5.37367 6.44884 5.5715 6.52941 5.77778 6.52941H18.2222C18.4285 6.52941 18.6263 6.44884 18.7722 6.30543C18.9181 6.16202 19 5.96752 19 5.76471C19 5.56189 18.9181 5.36739 18.7722 5.22398C18.6263 5.08057 18.4285 5 18.2222 5H5.77778ZM5.77778 8.82353C5.5715 8.82353 5.37367 8.9041 5.22781 9.04751C5.08194 9.19092 5 9.38542 5 9.58824C5 9.79105 5.08194 9.98555 5.22781 10.129C5.37367 10.2724 5.5715 10.3529 5.77778 10.3529H18.2222C18.4285 10.3529 18.6263 10.2724 18.7722 10.129C18.9181 9.98555 19 9.79105 19 9.58824C19 9.38542 18.9181 9.19092 18.7722 9.04751C18.6263 8.9041 18.4285 8.82353 18.2222 8.82353H5.77778ZM5 13.4118C5 13.209 5.08194 13.0144 5.22781 12.871C5.37367 12.7276 5.5715 12.6471 5.77778 12.6471H18.2222C18.4285 12.6471 18.6263 12.7276 18.7722 12.871C18.9181 13.0144 19 13.209 19 13.4118C19 13.6146 18.9181 13.8091 18.7722 13.9525C18.6263 14.0959 18.4285 14.1765 18.2222 14.1765H5.77778C5.5715 14.1765 5.37367 14.0959 5.22781 13.9525C5.08194 13.8091 5 13.6146 5 13.4118ZM5.77778 16.4706C5.5715 16.4706 5.37367 16.5512 5.22781 16.6946C5.08194 16.838 5 17.0325 5 17.2353C5 17.4381 5.08194 17.6326 5.22781 17.776C5.37367 17.9194 5.5715 18 5.77778 18H18.2222C18.4285 18 18.6263 17.9194 18.7722 17.776C18.9181 17.6326 19 17.4381 19 17.2353C19 17.0325 18.9181 16.838 18.7722 16.6946C18.6263 16.5512 18.4285 16.4706 18.2222 16.4706H5.77778Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_810_20073">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AlignMiddleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M6 17.4444H18V19H6V17.4444ZM8.25 14.3333H15.75V15.8889H8.25V14.3333ZM6 11.2222H18V12.7778H6V11.2222ZM6 5H18V6.55556H6V5ZM8.25 8.11111H15.75V9.66667H8.25V8.11111Z"
        fill="black"
      />
    </svg>
  );
};
export const ImageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none">
      <path
        opacity="0.2"
        d="M19.3845 6.46151V15.8507L16.3291 12.7954C16.2137 12.68 16.0572 12.6153 15.8941 12.6153C15.7309 12.6153 15.5745 12.68 15.4591 12.7954L13.4852 14.7692L9.666 10.9492C9.60885 10.892 9.54098 10.8466 9.46627 10.8156C9.39157 10.7847 9.31149 10.7687 9.23062 10.7687C9.14975 10.7687 9.06967 10.7847 8.99496 10.8156C8.92026 10.8466 8.85239 10.892 8.79523 10.9492L4.61523 15.13V6.46151C4.61523 6.2983 4.68007 6.14178 4.79548 6.02637C4.91088 5.91097 5.06741 5.84613 5.23062 5.84613H18.7691C18.9323 5.84613 19.0888 5.91097 19.2042 6.02637C19.3196 6.14178 19.3845 6.2983 19.3845 6.46151Z"
        fill="black"
      />
      <path
        d="M18.7692 5.23077H5.23077C4.90435 5.23077 4.5913 5.36044 4.36048 5.59126C4.12967 5.82207 4 6.13512 4 6.46154V17.5385C4 17.8649 4.12967 18.1779 4.36048 18.4088C4.5913 18.6396 4.90435 18.7692 5.23077 18.7692H18.7692C19.0957 18.7692 19.4087 18.6396 19.6395 18.4088C19.8703 18.1779 20 17.8649 20 17.5385V6.46154C20 6.13512 19.8703 5.82207 19.6395 5.59126C19.4087 5.36044 19.0957 5.23077 18.7692 5.23077ZM18.7692 6.46154V14.3654L16.7638 12.3608C16.6496 12.2465 16.5139 12.1558 16.3645 12.0939C16.2152 12.032 16.0551 12.0002 15.8935 12.0002C15.7318 12.0002 15.5717 12.032 15.4224 12.0939C15.2731 12.1558 15.1374 12.2465 15.0231 12.3608L13.4846 13.8992L10.1 10.5146C9.86921 10.284 9.55628 10.1544 9.23 10.1544C8.90372 10.1544 8.59079 10.284 8.36 10.5146L5.23077 13.6439V6.46154H18.7692ZM5.23077 15.3846L9.23077 11.3846L15.3846 17.5385H5.23077V15.3846ZM18.7692 17.5385H17.1254L14.3562 14.7692L15.8946 13.2308L18.7692 16.1062V17.5385ZM13.2308 9.84616C13.2308 9.66359 13.2849 9.48512 13.3863 9.33332C13.4878 9.18153 13.6319 9.06321 13.8006 8.99335C13.9693 8.92348 14.1549 8.9052 14.3339 8.94082C14.513 8.97644 14.6775 9.06435 14.8066 9.19344C14.9357 9.32254 15.0236 9.48702 15.0592 9.66608C15.0948 9.84513 15.0765 10.0307 15.0067 10.1994C14.9368 10.3681 14.8185 10.5122 14.6667 10.6137C14.5149 10.7151 14.3364 10.7692 14.1538 10.7692C13.909 10.7692 13.6742 10.672 13.5011 10.4989C13.328 10.3258 13.2308 10.091 13.2308 9.84616Z"
        fill="black"
      />
      <path
        d="M25.6 14.4667C25.8 14.7333 26.2 14.7333 26.4 14.4667L28.4 11.8C28.6472 11.4704 28.412 11 28 11H24C23.588 11 23.3528 11.4704 23.6 11.8L25.6 14.4667Z"
        fill="black"
      />
    </svg>
  );
};
export const ColorLensIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M10.0003 18.3334C5.40866 18.3334 1.66699 14.5917 1.66699 10C1.66699 5.40835 5.40866 1.66669 10.0003 1.66669C14.592 1.66669 18.3337 5.03335 18.3337 9.16669C18.3337 11.925 16.092 14.1667 13.3337 14.1667H11.8587C11.6253 14.1667 11.442 14.35 11.442 14.5834C11.442 14.6834 11.4837 14.775 11.5503 14.8584C11.892 15.25 12.0837 15.7417 12.0837 16.25C12.0837 16.8026 11.8642 17.3325 11.4735 17.7232C11.0828 18.1139 10.5529 18.3334 10.0003 18.3334ZM10.0003 3.33335C6.32533 3.33335 3.33366 6.32502 3.33366 10C3.33366 13.675 6.32533 16.6667 10.0003 16.6667C10.2337 16.6667 10.417 16.4834 10.417 16.25C10.4144 16.1419 10.373 16.0384 10.3003 15.9584C9.95866 15.575 9.77532 15.0834 9.77532 14.5834C9.77532 14.0308 9.99482 13.5009 10.3855 13.1102C10.7762 12.7195 11.3061 12.5 11.8587 12.5H13.3337C15.1753 12.5 16.667 11.0084 16.667 9.16669C16.667 5.95002 13.6753 3.33335 10.0003 3.33335Z"
        fill="black"
      />
      <path
        d="M5.41699 10.8333C6.10735 10.8333 6.66699 10.2737 6.66699 9.58331C6.66699 8.89296 6.10735 8.33331 5.41699 8.33331C4.72664 8.33331 4.16699 8.89296 4.16699 9.58331C4.16699 10.2737 4.72664 10.8333 5.41699 10.8333Z"
        fill="black"
      />
      <path
        d="M7.91699 7.5C8.60735 7.5 9.16699 6.94036 9.16699 6.25C9.16699 5.55964 8.60735 5 7.91699 5C7.22664 5 6.66699 5.55964 6.66699 6.25C6.66699 6.94036 7.22664 7.5 7.91699 7.5Z"
        fill="black"
      />
      <path
        d="M12.083 7.5C12.7734 7.5 13.333 6.94036 13.333 6.25C13.333 5.55964 12.7734 5 12.083 5C11.3927 5 10.833 5.55964 10.833 6.25C10.833 6.94036 11.3927 7.5 12.083 7.5Z"
        fill="black"
      />
      <path
        d="M14.583 10.8333C15.2734 10.8333 15.833 10.2737 15.833 9.58331C15.833 8.89296 15.2734 8.33331 14.583 8.33331C13.8927 8.33331 13.333 8.89296 13.333 9.58331C13.333 10.2737 13.8927 10.8333 14.583 10.8333Z"
        fill="black"
      />
    </svg>
  );
};
export const ColorLensArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="4"
      viewBox="0 0 6 4"
      fill="none">
      <path
        d="M2.6 3.46667C2.8 3.73333 3.2 3.73333 3.4 3.46667L5.4 0.8C5.64721 0.470382 5.41202 0 5 0H1C0.587977 0 0.352786 0.470382 0.6 0.8L2.6 3.46667Z"
        fill="black"
      />
    </svg>
  );
};
// ============= MY CONATCT ICON
export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <g clipPath="url(#clip0_456_34421)">
        <path
          className="group-hover:fill-white"
          d="M11.5167 14.5893H13.9274C14.2589 14.5893 14.5301 14.3181 14.5301 13.9866V10.9732H15.4884C16.0248 10.9732 16.296 10.3223 15.9163 9.94259L13.15 7.17628C12.9149 6.94124 12.5352 6.94124 12.3002 7.17628L9.53388 9.94259C9.15419 10.3223 9.41937 10.9732 9.95576 10.9732H10.914V13.9866C10.914 14.3181 11.1852 14.5893 11.5167 14.5893ZM9.10598 15.7946H16.3382C16.6696 15.7946 16.9408 16.0658 16.9408 16.3973C16.9408 16.7288 16.6696 17 16.3382 17H9.10598C8.7745 17 8.5033 16.7288 8.5033 16.3973C8.5033 16.0658 8.7745 15.7946 9.10598 15.7946Z"
          fill="#6F6AF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_456_34421">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.503296)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FaqBlackArrow = ({ id, open }) => {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      className={`${
        id === open ? "rotate-[90deg]" : "rotate-[0deg]"
      } h-5 w-5 transition-transform`}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 15L8 8L1 1"
        stroke="black"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ErroeIcon = ({ id, open }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 12 12"
      fill="none">
      <g clipPath="url(#clip0_486_30832)">
        <path
          d="M6 2C5.20888 2 4.43552 2.2346 3.77772 2.67412C3.11992 3.11365 2.60723 3.73836 2.30448 4.46927C2.00173 5.20017 1.92252 6.00444 2.07686 6.78036C2.2312 7.55628 2.61216 8.26902 3.17157 8.82843C3.73098 9.38784 4.44372 9.7688 5.21964 9.92314C5.99556 10.0775 6.79983 9.99827 7.53074 9.69552C8.26164 9.39277 8.88635 8.88008 9.32588 8.22228C9.76541 7.56448 10 6.79112 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2ZM5.50334 4C5.50334 3.86739 5.55601 3.74021 5.64978 3.64645C5.74355 3.55268 5.87073 3.5 6.00334 3.5C6.13594 3.5 6.26312 3.55268 6.35689 3.64645C6.45066 3.74021 6.50334 3.86739 6.50334 4V6.29667C6.50334 6.36233 6.4904 6.42735 6.46527 6.48801C6.44015 6.54867 6.40332 6.60379 6.35689 6.65022C6.31046 6.69665 6.25534 6.73348 6.19468 6.75861C6.13401 6.78373 6.069 6.79667 6.00334 6.79667C5.93767 6.79667 5.87266 6.78373 5.81199 6.75861C5.75133 6.73348 5.69621 6.69665 5.64978 6.65022C5.60335 6.60379 5.56652 6.54867 5.5414 6.48801C5.51627 6.42735 5.50334 6.36233 5.50334 6.29667V4ZM6 8.5C5.88661 8.5 5.77576 8.46637 5.68147 8.40338C5.58719 8.34038 5.51371 8.25083 5.47031 8.14607C5.42692 8.04131 5.41556 7.92603 5.43769 7.81481C5.45981 7.7036 5.51441 7.60144 5.59459 7.52126C5.67478 7.44108 5.77693 7.38647 5.88815 7.36435C5.99937 7.34223 6.11464 7.35358 6.21941 7.39698C6.32417 7.44037 6.41371 7.51385 6.47671 7.60814C6.53971 7.70242 6.57334 7.81327 6.57334 7.92667C6.57334 8.07872 6.51293 8.22455 6.40541 8.33207C6.29789 8.43959 6.15206 8.5 6 8.5Z"
          fill="#FF0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_486_30832">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BlueCalendar = ({ id, open }) => {
  return (
   <svg width="16" height="16" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2581_7954)">
<path d="M5 8.24438C5.08241 8.24438 5.16297 8.21995 5.23149 8.17416C5.30001 8.12838 5.35342 8.0633 5.38495 7.98717C5.41649 7.91103 5.42474 7.82725 5.40866 7.74643C5.39259 7.6656 5.3529 7.59136 5.29463 7.53309C5.23636 7.47482 5.16212 7.43513 5.08129 7.41906C5.00046 7.40298 4.91669 7.41123 4.84055 7.44277C4.76442 7.4743 4.69934 7.52771 4.65356 7.59623C4.60777 7.66475 4.58334 7.74531 4.58334 7.82772C4.58334 7.93822 4.62723 8.04421 4.70537 8.12235C4.78352 8.20049 4.8895 8.24438 5 8.24438ZM7.08334 8.24438C7.16575 8.24438 7.2463 8.21995 7.31482 8.17416C7.38334 8.12838 7.43675 8.0633 7.46829 7.98717C7.49982 7.91103 7.50807 7.82725 7.492 7.74643C7.47592 7.6656 7.43624 7.59136 7.37796 7.53309C7.31969 7.47482 7.24545 7.43513 7.16462 7.41906C7.0838 7.40298 7.00002 7.41123 6.92388 7.44277C6.84775 7.4743 6.78267 7.52771 6.73689 7.59623C6.69111 7.66475 6.66667 7.74531 6.66667 7.82772C6.66667 7.93822 6.71057 8.04421 6.78871 8.12235C6.86685 8.20049 6.97283 8.24438 7.08334 8.24438ZM7.08334 6.57772C7.16575 6.57772 7.2463 6.55328 7.31482 6.5075C7.38334 6.46171 7.43675 6.39664 7.46829 6.3205C7.49982 6.24437 7.50807 6.16059 7.492 6.07976C7.47592 5.99894 7.43624 5.9247 7.37796 5.86642C7.31969 5.80815 7.24545 5.76847 7.16462 5.75239C7.0838 5.73631 7.00002 5.74456 6.92388 5.7761C6.84775 5.80764 6.78267 5.86104 6.73689 5.92956C6.69111 5.99808 6.66667 6.07864 6.66667 6.16105C6.66667 6.27156 6.71057 6.37754 6.78871 6.45568C6.86685 6.53382 6.97283 6.57772 7.08334 6.57772ZM5 6.57772C5.08241 6.57772 5.16297 6.55328 5.23149 6.5075C5.30001 6.46171 5.35342 6.39664 5.38495 6.3205C5.41649 6.24437 5.42474 6.16059 5.40866 6.07976C5.39259 5.99894 5.3529 5.9247 5.29463 5.86642C5.23636 5.80815 5.16212 5.76847 5.08129 5.75239C5.00046 5.73631 4.91669 5.74456 4.84055 5.7761C4.76442 5.80764 4.69934 5.86104 4.65356 5.92956C4.60777 5.99808 4.58334 6.07864 4.58334 6.16105C4.58334 6.27156 4.62723 6.37754 4.70537 6.45568C4.78352 6.53382 4.8895 6.57772 5 6.57772ZM7.91667 1.57772H7.5V1.16105C7.5 1.05054 7.4561 0.944564 7.37796 0.866424C7.29982 0.788283 7.19384 0.744385 7.08334 0.744385C6.97283 0.744385 6.86685 0.788283 6.78871 0.866424C6.71057 0.944564 6.66667 1.05054 6.66667 1.16105V1.57772H3.33334V1.16105C3.33334 1.05054 3.28944 0.944564 3.2113 0.866424C3.13316 0.788283 3.02718 0.744385 2.91667 0.744385C2.80616 0.744385 2.70018 0.788283 2.62204 0.866424C2.5439 0.944564 2.5 1.05054 2.5 1.16105V1.57772H2.08334C1.75182 1.57772 1.43387 1.70941 1.19945 1.94383C0.965032 2.17825 0.833336 2.4962 0.833336 2.82772V8.66105C0.833336 8.99257 0.965032 9.31051 1.19945 9.54493C1.43387 9.77936 1.75182 9.91105 2.08334 9.91105H7.91667C8.24819 9.91105 8.56613 9.77936 8.80055 9.54493C9.03497 9.31051 9.16667 8.99257 9.16667 8.66105V2.82772C9.16667 2.4962 9.03497 2.17825 8.80055 1.94383C8.56613 1.70941 8.24819 1.57772 7.91667 1.57772ZM8.33334 8.66105C8.33334 8.77156 8.28944 8.87754 8.2113 8.95568C8.13316 9.03382 8.02718 9.07772 7.91667 9.07772H2.08334C1.97283 9.07772 1.86685 9.03382 1.78871 8.95568C1.71057 8.87754 1.66667 8.77156 1.66667 8.66105V4.91105H8.33334V8.66105ZM8.33334 4.07772H1.66667V2.82772C1.66667 2.71721 1.71057 2.61123 1.78871 2.53309C1.86685 2.45495 1.97283 2.41105 2.08334 2.41105H2.5V2.82772C2.5 2.93822 2.5439 3.04421 2.62204 3.12235C2.70018 3.20049 2.80616 3.24438 2.91667 3.24438C3.02718 3.24438 3.13316 3.20049 3.2113 3.12235C3.28944 3.04421 3.33334 2.93822 3.33334 2.82772V2.41105H6.66667V2.82772C6.66667 2.93822 6.71057 3.04421 6.78871 3.12235C6.86685 3.20049 6.97283 3.24438 7.08334 3.24438C7.19384 3.24438 7.29982 3.20049 7.37796 3.12235C7.4561 3.04421 7.5 2.93822 7.5 2.82772V2.41105H7.91667C8.02718 2.41105 8.13316 2.45495 8.2113 2.53309C8.28944 2.61123 8.33334 2.71721 8.33334 2.82772V4.07772ZM2.91667 6.57772C2.99908 6.57772 3.07964 6.55328 3.14816 6.5075C3.21668 6.46171 3.27008 6.39664 3.30162 6.3205C3.33316 6.24437 3.34141 6.16059 3.32533 6.07976C3.30925 5.99894 3.26957 5.9247 3.2113 5.86642C3.15303 5.80815 3.07878 5.76847 2.99796 5.75239C2.91713 5.73631 2.83335 5.74456 2.75722 5.7761C2.68108 5.80764 2.61601 5.86104 2.57022 5.92956C2.52444 5.99808 2.5 6.07864 2.5 6.16105C2.5 6.27156 2.5439 6.37754 2.62204 6.45568C2.70018 6.53382 2.80616 6.57772 2.91667 6.57772ZM2.91667 8.24438C2.99908 8.24438 3.07964 8.21995 3.14816 8.17416C3.21668 8.12838 3.27008 8.0633 3.30162 7.98717C3.33316 7.91103 3.34141 7.82725 3.32533 7.74643C3.30925 7.6656 3.26957 7.59136 3.2113 7.53309C3.15303 7.47482 3.07878 7.43513 2.99796 7.41906C2.91713 7.40298 2.83335 7.41123 2.75722 7.44277C2.68108 7.4743 2.61601 7.52771 2.57022 7.59623C2.52444 7.66475 2.5 7.74531 2.5 7.82772C2.5 7.93822 2.5439 8.04421 2.62204 8.12235C2.70018 8.20049 2.80616 8.24438 2.91667 8.24438Z" fill="#6F6AF8"/>
</g>
<defs>
<clipPath id="clip0_2581_7954">
<rect width="10" height="10" fill="white" transform="translate(0 0.327637)"/>
</clipPath>
</defs>
</svg>

  );
};
export const BlackRightIcon = ({ id, open }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"
        fill="black"
      />
    </svg>
  );
};

//=========== SETTINGS PAGE ICON
export const PersonalInfoImageUploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none">
      <path
        d="M14.25 9.74992C14.0511 9.74992 13.8603 9.82894 13.7197 9.96959C13.579 10.1102 13.5 10.301 13.5 10.4999V10.7849L12.39 9.67492C11.9981 9.28608 11.4683 9.06789 10.9163 9.06789C10.3642 9.06789 9.83443 9.28608 9.4425 9.67492L8.9175 10.1999L7.0575 8.33992C6.66009 7.96162 6.13242 7.75064 5.58375 7.75064C5.03508 7.75064 4.50741 7.96162 4.11 8.33992L3 9.44992V5.24992C3 5.05101 3.07902 4.86024 3.21967 4.71959C3.36032 4.57894 3.55109 4.49992 3.75 4.49992H9C9.19891 4.49992 9.38968 4.4209 9.53033 4.28025C9.67098 4.1396 9.75 3.94883 9.75 3.74992C9.75 3.55101 9.67098 3.36024 9.53033 3.21959C9.38968 3.07894 9.19891 2.99992 9 2.99992H3.75C3.15326 2.99992 2.58097 3.23697 2.15901 3.65893C1.73705 4.08089 1.5 4.65318 1.5 5.24992V14.2499C1.5 14.8467 1.73705 15.419 2.15901 15.8409C2.58097 16.2629 3.15326 16.4999 3.75 16.4999H12.75C13.3467 16.4999 13.919 16.2629 14.341 15.8409C14.7629 15.419 15 14.8467 15 14.2499V10.4999C15 10.301 14.921 10.1102 14.7803 9.96959C14.6397 9.82894 14.4489 9.74992 14.25 9.74992ZM3.75 14.9999C3.55109 14.9999 3.36032 14.9209 3.21967 14.7803C3.07902 14.6396 3 14.4488 3 14.2499V11.5724L5.175 9.39742C5.28518 9.29242 5.43155 9.23385 5.58375 9.23385C5.73595 9.23385 5.88232 9.29242 5.9925 9.39742L8.37 11.7749L11.595 14.9999H3.75ZM13.5 14.2499C13.4989 14.3935 13.4516 14.5329 13.365 14.6474L9.9825 11.2499L10.5075 10.7249C10.5613 10.67 10.6255 10.6264 10.6963 10.5967C10.7671 10.5669 10.8432 10.5516 10.92 10.5516C10.9968 10.5516 11.0729 10.5669 11.1437 10.5967C11.2146 10.6264 11.2787 10.67 11.3325 10.7249L13.5 12.9074V14.2499ZM17.0325 3.21742L14.7825 0.967422C14.7112 0.899142 14.6271 0.845618 14.535 0.809922C14.3524 0.734909 14.1476 0.734909 13.965 0.809922C13.8729 0.845618 13.7888 0.899142 13.7175 0.967422L11.4675 3.21742C11.3976 3.28735 11.3421 3.37037 11.3043 3.46174C11.2664 3.5531 11.2469 3.65103 11.2469 3.74992C11.2469 3.94965 11.3263 4.14119 11.4675 4.28242C11.6087 4.42365 11.8003 4.50299 12 4.50299C12.1997 4.50299 12.3913 4.42365 12.5325 4.28242L13.5 3.30742V7.49992C13.5 7.69883 13.579 7.8896 13.7197 8.03025C13.8603 8.1709 14.0511 8.24992 14.25 8.24992C14.4489 8.24992 14.6397 8.1709 14.7803 8.03025C14.921 7.8896 15 7.69883 15 7.49992V3.30742L15.9675 4.28242C16.0372 4.35272 16.1202 4.40851 16.2116 4.44659C16.303 4.48467 16.401 4.50427 16.5 4.50427C16.599 4.50427 16.697 4.48467 16.7884 4.44659C16.8798 4.40851 16.9628 4.35272 17.0325 4.28242C17.1028 4.2127 17.1586 4.12975 17.1967 4.03835C17.2347 3.94696 17.2543 3.84893 17.2543 3.74992C17.2543 3.65091 17.2347 3.55288 17.1967 3.46149C17.1586 3.3701 17.1028 3.28714 17.0325 3.21742Z"
        fill="white"
      />
    </svg>
  );
};

export const PasswordkeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none">
      <path
        className="group-hover:fill-[#6F6AF8] group-hover:stroke-white"
        d="M10.9791 5.31258L13.4583 2.83341M14.875 1.41675L13.4583 2.83341L14.875 1.41675ZM8.06787 8.22383C8.43361 8.5847 8.72435 9.01436 8.92336 9.48806C9.12237 9.96176 9.22571 10.4701 9.22743 10.9839C9.22915 11.4977 9.12922 12.0068 8.93339 12.4818C8.73756 12.9569 8.4497 13.3885 8.08639 13.7518C7.72307 14.1151 7.29148 14.4029 6.81646 14.5988C6.34143 14.7946 5.83237 14.8945 5.31857 14.8928C4.80476 14.8911 4.29638 14.7877 3.82268 14.5887C3.34898 14.3897 2.91932 14.099 2.55845 13.7332C1.84879 12.9985 1.45611 12.0144 1.46499 10.9929C1.47387 9.97144 1.88359 8.99432 2.60591 8.272C3.32823 7.54968 4.30535 7.13996 5.32683 7.13108C6.3483 7.1222 7.3324 7.51488 8.06716 8.22454L8.06787 8.22383ZM8.06787 8.22383L10.9791 5.31258L8.06787 8.22383ZM10.9791 5.31258L13.1041 7.43758L15.5833 4.95841L13.4583 2.83341L10.9791 5.31258Z"
        stroke="#6F6AF8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingMenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 1024 1024">
      <path
        fill="#6F6AF8"
        d="M160 448a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32H160zm448 0a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32H608zM160 896a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32H160zm448 0a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32H608z"
      />
    </svg>
  );
};

export const DescriptionEditIcon = () => {
  return (
    <svg
      className="w-[15px] h-[15px] 3xl:w-[20px] 3xl:h-[20px] productivity-card-edit-icon duration-200"
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.90602 9.89932H9.80968C9.94046 9.89932 10.0659 9.95128 10.1584 10.0438C10.2508 10.1362 10.3028 10.2617 10.3028 10.3924C10.3028 10.5232 10.2508 10.6487 10.1584 10.7411C10.0659 10.8336 9.94046 10.8856 9.80968 10.8856H2.90602C2.77524 10.8856 2.64981 10.8336 2.55733 10.7411C2.46486 10.6487 2.4129 10.5232 2.4129 10.3924C2.4129 10.2617 2.46486 10.1362 2.55733 10.0438C2.64981 9.95128 2.77524 9.89932 2.90602 9.89932ZM2.4129 7.43373L7.34409 2.50255L8.82344 3.9819L3.89226 8.91309H2.4129V7.43373ZM7.8372 2.00943L8.82344 1.02319L10.3028 2.50255L9.31607 3.48928L7.8372 2.00943Z"
        fill="#929292"
      />
    </svg>
  );
};

export const InputDropDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g opacity="0.4">
        <path
          d="M14.1667 8.33333L10 12.5L5.83337 8.33333"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const SetProductivityRightMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <path
        d="M15.5917 6.33585C15.5142 6.25775 15.422 6.19575 15.3205 6.15344C15.2189 6.11114 15.11 6.08936 15 6.08936C14.89 6.08936 14.7811 6.11114 14.6795 6.15344C14.578 6.19575 14.4858 6.25775 14.4083 6.33585L8.20001 12.5525L5.59168 9.93585C5.51124 9.85815 5.41629 9.79706 5.31224 9.75606C5.2082 9.71505 5.09709 9.69494 4.98528 9.69688C4.87346 9.69881 4.76312 9.72275 4.66055 9.76733C4.55799 9.81191 4.46521 9.87625 4.38751 9.95669C4.30981 10.0371 4.24872 10.1321 4.20771 10.2361C4.16671 10.3402 4.1466 10.4513 4.14853 10.5631C4.15047 10.6749 4.17441 10.7852 4.21899 10.8878C4.26356 10.9904 4.32791 11.0832 4.40834 11.1609L7.60834 14.3609C7.68581 14.439 7.77798 14.501 7.87953 14.5433C7.98108 14.5856 8.09 14.6074 8.20001 14.6074C8.31002 14.6074 8.41894 14.5856 8.52049 14.5433C8.62204 14.501 8.71421 14.439 8.79168 14.3609L15.5917 7.56085C15.6763 7.48282 15.7438 7.38811 15.7899 7.28269C15.8361 7.17728 15.86 7.06344 15.86 6.94835C15.86 6.83327 15.8361 6.71943 15.7899 6.61402C15.7438 6.5086 15.6763 6.41389 15.5917 6.33585Z"
        fill="white"
      />
    </svg>
  );
};

export const TimerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none">
      <path
        d="M8.15495 15.2917C4.47295 15.2917 1.48828 12.307 1.48828 8.62504C1.48828 4.94304 4.47295 1.95837 8.15495 1.95837C11.8369 1.95837 14.8216 4.94304 14.8216 8.62504C14.8216 12.307 11.8369 15.2917 8.15495 15.2917ZM8.15495 13.9584C9.56944 13.9584 10.926 13.3965 11.9262 12.3963C12.9264 11.3961 13.4883 10.0395 13.4883 8.62504C13.4883 7.21055 12.9264 5.854 11.9262 4.8538C10.926 3.85361 9.56944 3.29171 8.15495 3.29171C6.74046 3.29171 5.38391 3.85361 4.38371 4.8538C3.38352 5.854 2.82161 7.21055 2.82161 8.62504C2.82161 10.0395 3.38352 11.3961 4.38371 12.3963C5.38391 13.3965 6.74046 13.9584 8.15495 13.9584ZM8.82161 8.62504H11.4883V9.95837H7.48828V5.29171H8.82161V8.62504Z"
        fill="#6F6AF8"
      />
    </svg>
  );
};
export const BackArrowIcon = () => {
  return (
    <svg
      className="backArrow-Icon duration-300"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none">
      <rect
        x="0.155273"
        y="0.343994"
        width="28.8701"
        height="28.8701"
        rx="14.4351"
        fill="#6F6AF8"
        fill-opacity="0.1"
      />
      <path
        d="M8.91483 14.3538C8.67994 14.5886 8.67994 14.9695 8.91483 15.2043L12.7425 19.032C12.9774 19.2669 13.3582 19.2669 13.5931 19.032C13.828 18.7971 13.828 18.4163 13.5931 18.1814L10.1907 14.7791L13.5931 11.3767C13.828 11.1418 13.828 10.761 13.5931 10.5261C13.3582 10.2912 12.9774 10.2912 12.7425 10.5261L8.91483 14.3538ZM19.8398 14.1776L9.34012 14.1776V15.3805L19.8398 15.3805V14.1776Z"
        fill="black"
      />
    </svg>
  );
};
